'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var p = require('prop-types');
var _ = require('lodash');
var armCommon = require('arm-common');
var reactDom = require('react-dom');
var update = require('immutability-helper');
var jquery = require('jquery');
require('lodash/debounce');
var moment = require('moment');
var Datetime = require('react-datetime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var p__default = /*#__PURE__*/_interopDefaultLegacy(p);
var ___default = /*#__PURE__*/_interopDefaultLegacy(_);
var update__default = /*#__PURE__*/_interopDefaultLegacy(update);
var jquery__default = /*#__PURE__*/_interopDefaultLegacy(jquery);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);
var Datetime__default = /*#__PURE__*/_interopDefaultLegacy(Datetime);

var name = "arm-gui";
var version = "4.4.0";
var author = "Armundia Group";
var homepage = "http://www.armundia.com";
var main = "./dist/controls/index.js";
var license = "Armundia";
var files = [
	"dist"
];
var devDependencies = {
	"arm-common": "1.1.0",
	"arm-core-layouts": "0.11.2",
	"arm-gulp-builders": "^1.1.3",
	"arm-router": "1.3.0",
	"arm-themes": "^1.2.2-beta.0",
	"arm-visual-component": "2.2.1",
	"eslint-plugin-import": "^2.22.0",
	"eslint-plugin-react": "^7.20.3",
	react: "^17.0.2",
	"react-dom": "^17.0.2",
	"react-router-dom": "5.3.0",
	"react-redux": "^7.2.0",
	redux: "^4.0.5",
	"redux-thunk": "^2.3.0"
};
var peerDependencies = {
	"arm-common": ">=1.0.4 <2.0.0-0",
	"immutability-helper": ">=3.0.1 <4.0.0-0"
};
var dependencies = {
	jquery: "3.5.1",
	lodash: "4.17.21",
	"prop-types": "15.7.2",
	"react-datetime": "3.1.1"
};
var scripts = {
	watch: "gulp watch",
	beta: "npm version prerelease --preid=beta && gulp npm && npm publish --tag beta",
	patch: "npm version patch && gulp npm && npm publish",
	minor: "npm version minor && gulp npm && npm publish",
	major: "npm version major && gulp npm && npm publish",
	build: "gulp npm"
};
var publishConfig = {
	registry: "https://nexus.armundia.com/repository/npm-releases"
};
var pckg = {
	name: name,
	version: version,
	author: author,
	homepage: homepage,
	main: main,
	license: license,
	files: files,
	devDependencies: devDependencies,
	peerDependencies: peerDependencies,
	dependencies: dependencies,
	scripts: scripts,
	publishConfig: publishConfig
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var getI18N = function getI18N(code, def) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return armCommon.i18n.apply(void 0, ['V2.ARM_GUI.' + code, def].concat(args));
};
/**
 * @callback setState
 * @param {((state: object, props: object) => object|object)} changes object to update state
 * @param {(newState: object) => void} [cb] callback called post update
 * @returns {object} a shallow copy of updated state
 */

/**
 * Function that returns a setState function 'similar' of React.Component.setState function
 * 
 * @param {object} state functional component object state
 * @param {object} props functional component props
 * @param {React.Dispatch<React.SetStateAction<{}>>} updateState function that update the state
 * @returns {setState} setState function with state, props and updateStateFunction binded
 */


function setStateFunction(state, props, updateState) {
  return function (changes) {
    if (!state) return state;
    props = props || {};

    if (state && props && changes) {
      var newState = _objectSpread2({}, state);

      var isFunction = false;

      if (typeof changes === 'function') {
        changes = changes(state, props);
        isFunction = true;
      }

      for (var key in changes) {
        newState[key] = changes[key];
      }

      if (isFunction) {
        updateState(function () {
          return newState;
        });
      }

      updateState(newState);
      return newState;
    }

    return state;
  };
}
/**
 * @param {number} rem 
 * @returns {number} calculated pixel size
 */


function remToPixels(rem) {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}
/**
 * Object representing the default base components props
 */


var BaseProps = {
  propTypes: {
    className: p__default['default'].string,
    children: p__default['default'].node
  },
  defaultProps: {
    className: '',
    children: null
  }
};
/**
 * Children proptype helper creator
 * 
 * @param {(React.FC|React.Component|React.PureComponent)[]} components
 * @param {('shape'|'arrayOf'|'both')} [type] 
 * @returns shape, returns only the shape of components, arrayOf, returns only arrayOf shape components, both, returns both previous proptypes
 */

function childrenType(components) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'both';
  var shape = p__default['default'].shape({
    type: p__default['default'].oneOf(components)
  });

  switch (type) {
    case 'arrayOf':
      return p__default['default'].arrayOf(shape);

    case 'both':
      return p__default['default'].oneOfType([shape, p__default['default'].arrayOf(shape)]);

    default:
      return shape;
  }
}

var modalContainerPrefix = 'arm-gui-modal-container';
function ModalContainer(_ref) {
  var children = _ref.children;
  var container = document.getElementById(modalContainerPrefix);

  if (!container) {
    container = document.createElement('div');
    container.id = modalContainerPrefix;
    document.body.appendChild(container);
  }

  return /*#__PURE__*/reactDom.createPortal(children, container);
}
ModalContainer.propTypes = {
  children: p.node.isRequired
};

/**
 * @typedef {object} PopupDialogProps PopupDialog properties
 *
 * @prop {boolean} show hide/show the popup
 * @prop {React.CSSProperties} [style] Dom element style
 * @prop {string} [className] className component
 * @prop {(boolean|'transparent'|'default')} [addBackDrop] if true shows grey background glass
 * @prop {() => void} [onClose] shows the close button
 * @prop {Node} children popup content
 */

/**
 * @callback _PopupDialog component that shows a popup dialog
 * @param {PopupDialogProps} props
 * @returns {JSX.Element}
 */

/**
 * @typedef {object} PopupDialogSectionProps properties of PopupDialog.Header, PopupDialog.Body and PopupDialog.Footer  
 * @prop {string} [className] element className
 * @prop {Node} children section content 
 * @returns {JSX.Element}
 */
exports.typedefs = {};

var classNamePrefix = 'arm-gui-modal-back-drop';
function ModalBackDrop(_ref) {
  var _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === void 0 ? false : _ref$transparent,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 2005 : _ref$zIndex,
      onClick = _ref.onClick;
  var style = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: transparent ? 'transparent' : 'hsla(0, 0%, 66%, 0.5)',
    zIndex: zIndex
  };
  return /*#__PURE__*/React__default['default'].createElement("div", {
    style: style,
    onClick: onClick,
    className: classNamePrefix
  });
}
ModalBackDrop.propTypes = {
  transparent: p.bool,
  onClick: p.func,
  zIndex: p.number
};

var popupDialogPrefix = 'arm-gui-popup-dialog';
/** @type {_PopupDialog} */

function PopupDialog(props) {
  var show = props.show,
      style = props.style,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      title = props.title,
      _props$addBackDrop = props.addBackDrop,
      addBackDrop = _props$addBackDrop === void 0 ? false : _props$addBackDrop,
      onClose = props.onClose,
      children = props.children;
  if (title) console.error('[PopupDialog]: title prop is deprecated, use PopupDialog.Header component.');
  return /*#__PURE__*/React__default['default'].createElement(ModalContainer, null, show && addBackDrop && /*#__PURE__*/React__default['default'].createElement(ModalBackDrop, {
    onClick: onClose,
    transparent: addBackDrop === 'transparent'
  }), show && /*#__PURE__*/React__default['default'].createElement("div", {
    style: style,
    className: "".concat(popupDialogPrefix, " ").concat(className).trimEnd()
  }, /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, !addBackDrop && onClose && /*#__PURE__*/React__default['default'].createElement("button", {
    type: "button",
    className: "".concat(popupDialogPrefix, "-close"),
    onClick: onClose
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), children)));
}
PopupDialog.defaultProps = {
  show: false,
  className: '',
  addBackDrop: false,
  onClose: null,
  children: null
};
PopupDialog.propTypes = {
  show: p__default['default'].bool.isRequired,
  style: p__default['default'].object,
  className: p__default['default'].string,
  addBackDrop: p__default['default'].oneOf(['transparent', 'default', true, false]),
  onClose: p__default['default'].func,
  children: childrenType([PopupDialogHeader, PopupDialogBody, PopupDialogFooter])
};
/**
 * Header of PopupDialog
 * 
 * @param {PopupDialogSectionProps} props 
 * @returns {JSX.Element}
 */

function PopupDialogHeader(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      children = _ref.children;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(popupDialogPrefix, "-header ").concat(className).trimEnd()
  }, children);
}

PopupDialogHeader.defaultProps = BaseProps.defaultProps;
PopupDialogHeader.propTypes = BaseProps.propTypes;
/**
 * Body of PopupDialog
 * 
 * @param {PopupDialogSectionProps} props 
 * @returns {JSX.Element}
 */

function PopupDialogBody(_ref2) {
  var className = _ref2.className,
      children = _ref2.children;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(popupDialogPrefix, "-body ").concat(className).trimEnd()
  }, children);
}

PopupDialogBody.defaultProps = BaseProps.defaultProps;
PopupDialogBody.propTypes = BaseProps.propTypes;
/**
 * Footer of PopupDialog
 * 
 * @param {PopupDialogSectionProps} props 
 * @returns {JSX.Element}
 */

function PopupDialogFooter(_ref3) {
  var className = _ref3.className,
      children = _ref3.children;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(popupDialogPrefix, "-footer ").concat(className).trimEnd()
  }, children);
}

PopupDialogFooter.defaultProps = BaseProps.defaultProps;
PopupDialogFooter.propTypes = BaseProps.propTypes;
PopupDialog.Header = PopupDialogHeader;
PopupDialog.Body = PopupDialogBody;
PopupDialog.Footer = PopupDialogFooter;

/**
 * @typedef {object} AskConfirmOptions object required for AskConfirm `options` prop
 * @prop {string} [title] popup header
 * @prop {string} [message] message to show
 * @prop {boolean} [warning] is warning message
 * @prop {string} [yes] button confirm label
 * @prop {string} [yesIcon] button confirm icon
 * @prop {string} [no] button cancel label
 * @prop {string} [noIcon] button cancel icon
 */

/**
 * @typedef {object} AskConfirmProps AskConfirm properties
 * @prop {boolean} show hide/show the popup
 * @prop {() => void} onCancel needs to close the AskConfirm
 * @prop {() => void} onConfirm needs to execute something and close the AskConfirm
 * @prop {string|AskConfirmOptions} [options] if is string, it will shows the text in body, otherwise you can define all the textes of AskConfirm
 * @prop {Node} [children] when prop `show` is false, it shows the children
 */

/**
 * @callback _AskConfirm component uses to ask something before continue
 * @param {AskConfirmProps} props
 * @returns {JSX.Element}
 */
exports.typedefs = {};

var askConfirmPrefix = 'arm-gui-ask-confirm';
/** @type {_AskConfirm} */

function AskConfirm(props) {
  var show = props.show,
      children = props.children,
      _props$options = props.options,
      options = _props$options === void 0 ? {} : _props$options,
      onCancel = props.onCancel,
      onConfirm = props.onConfirm;
  if (!show) return children || null;
  var opts = {};
  if (typeof options === 'string') opts.message = options;else opts = options;
  var _opts = opts,
      title = _opts.title,
      message = _opts.message,
      warning = _opts.warning,
      noIcon = _opts.noIcon,
      no = _opts.no,
      yesIcon = _opts.yesIcon,
      yes = _opts.yes;
  var icon = warning ? "fas fa-exclamation-triangle" : "fas fa-info-circle";
  return /*#__PURE__*/React__default['default'].createElement(PopupDialog, {
    show: true,
    className: askConfirmPrefix,
    addBackDrop: true,
    onClose: onCancel
  }, /*#__PURE__*/React__default['default'].createElement(PopupDialog.Header, {
    className: "".concat(askConfirmPrefix, "-header")
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "".concat(icon, " ").concat(askConfirmPrefix, "-icon").concat(warning ? '-warn' : '')
  }), title || getI18N("ASK_CONFIRM.REQUEST_CONFIRM", "Richiesta conferma")), /*#__PURE__*/React__default['default'].createElement(PopupDialog.Body, {
    className: "".concat(askConfirmPrefix, "-body")
  }, message || getI18N("ASK_CONFIRM.CONTINUE", "Sicuro di voler continuare?")), /*#__PURE__*/React__default['default'].createElement(PopupDialog.Footer, {
    className: "".concat(askConfirmPrefix, "-footer")
  }, /*#__PURE__*/React__default['default'].createElement(aButton, {
    bs: "secondary",
    onClick: onCancel,
    icon: noIcon
  }, no || getI18N("ASK_CONFIRM.NO", "No")), /*#__PURE__*/React__default['default'].createElement(aButton, {
    bs: "default",
    onClick: onConfirm,
    icon: yesIcon
  }, yes || getI18N("ASK_CONFIRM.YES", "Si"))));
}
var optionsType = p.oneOfType([p.string, p.shape({
  title: p.string,
  message: p.string,
  warning: p.bool,
  yes: p.string,
  yesIcon: p.string,
  no: p.string,
  noIcon: p.string
})]);
AskConfirm.propTypes = {
  show: p.bool,
  options: optionsType,
  onCancel: p.func.isRequired,
  onConfirm: p.func.isRequired,
  children: p.node
};

/** @typedef {('default'|'primary'|'secondary')} aButtonStyle style type of button */

/**
 * @typedef {object} aButtonStyles
 * 
 * @prop {string} DEFAULT default style
 * @prop {string} PRIMARY primary style
 * @prop {string} SECONDARY secondary style
 */

/**
 * @typedef {object} aButtonProps aButton properties
 *
 * @prop {React.MutableRefObject|React.RefObject} btnRef to attach ref to button
 * @prop {string} [id] button id
 * @prop {string} [className] additional button selector
 * @prop {boolean} [disabled] disable the button
 * @prop {aButtonStyle} [bs] button style
 * @prop {string} [icon] icon css selector
 * @prop {boolean} [inline] display inline
 * @prop {boolean} [loading] shows a loader icon
 * @prop {boolean} [block] display block
 * @prop {('button'|'submit'|'reset')} [type] button type attribute see: {@link https://www.w3schools.com/tags/att_button_type.asp}
 * @prop {string} [href] href path
 * @prop {() => void} [onClick] button onclick event
 * @prop {(string|number)} [minWidth] css property
 * @prop {any} [eventParam] parameter passed as second argument when onClick event start
 * @prop {(string|AskConfirmOptions)} [askConfirm] activates AskConfirm popup and execute the events when click confirm
 * @prop {boolean} [compact] shows compact button
 * @prop {string} [children] button label
 */

/**
 * @callback _aButton component that renders a button.
 * @param {aButtonProps} props
 * @returns {JSX.Element}
 */

exports.typedefs = {};

var _excluded = ["btnRef"];
var aButtonStylesType = Object.freeze({
  DEFAULT: 'default',
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
});
/** @type {_aButton} */

function aButton(_ref) {
  var btnRef = _ref.btnRef,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showConfirm = _useState2[0],
      setShowConfirm = _useState2[1];

  var onShowConfirm = function onShowConfirm() {
    setShowConfirm(true);
  };

  var _onConfirm = function onConfirm(onOk) {
    setShowConfirm(false);

    if (onOk) {
      onOk();
    }
  };

  var onCancelConfirm = function onCancelConfirm() {
    setShowConfirm(false);
  };

  var visible = true;

  if (props.visible !== undefined && props.visible !== null) {
    visible = props.visible;
  }

  if (!visible) return null;
  var _props = props,
      children = _props.children,
      id = _props.id,
      disabled = _props.disabled,
      bs = _props.bs,
      icon = _props.icon,
      size = _props.size,
      inline = _props.inline,
      loading = _props.loading,
      large = _props.large,
      small = _props.small,
      block = _props.block,
      outline = _props.outline,
      type = _props.type,
      _props$className = _props.className,
      className = _props$className === void 0 ? '' : _props$className,
      href = _props.href,
      onClick = _props.onClick,
      eventParam = _props.eventParam,
      askConfirm = _props.askConfirm,
      compact = _props.compact;
  props = ___default['default'].omit(props, 'block', 'children', 'className', 'disabled', 'bs', 'icon', 'size', 'large', 'small', 'inline', "askConfirm", 'outline', 'loading', 'type', 'href', 'onClick', 'visible', 'eventParam', 'compact');
  loading = !!loading;

  if (!type) {
    type = "button";
  }

  var ticon = "";

  if (icon || loading) {
    var ic = icon;

    if (loading) {
      ic = "fa fa-spinner fa-pulse";
    }

    ticon = /*#__PURE__*/React__default['default'].createElement("i", {
      className: " arm-gui-btn-icon " + ic
    });
  }

  var clbtn = "arm-gui-btn ";

  if (disabled) {
    clbtn += "arm-gui-btn-disabled ";
  }

  if (loading) {
    clbtn += "btn-loading ";
  }

  if (compact) {
    clbtn += "btn-compact ";
  }

  var pre = " arm-gui-btn-";

  if (bs) {
    clbtn += pre + bs;
  } else {
    clbtn += " arm-gui-btn-default";
  }

  if (inline === false || block) clbtn += " btn-block";

  if (className) {
    clbtn = armCommon.Utils.union(clbtn, ' ', className);
  }

  if (eventParam && onClick) {
    var _onc = onClick;

    onClick = function onClick(e) {
      _onc(e, eventParam);
    };
  }

  if (!onClick && href) {
    onClick = function onClick() {
      document.location.href = "" + href;
    };
  }

  if (disabled || loading) onClick = null;
  var tAskConfirm = null;

  if (onClick !== null && askConfirm) {
    var origOnClick = onClick;
    tAskConfirm = /*#__PURE__*/React__default['default'].createElement(AskConfirm, {
      show: showConfirm,
      options: askConfirm,
      onConfirm: function onConfirm() {
        return _onConfirm(origOnClick);
      },
      onCancel: onCancelConfirm
    });
    onClick = onShowConfirm;
  }
  /** min-width */


  var btnStyle = {// minWidth: '6rem'
  };

  if (props.minWidth) {
    btnStyle.minWidth = props.minWidth;
  }

  var button = /*#__PURE__*/React__default['default'].createElement("button", _extends({
    ref: btnRef,
    id: id,
    className: clbtn,
    disabled: disabled,
    type: type
  }, props, {
    onClick: onClick,
    style: btnStyle
  }), ticon, ticon && children && /*#__PURE__*/React__default['default'].createElement("span", {
    className: "arm-gui-btn-divisor"
  }), children);
  if (!tAskConfirm) return button;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      display: "inline"
    }
  }, button, tAskConfirm);
}

var bsType = p__default['default'].oneOf(Object.values(aButtonStylesType));
aButton.propTypes = {
  id: p__default['default'].string,
  disabled: p__default['default'].bool,
  bs: bsType,
  icon: p__default['default'].string,
  inline: p__default['default'].bool,
  loading: p__default['default'].bool,
  block: p__default['default'].bool,
  outline: p__default['default'].bool,
  type: p__default['default'].oneOf(['button', 'submit', 'reset']),
  className: p__default['default'].string,
  href: p__default['default'].string,
  onClick: p__default['default'].func,
  minWidth: p__default['default'].oneOfType([p__default['default'].string, p__default['default'].number]),
  eventParam: p__default['default'].any,
  askConfirm: optionsType,
  compact: p__default['default'].bool,
  children: p__default['default'].oneOfType([p__default['default'].string, p__default['default'].number, p__default['default'].arrayOf(p__default['default'].oneOfType([p__default['default'].string, p__default['default'].number]))])
};
/** @type {Readonly<aButtonStyles>} styles of aButton */

aButton.STYLES = aButtonStylesType;

var classNamePrefix$1 = 'card';

function aCardDetailsHeader(props) {
  if (props.visible !== undefined && !!!props.visible) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: 'card-header text-left title element-list' + (props.className ? props.className : '') + (props.loading ? " loading-card-header" : "")
  }, props.loading && /*#__PURE__*/React.createElement("div", {
    className: "loading-header"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-spinner fa-pulse"
  })), props.children, /*#__PURE__*/React.createElement("div", {
    className: "cardHeaderButton pull-right",
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-bars",
    "aria-hidden": "true"
  })));
}

function aCardHeader(props) {
  if (props.visible !== undefined && !!!props.visible) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: 'card-header text-left title ' + (props.className ? props.className : '') + (props.loading ? " loading-card-header" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "title-header-align"
  }, props.loading && /*#__PURE__*/React.createElement("div", {
    className: "loading-header"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-spinner fa-pulse"
  })), props.children));
}

function aCardFilter(props) {
  if (props.visible !== undefined && !!!props.visible) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: 'card-filter ' + (props.className ? props.className : '') + (props.loading ? " loading-card-filter" : "")
  }, props.loading && /*#__PURE__*/React.createElement("div", {
    className: "loading-filter"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-spinner fa-pulse"
  })), props.title && /*#__PURE__*/React.createElement("h3", {
    className: "card-filter-title"
  }, props.title), props.children);
}

function aCardBody(props) {
  if (props.visible !== undefined && !!!props.visible) return null;
  return /*#__PURE__*/React.createElement("div", {
    title: props.title,
    className: 'card-block ' + (props.className ? props.className : ''),
    style: props.style
  }, /*#__PURE__*/React.createElement("div", {
    className: "loading-card",
    style: {
      display: props.loading ? 'block' : 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "spinner-balls"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bounce1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bounce2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bounce3"
  }))), props.children, " ");
}

function aCardFooter(props) {
  if (props.visible !== undefined && !!!props.visible) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: 'card-footer ' + (props.className ? props.className : '') + (props.loading ? " loading-card-footer" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "title-footer-align"
  }, props.loading && /*#__PURE__*/React.createElement("div", {
    className: "loading-footer"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-spinner fa-pulse"
  })), props.children));
}

function aCard(props) {
  var _props$visible = props.visible,
      visible = _props$visible === void 0 ? true : _props$visible,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      id = props.id,
      tableOn = props.tableOn,
      loading = props.loading,
      children = props.children;
  if (!visible) return null;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "".concat(classNamePrefix$1).concat(tableOn ? ' table-on' : '', " ").concat(className).trimEnd()
  }, /*#__PURE__*/React.createElement("div", {
    className: "loading-card",
    style: {
      display: loading ? 'block' : 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "spinner-balls"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bounce1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bounce2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bounce3"
  }))), children);
}

aCard.propTypes = {
  visible: p__default['default'].bool,
  className: p__default['default'].string,
  id: p__default['default'].string,
  tableOn: p__default['default'].bool,
  loading: p__default['default'].bool,
  children: p__default['default'].node
};

var aCardDetail = function aCardDetail(props) {
  var _useState = React.useState({
    open: props.defaultOpen || false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1]; // constructor(props) {
  //     super(props);
  //     state = {
  //         open: props.defaultOpen || false
  //     };
  //     toggle = toggle.bind(this);
  // }


  var toggle = function toggle() {
    setState({
      open: !state.open
    });
  }; // const toggle =()=> {
  //     setState(
  //         Object.assign(state, 
  //             { open: !state.open }));
  // }


  var open = state.open;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "acard-detail"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    onClick: toggle,
    className: "acard-detail-title"
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "arrow fa fa-caret-down" + (open ? " open" : "")
  }), props.title || "Dettagli", " ..."), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "acard-detail-body " + (open ? "open" : "close")
  }, props.children));
};

var classNamePrefix$2 = 'arm-gui-accordion';

function AccordionHeader(props) {
  var headerRef = props.headerRef,
      open = props.open,
      handleClick = props.handleClick,
      openIcon = props.openIcon,
      closeIcon = props.closeIcon,
      className = props.className,
      children = props.children;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    ref: headerRef,
    className: "".concat(classNamePrefix$2, "-header ").concat(className).trimEnd(),
    onClick: handleClick
  }, children, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "".concat(classNamePrefix$2, "-icon ").concat(open ? closeIcon : openIcon).trimEnd()
  }));
}

AccordionHeader.defaultProps = {
  openIcon: 'fas fa-plus',
  closeIcon: 'fas fa-minus',
  className: '',
  children: null
};
AccordionHeader.propTypes = {
  openIcon: p__default['default'].string,
  closeIcon: p__default['default'].string,
  className: p__default['default'].string,
  children: p__default['default'].node
};
/**
 * Attention Accordion has to have Header!!!
 */

function Accordion(props) {
  var marginBottom = props.marginBottom,
      _props$open = props.open,
      open = _props$open === void 0 ? false : _props$open,
      handleOpen = props.handleOpen,
      className = props.className,
      disabled = props.disabled,
      loading = props.loading,
      children = props.children;
  var accordionStyle = {};

  if (marginBottom) {
    accordionStyle["marginBottom"] = marginBottom;
  }

  var openAccordion = open;

  var handleClick = function handleClick() {
    return disabled || handleOpen();
  };

  if (!handleOpen) {
    var _useState = React.useState({
      open: open
    }),
        _useState2 = _slicedToArray(_useState, 2),
        state = _useState2[0],
        setState = _useState2[1];

    handleClick = function handleClick() {
      if (disabled) {
        return;
      }

      if (state.open) {
        setState({
          open: false
        });
      } else {
        setState({
          open: true
        });
      }
    };

    React.useEffect(function () {
      setState({
        open: open
      });
    }, [open]);
    openAccordion = state.open;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: 'arm-gui-accordion ' + (className ? className : '') + ' ' + (disabled ? "disabled" : ''),
    style: accordionStyle
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "loading-card",
    style: {
      display: loading ? 'flex' : 'none'
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "spinner-balls"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "bounce1"
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "bounce2"
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "bounce3"
  }))), React__default['default'].Children.map(children, function (child, index) {
    if (child && child.type && child.type.toString() === AccordionHeader.toString()) {
      return /*#__PURE__*/React__default['default'].cloneElement(child, {
        open: openAccordion,
        handleClick: handleClick
      });
    } else if (openAccordion) {
      return child;
    } else {
      return null;
    }
  }));
}

var hasHeader = function hasHeader(propValue, key, componentName, location, propFullName) {
  if (!propValue || !Array.isArray(propValue)) {
    return new Error("To ".concat(componentName, " should be passed an array of Elements"));
  }

  var header = false;
  propValue.forEach(function (child) {
    if (child && child.type && child.type.toString() === AccordionHeader.toString()) {
      header = true;
    }
  });

  if (!header) {
    return new Error("".concat(componentName, " should have an Element ").concat(AccordionHeader.name, " to work"));
  }
};

Accordion.propTypes = {
  open: p__default['default'].bool,
  handleOpen: p__default['default'].func,
  marginBottom: p__default['default'].string,
  className: p__default['default'].string,
  disabled: p__default['default'].bool,
  loading: p__default['default'].bool,
  children: p__default['default'].arrayOf(hasHeader)
};

function AccordionBody(props) {
  var className = props.className,
      children = props.children;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "arm-gui-accordion-body " + (className ? className : "")
  }, children);
}

AccordionBody.propTypes = {
  className: p__default['default'].string,
  children: p__default['default'].node
};

var AccordionFooter = function AccordionFooter(props) {
  var className = props.className,
      children = props.children;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "arm-gui-accordion-footer " + (className ? className : "")
  }, children);
};

AccordionFooter.propTypes = {
  className: p__default['default'].string,
  children: p__default['default'].node
};
Accordion.Header = AccordionHeader;
Accordion.Body = AccordionBody;
Accordion.Footer = AccordionFooter;

var MAX_VIEWED_PAGE = 8;
/**
 * aTable
 * 
*/

var aPaginator = /*#__PURE__*/function (_Component) {
  _inherits(aPaginator, _Component);

  var _super = _createSuper(aPaginator);

  function aPaginator(props) {
    var _this;

    _classCallCheck(this, aPaginator);

    _this = _super.call(this, props);
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.state = {
      id: props.id | armCommon.Utils.uuid('APG')
    };
    return _this;
  }

  _createClass(aPaginator, [{
    key: "handleClick",
    value: function handleClick(e, page) {
      e.preventDefault();
      var event = Object.assign({}, e);
      event.target = this;
      event.page = page; // console.log("[aPaginator] selected page", page);

      if (this.props.onPageChange) this.props.onPageChange(event);
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {}
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      console.debug("aPaginator", this.props);
      var pid = this.state.id;
      var usePage = this.props.pageSize > 0 && this.props.pageCount > 1; // generate pages based on props

      var pages = [];
      var pageCount = this.props.pageCount;
      var page = this.props.page;
      var startPage = 1;
      var endPage = this.props.pageCount;
      var prevPage = null;
      var nextPage = null;
      var prevMore = null;
      var nextMore = null;

      if (usePage) {
        var maxPage = MAX_VIEWED_PAGE; // calc based on resolution width?

        if (pageCount > maxPage) {
          var half = Math.round(maxPage / 2);
          startPage = Math.max(1, page - half);
          endPage = Math.min(pageCount, page + half);

          if (endPage - startPage < maxPage) {
            if (startPage === 1) {
              endPage = maxPage + 1;
            } else if (endPage === pageCount) {
              startPage = endPage - maxPage - 1;
            }
          }

          prevMore = startPage - maxPage - half;
          if (prevMore < 1) prevMore = 1;
          nextMore = startPage + maxPage + half;
          if (nextMore > pageCount) nextMore = pageCount;
        }

        for (var p = startPage; p <= endPage; p++) {
          var pg = {};
          pg.num = p;
          pg.isCurrent = p === page;
          if (p === page - 1) prevPage = pg;
          if (p === page + 1) nextPage = pg;
          pages.push(pg);
        }
      }

      var prevMorePage = prevMore ? {
        num: prevMore
      } : null;
      var nextMorePage = nextMore ? {
        num: nextMore
      } : null; // console.warn("prev/next more page", pages, prevMorePage, nextMorePage);

      var itemName = this.props.count === 1 ? this.props.itemName : this.props.itemsName;
      return /*#__PURE__*/React__default['default'].createElement("nav", {
        className: "aPaginator clearfix",
        "aria-label": "Page navigation"
      }, /*#__PURE__*/React__default['default'].createElement("p", {
        className: "description"
      }, usePage && /*#__PURE__*/React__default['default'].createElement("span", {
        className: "descr-pages"
      }, "pagina ", page, " di ", pageCount), usePage && /*#__PURE__*/React__default['default'].createElement("span", {
        className: "descr-sep"
      }, " - "), /*#__PURE__*/React__default['default'].createElement("span", {
        className: "descr-counts"
      }, this.props.count, " ", itemName)), usePage && /*#__PURE__*/React__default['default'].createElement("ul", {
        className: armCommon.Utils.union("pagination", " ", this.props.className)
      }, this.buildPage(pid, prevMorePage, /*#__PURE__*/React__default['default'].createElement("span", null, "<<"), "page-more", "prevmore"), this.buildPage(pid, prevPage, /*#__PURE__*/React__default['default'].createElement("span", null, "<"), "page-more", "prev"), pages.map(function (page) {
        return _this2.buildPage(pid, page);
      }), this.buildPage(pid, nextPage, /*#__PURE__*/React__default['default'].createElement("span", null, ">"), "page-more", "next"), this.buildPage(pid, nextMorePage, /*#__PURE__*/React__default['default'].createElement("span", null, ">>"), "page-more", "nextmore")));
    }
  }, {
    key: "buildPage",
    value: function buildPage(pid, page, symbol, cssClass, postid) {
      var _this3 = this;

      if (!page) page = {
        num: armCommon.Utils.uuid(),
        isDisabled: true
      };
      var className = "page-item";

      if (page.isCurrent) {
        className = "page-item active";
      } else if (page.isDisabled) {
        className = "page-item disabled";
      }

      if (cssClass) className += " " + cssClass;
      var id = pid + "__" + page.num + "__" + postid;
      var sym = symbol || page.num;
      var title = page.isDisabled ? null : "Pagina #" + page.num;
      return /*#__PURE__*/React__default['default'].createElement("li", {
        key: id,
        "data-page-num": page.num,
        className: className
      }, page.isDisabled ? /*#__PURE__*/React__default['default'].createElement("span", {
        className: "page-link",
        title: title
      }, sym) : /*#__PURE__*/React__default['default'].createElement("a", {
        href: "javascript:;",
        className: "page-link",
        title: title,
        onClick: function onClick(e) {
          return _this3.handleClick(e, page.num);
        }
      }, sym));
    }
  }]);

  return aPaginator;
}(React.Component);

_defineProperty(aPaginator, "propTypes", {
  itemName: p__default['default'].string,
  itemsName: p__default['default'].string,
  count: p__default['default'].number,
  pageSize: p__default['default'].number,
  pageCount: p__default['default'].number,
  page: p__default['default'].number,
  onPageChange: p__default['default'].func
});

function unitsToFloat(val, defVal) {
  if (val === undefined || val === null) return defVal || null; //Se fosse una stringa, vuol dire che possiede un unità

  if (typeof val === "string") {
    val = setUnit(val);
    return parseFloat(val.substring(0, val.length - unit.length));
  }

  if (!isNaN(val)) return val;
  return defVal || null;
}

var unit = null;
/**
 * Setta la variabile globale con l'unità css trovata nella stringa
 * @param {*} numberWithUnit 
 */

function setUnit(numberWithUnit) {
  if (numberWithUnit.endsWith("px")) {
    unit = "px";
  } else if (numberWithUnit.endsWith("%")) {
    unit = "%";
  } else if (numberWithUnit.endsWith("em")) {
    unit = "em";
  } else if (numberWithUnit.endsWith("rem")) {
    unit = "rem";
  } else if (numberWithUnit.endsWith("vw")) {
    unit = "vw";
  } else if (numberWithUnit.endsWith("vh")) {
    unit = "vh";
  } else {
    unit = "px";
    numberWithUnit += unit;
  }

  return numberWithUnit;
}

var SCROLLBAR_WIDTH = null;

function _getScrollbarWidth() {
  if (SCROLLBAR_WIDTH) return SCROLLBAR_WIDTH;
  var outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.width = "100px";
  outer.style.height = "100px";
  outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

  document.body.appendChild(outer);
  var widthNoScroll = outer.offsetWidth; // force scrollbars

  outer.style.overflow = "scroll"; // add innerdiv

  var inner = document.createElement("div");
  inner.style.height = "200px";
  outer.appendChild(inner);
  var widthWithScroll = inner.offsetWidth; // remove divs

  outer.parentNode.removeChild(outer);
  SCROLLBAR_WIDTH = widthNoScroll - widthWithScroll;
  return SCROLLBAR_WIDTH;
}
/**
 * aTable
 * 
*/


var aTable = /*#__PURE__*/function (_Component) {
  _inherits(aTable, _Component);

  var _super = _createSuper(aTable);

  function aTable(props) {
    var _this;

    _classCallCheck(this, aTable);

    _this = _super.call(this, props);
    _this.sortIcon = _this.sortIcon.bind(_assertThisInitialized(_this));
    _this.sortClass = _this.sortClass.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(aTable, [{
    key: "sortClass",
    value: function sortClass(col) {
      if (!col || !col.sortable) return "";
      if (this.props === null) return "text-danger";
      if (this.props.sort === null || this.props.sort.activeSort === null) return "";
      if (this.props.sort.activeSort.name !== col.name) return "";
      return "active";
    }
  }, {
    key: "sortIcon",
    value: function sortIcon(col) {
      if (!col || !col.sortable) return "";
      if (this.props === null) return "fa fa-exclamation-triangle";
      if (this.props.sort === null || this.props.sort.activeSort === null) return "fa fa-sort text-default";
      if (this.props.sort.activeSort.name !== col.name) return "fa fa-sort text-default"; // equals

      if (this.props.sort.activeSort.asc) return "fa fa-sort-asc";else return "fa fa-sort-desc";
    }
  }, {
    key: "rowClickHandler",
    value: function rowClickHandler(row, event) {
      if (this.props.onRowClick) this.props.onRowClick(row);
    }
  }, {
    key: "_calcWidth",
    value: function _calcWidth(col, index, firstIndex, lastIndex) {
      if (!col.width) return;
      var w = unitsToFloat(col.width) || 100; // TODO error?

      var d = _getScrollbarWidth();
    }
  }, {
    key: "_calcStyle",
    value: function _calcStyle(col, isTh) {
      var style = {};
      if (!col.width) return style;
      var pl = col._leftSpace || 0;
      var pr = 0;

      if (isTh) {
        pr = col._thRightSpace || 0;
      } else {
        pr = col._rightSpace || 0;
      }

      if (col.padding === undefined) {
        style.paddingLeft = "" + pl + "px";
        style.paddingRight = "" + pr + "px";
      } else {
        style.paddingLeft = col.padding;
        style.paddingRight = col.padding;
      }

      if (col._left !== undefined) {
        style.left = "" + col._left + "px";
      }

      if (col._right !== undefined) {
        style.right = "" + col._right + "px";
      }

      if (col._borderLeft !== undefined) {
        style.borderLeft = "1px solid #ddd";
      }

      if (col._borderRight !== undefined) {
        style.borderRight = "1px solid #ddd";
      }

      if (col.width) {
        var w = unitsToFloat(col.width);
        if (pl) w += pl;
        if (pr && !_typeof(col.width) === "string") w += pr; //Setto come default px

        style.minWidth = w + "px";
        style.width = w + "px";
        style.maxWidth = w + "px"; // maxWidth: col.width 
        //Se la grandezza è di tipo stringa, affianco al numero la stringa unit (settata in precedenza)

        if (typeof col.width === "string") {
          style.minWidth = w + unit;
          style.width = w + unit;
          style.maxWidth = w + unit;
        }
      }

      return style;
    }
  }, {
    key: "_prepareColumns",
    value: function _prepareColumns(def) {
      var SCROLLBAR_WIDTH = _getScrollbarWidth();

      var W_SPACE = 8;
      var fixedCols = this.props.fixedCols; // preleva l'indice della l'ultima colonna
      // visibile e non fissa

      var lastColNotFixedIndex = def.length - 1 - (fixedCols ? fixedCols.last : 0);
      var firstColNotFixedIndex = fixedCols ? fixedCols.first : 0;
      var f = 0;
      var l = 0;

      if (fixedCols) {
        // prepare on fixedCols options
        var inErr = false;
        f = fixedCols.first || 0;
        l = fixedCols.last || 0;

        if (f && f >= def.length) {
          f = null;
          inErr = true;
        }

        if (l && l >= def.length) {
          l = null;
          inErr = true;
        }

        if (!inErr && f && l) {
          if (f + l >= def.length) {
            inErr = true;
          }
        }

        if (f < 0 || l < 0) inErr = true;

        if (inErr) {
          console.error("fixeCols skipped by definition errors. Please fix -- fixedCols: ", fixedCols); // throw new Error("fixeCols skipped by definition errors. Please fix");

          return;
        }

        if (f > 0) {
          var w = 0;

          for (var i = 0; i < f; i++) {
            var c = def[i];

            if (!c.width) {
              break;
            }

            c._fixed = true;
            c._fixedLeft = true;
            c._left = w;
            w += unitsToFloat(c.width) || 1;
          }

          def[f - 1]._borderRight = true;
          def[f]._leftSpace = w + 2; // fixed = true;
        }

        if (l > 0) {
          var _w = 0;

          for (var _i = def.length - 1; _i >= def.length - l; _i--) {
            var _c = def[_i];

            if (!_c.width) {
              // console.error("fixed column without width", c);
              break;
            }

            _c._fixed = true;
            _c._fixedRight = true;
            _c._right = _w;
            _w += unitsToFloat(_c.width) || 1;
          }

          def[def.length - l]._borderLeft = true;
          def[def.length - l - 1]._rightSpace = _w + SCROLLBAR_WIDTH;
          def[def.length - l - 1]._thRightSpace = _w + W_SPACE + SCROLLBAR_WIDTH;
          def[def.length - 1]._thRightSpace = SCROLLBAR_WIDTH;
        } else {
          def[def.length - 1]._rightSpace = l + SCROLLBAR_WIDTH;
          def[def.length - 1]._thRightSpace = W_SPACE + SCROLLBAR_WIDTH + SCROLLBAR_WIDTH;
        }
      } else {
        def[def.length - 1]._rightSpace = W_SPACE + SCROLLBAR_WIDTH;
        def[def.length - 1]._thRightSpace = W_SPACE + SCROLLBAR_WIDTH + SCROLLBAR_WIDTH;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // console.log("[aTable] render");
      var self = this;
      var data = this.props.data;

      if (!data) {
        // console.warn("no data?!?!?");
        data = [];
      }

      if (!this.props.def) {
        throw new Error("[aDataGrid/aTable] NO DEFINITION COLUMNS");
      }

      var def = [];
      this.props.def.map(function (col, index) {
        if (col.visible === false) return;
        col._index = index;
        def.push(col);
      });
      var fixed = !!this.props.fixed;
      var compact = this.props.compact;
      var clz;
      clz = " " + armCommon.Utils.union('aTable table', ' ', this.props.className) + " ";
      clz += fixed ? " fixedTable " : "";
      clz += compact ? " compact " : "";
      if (clz.indexOf(" fixedTable ") > 0) fixed = true;
      var fixedCols = this.props.fixedCols;
      var lastColNotFixedIndex = def.length - 1 - (fixedCols ? fixedCols.last : 0);
      var firstColNotFixedIndex = fixedCols ? fixedCols.first : 0;
      var validColNum = def.length;

      this._prepareColumns(def, fixed);

      var tbAddClz = this.props.onRowClick ? ' clickable-row table-hover' : '';
      clz += tbAddClz;
      var tbodyStyle = null;

      if (this.props.tbodyHeight) {
        tbodyStyle = {
          height: this.props.tbodyHeight
        };
      }

      var sbw = _getScrollbarWidth();

      var isIE = armCommon.UiUtils.detectIE() > 0;
      return /*#__PURE__*/React__default['default'].createElement("table", {
        id: this.props.id,
        className: clz
      }, /*#__PURE__*/React__default['default'].createElement("thead", null, /*#__PURE__*/React__default['default'].createElement("tr", null, def.map(function (col, colIndex) {
        var thStyle = _this2._calcStyle(col, true);

        var thClz = col.thClassName ? col.thClassName : col.className ? col.className : '';

        if (col._fixed) {
          thClz += " col-fixed";

          if (col._fixedLeft) {
            thClz += " col-fixed-left";
          }

          if (col._fixedRight) {
            thClz += " col-fixed-right";
          }
        }

        return /*#__PURE__*/React__default['default'].createElement("th", {
          key: "th_" + col.name + "_" + colIndex,
          className: thClz,
          style: thStyle,
          "data-left": thStyle.left,
          "data-is-header": true
        }, col.sortable && /*#__PURE__*/React__default['default'].createElement("a", {
          href: "javascript:;",
          className: _this2.sortClass(col),
          onClick: function onClick(e) {
            _this2.props.onChangeSort(col.name);
          }
        }, col.label, ' ', /*#__PURE__*/React__default['default'].createElement("i", {
          className: _this2.sortIcon(col)
        })), !col.sortable && col.label);
      }, this))), /*#__PURE__*/React__default['default'].createElement("tbody", {
        style: tbodyStyle
      }, data.map(function (item, index) {
        if (self.props.rowVisibleOn) {
          if (!self.props.rowVisibleOn(item, index)) {
            // console.debug("row hidden by rowVisibleOn", item, index);
            return null;
          }
        }

        var rowCssClass = index % 2 === 0 ? "even e1" : "odd o1";
        if (_this2.props.rowCssClass) rowCssClass += " " + _this2.props.rowCssClass;

        if (_this2.props.rowCssClassCalculate) {
          var calcRowCssClass = _this2.props.rowCssClassCalculate(item, index); // console.debug("row css calc", calcRowCssClass);


          if (calcRowCssClass) rowCssClass += " " + calcRowCssClass;
        }

        var baseRow = def.map(function (col, colIndex) {
          var tabIndex = undefined;

          if (self.props.useTabIndex) {
            var zeroFill = isIE ? 3 : 6;
            tabIndex = "" + (colIndex + 1) + armCommon.UiUtils.zeroFill(index, zeroFill);
          }

          var tdClz = col.className ? col.className : '';

          if (col._fixed) {
            tdClz += " col-fixed";

            if (col._fixedLeft) {
              tdClz += " col-fixed-left";
            }

            if (col._fixedRight) {
              tdClz += " col-fixed-right";
            }
          }

          var tdStyle = _this2._calcStyle(col, false);

          return /*#__PURE__*/React__default['default'].createElement("td", {
            key: "td_" + col.name + "_" + colIndex,
            className: tdClz,
            "data-left": tdStyle.left,
            "data-offset": sbw,
            "data-toggle": col.openDetails ? 'collapse' : null,
            "data-target": col.openDetails ? '#' + self.props.id + '_detail_' + index : '',
            style: tdStyle
          }, _this2.renderVal(col, item, index, tabIndex));
        }, _this2);

        var detRender = _this2.renderDetail(_this2.props.detailsRenderer, item, index);

        if (detRender) {
          return [/*#__PURE__*/React__default['default'].createElement("tr", {
            key: "tr_" + index,
            onClick: _this2.rowClickHandler.bind(_this2, item),
            className: "accordion-toggle " + rowCssClass
          }, baseRow), /*#__PURE__*/React__default['default'].createElement("tr", {
            key: "tr_detail" + index,
            className: "detailsRow"
          }, /*#__PURE__*/React__default['default'].createElement("td", {
            colSpan: validColNum,
            className: "hiddentablerow"
          }, /*#__PURE__*/React__default['default'].createElement("div", {
            id: self.props.id + '_detail_' + index,
            className: "accordian-body collapse"
          }, detRender)))];
        } else {
          return /*#__PURE__*/React__default['default'].createElement("tr", {
            key: "tr_" + index,
            onClick: _this2.rowClickHandler.bind(_this2, item),
            className: rowCssClass
          }, baseRow);
        }
      }, this)));
    }
  }, {
    key: "renderDetail",
    value: function renderDetail(detailsRenderer, item, index) {
      if (detailsRenderer) {
        return detailsRenderer(item, index);
      } else {
        return null;
      }
    }
  }, {
    key: "renderVal",
    value: function renderVal(col, item, index, tabIndex) {
      try {
        var val = aTable.getVal(col, item);

        if (col.formatter) {
          var newval = col.formatter(val, col, item, index);
          val = newval;
        }

        if (col.renderer) {
          var rd = col.renderer(val, col, item, index, tabIndex);
          if (rd === null) return "";
          return rd;
        }

        if (val === null || val === undefined) val = "";
        return val.toString();
      } catch (error) {
        console.error(error);
        return " error ";
      }
    }
  }], [{
    key: "getVal",
    value: function getVal(col, item) {
      if (item === null || item === undefined) return null;
      if (!col || !col.fieldPath) return null;
      return armCommon.Utils.getVal(col.fieldPath, item);
    }
  }]);

  return aTable;
}(React.Component);

_defineProperty(aTable, "propTypes", {
  id: p__default['default'].string,
  def: p__default['default'].arrayOf(p__default['default'].object),
  data: p__default['default'].arrayOf(p__default['default'].object),
  detailsRenderer: p__default['default'].func,
  onChangeSort: p__default['default'].func,
  onRowClick: p__default['default'].func,
  itemComponent: p__default['default'].node,
  // not used for table
  rowCssClassCalculate: p__default['default'].func
});

var DEFAULT_PAGE_SIZE = 10;
var DEFS = {
  NO_ELEMS: null
};

function pixelToInt(val, defVal) {
  if (val === undefined || val === null) return defVal || null;

  if (typeof val === "string") {
    if (val.endsWith("px")) val = val.substring(0, val.length - 2);
    return parseInt(val);
  }

  if (!isNaN(val)) return val;
  return defVal || null;
}
/*
class GridDef {
    static propTypes = {
        name: t.string, // es. city
        label: t.string, // es. città
        fieldPath: t.string // es. address.city
    }
}
*/

/**
 * aDataGrid - handle loading, view and pageing of an array of object data.
 * 
 * @author G. Annunziata
*/


var aDataGrid = /*#__PURE__*/function (_PureComponent) {
  _inherits(aDataGrid, _PureComponent);

  var _super = _createSuper(aDataGrid);

  function aDataGrid(props) {
    var _this;

    _classCallCheck(this, aDataGrid);

    _this = _super.call(this, props);
    _this.state = _this.initialState(props);
    _this.pageHandler = _this.pageHandler.bind(_assertThisInitialized(_this));
    _this.onChangeSort = _this.onChangeSort.bind(_assertThisInitialized(_this));
    _this.rowClickHandler = _this.rowClickHandler.bind(_assertThisInitialized(_this));
    _this.treePrepare = _this.treePrepare.bind(_assertThisInitialized(_this));
    _this.treeRowVisible = _this.treeRowVisible.bind(_assertThisInitialized(_this));
    _this.treeChangeOpen = _this.treeChangeOpen.bind(_assertThisInitialized(_this));
    _this._patchScrollBar = _this._patchScrollBar.bind(_assertThisInitialized(_this));
    _this._applyScrollWidth = _this._applyScrollWidth.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(aDataGrid, [{
    key: "initialState",
    value: function initialState(props) {
      return {
        id: this.props.id || armCommon.Utils.uuid("adg"),
        data: [],
        pageSize: DEFAULT_PAGE_SIZE,
        page: 1,
        count: 0,
        pageCount: 1,
        currentPage: null,
        selTree: props.useTree ? {} : null
      };
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {

      var state = Object.assign({}, this.state); // state.id = this.props.id || Utils.uuid("DG");

      state.data = this.props.data || [];
      state.count = this.props.data ? this.props.data.length : 0;
      state.pageSize = this.props.pageSize;
      state.page = this.props.page;
      state.sort = this.buildSort(this.props.def);
      state.rowId = this.props.rowId;
      this.internUpdateOnState(state, true);
      this.setState(state, function () {// after set state
        // if (self.props.useTree)
        //      self.treePrepare(seòf.state.data);
      });
    }
  }, {
    key: "buildSort",
    value: function buildSort(def) {
      var res = {
        activeSort: null,
        availSort: []
      };
      if (this.props.useTree) return res;

      for (var i = 0; i < def.length; i++) {
        var d = def[i];
        if (!d.sortable) continue;
        var sortdef = {};
        sortdef.name = d.name;
        sortdef.field = d;
        sortdef.comparator = d.comparator || aDataGrid.builtinComparator;
        res.availSort.push(sortdef);

        if (d.activeSort) {
          res.activeSort = sortdef;
          res.activeSort.asc = d.activeSort === 'asc' ? true : false;
        }
      }

      return res;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var self = this;

      self._patchScrollBar(); //console.warn("adatagrid didmount");

    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._patchScrollBar();
    }
  }, {
    key: "_patchScrollBar",
    value: function _patchScrollBar() {
      var self = this; // setTimeout(function () {

      self._applyScrollWidth(self); // $("#" + self.state.id + "__grid").on('scroll', _.debounce(function () {
      //     self._applyScrollWidth(self);
      // }, 1));


      jquery__default['default']("#" + self.state.id + "__grid").scroll(function () {
        self._applyScrollWidth(self);
      }); // }, 3);
    }
  }, {
    key: "_applyScrollWidth",
    value: function _applyScrollWidth(self) {
      var sl = jquery__default['default']("#" + self.state.id + "__grid").scrollLeft();
      var w = jquery__default['default']("#" + self.state.id + "__grid").width();
      var ts = w / 10;

      var newWidth = w + sl;
      jquery__default['default']("#" + self.state.id + "__grid > *").width(newWidth);
      jquery__default['default']("#" + self.state.id + "__grid .col-fixed-left").each(function () {
        var row = jquery__default['default'](this);
        var l = row.attr("data-left");
        if (l === undefined) return;
        l = pixelToInt(l);

        if (l !== null) {
          if (sl > ts) {
            var _sbw = 6; // parseInt(row.attr("data-offset"));

            l -= _sbw; //parseInt(sbw);
          }

          row.css("left", l + sl + "px");
        }
      }); //console.debug("aDataGrid _applyScrollWidth", newWidth, sl);
    }
    /**
     * private.
     * assume if not null, a and b are the same type.
     * @param {*} a 
     * @param {*} b 
     */

  }, {
    key: "treePrepare",
    value: // TREE HANDLING =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function treePrepare(data, state) {
      var self = this;
      if (!self.props.useTree) return null;
      if (!data) data = state.data || this.state.data; //console.warn("treePrepare()", data);

      var selTree = {}; // _.clone(this.state.selTree) || {};

      var treeIds = {};
      data.map(function (row, index) {
        var tt = row._tree;
        if (!tt) return null;
        treeIds[tt.id] = tt.parentId || null;
        if (!tt.hasknot) return null;

        if (self.props.treeOpened === undefined) {
          selTree[tt.id] = true;
        } else {
          if (self.props.treeOpened) {
            selTree[tt.id] = true;
          } else {
            if (tt.level === 0) {
              /* il livello zero non lo impostiamo come chiuso altrimenti l albero sarebbe formato da una sola riga
                  TODO: inserire una opzione in caso di necessita */
              selTree[tt.id] = true;
            } else {
              selTree[tt.id] = false;
            }
          }
        }
      }, this);
      var doSet = true;

      if (!state) {
        state = this.state;
      } else {
        doSet = false;
      }

      state.selTree = selTree;
      state.treeIds = treeIds;
      if (doSet) this.setState(state);
      return selTree;
    }
  }, {
    key: "treeRowVisible",
    value: function treeRowVisible(row) {
      var tt = row._tree;
      if (!tt) return true;
      if (!tt.parentId) return true;

      var res = this._treeRowVisible(tt.parentId, row); // if (!res) {
      //     console.warn("row non visibile",
      //         row,
      //         tt,
      //         this.state.selTree,
      //         this.state.treeIds);
      // }


      return res;
    }
  }, {
    key: "_treeRowVisible",
    value: function _treeRowVisible(parentId, row) {
      if (this.state.selTree[parentId] === undefined) {
        // console.warn("row non preparata", row);
        return false;
      }

      var val = this.state.selTree[parentId];

      if (!val) {
        return false;
      }

      parentId = this.state.treeIds[parentId];
      if (parentId === null || parentId === undefined) return true;
      return this._treeRowVisible(parentId, row);
    }
  }, {
    key: "treeOpened",
    value: function treeOpened(row) {
      var tt = row._tree;
      if (!tt) return true;
      return !!this.state.selTree[tt.id];
    }
  }, {
    key: "treeChangeOpen",
    value: function treeChangeOpen(col, row, index) {
      var tt = row._tree;
      if (!tt) return;
      var val = !this.treeOpened(row);
      this.setState(update__default['default'](this.state, {
        selTree: _defineProperty({}, tt.id, {
          $set: val
        })
      }));
    } // =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-

  }, {
    key: "onChangeSort",
    value: function onChangeSort(name) {
      //console.log("[aDataGrid] sort by name:", name);
      var sort = this.state.sort;

      if (this.changeSort(name, sort)) {
        //NUOVO CODICE: INSERISCO UN FORCE UPDATE PER FAR CHIAMARE NUOVAMENTE LA RENDER AL CAMBIO STATO
        //console.log("[aDataGrid] makeSort end. Change state.");
        var state = Object.assign({}, this.state, {
          sort: sort
        });
        this.internUpdateOnState(state, true);
        this.setState(state);
        this.forceUpdate(); //VECCHIO CODICE CHE NON CHIAMAVA LA RENDER!
        // console.log("[aDataGrid] changeSort...");
        // let newdata = this.makeSort(this.state.data, sort);
        // if (newdata) {
        //     console.log("[aDataGrid] makeSort end. Change state.");
        //     let state = Object.assign({}, this.state, { data: newdata, sort: sort });
        //     this.internUpdateOnState(state, true);
        //     this.setState(state);
        // }
      }
    }
  }, {
    key: "changeSort",
    value: function changeSort(name, sort) {
      if (!name) {
        //console.log("name null");
        return false;
      } // tree cannot handle sort


      if (this.props.useTree) return false; //console.log("change sort:", sort, " - name:", name);

      var newSort = null;

      for (var i = 0; i < sort.availSort.length; i++) {
        var asrt = sort.availSort[i];

        if (asrt.name === name) {
          // found
          newSort = asrt;
          break;
        }
      }

      if (newSort === null) {
        //console.log("change sort - not found on avail sort");
        return false;
      }

      if (sort.activeSort !== null && sort.activeSort.name === newSort.name) {
        sort.activeSort.asc = !sort.activeSort.asc;
      } else {
        sort.activeSort = Object.assign({
          asc: true
        }, newSort); //console.log("change activeSort", sort.activeSort);
      }

      return true;
    }
  }, {
    key: "makeSort",
    value: function makeSort(data, sort) {
      var _this2 = this;

      if (sort === null || sort.activeSort === null) return null;

      if (sort.activeSort.comparator === null) {
        throw new Error("active sort without comparator function");
      }

      var newdata = data.sort(function (itemA, itemB) {
        var a, b;
        a = aDataGrid.getVal(sort.activeSort.field, itemA);
        b = aDataGrid.getVal(sort.activeSort.field, itemB);

        if (sort.activeSort.asc) {
          return sort.activeSort.comparator(a, b, itemA, itemB, _this2.props.retrieveRowId);
        } else {
          return sort.activeSort.comparator(b, a, itemB, itemA, _this2.props.retrieveRowId);
        }
      });
      return newdata;
    }
  }, {
    key: "rowClickHandler",
    value: function rowClickHandler(row) {
      // console.log("row clicked");
      if (this.props.onRowClick) {
        this.props.onRowClick(row);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(props) {
      var self = this; // copy from current (initial) state

      if (self.state.data === props.data) ; else {
        //console.debug("adatagrid - change props with CHANGE data", self.state.data, props.data);
        var state = update__default['default'](this.state, {
          data: {
            $set: props.data || []
          },
          count: {
            $set: props.data ? props.data.length : 0
          }
        });
        this.internUpdateOnState(state, true);
        this.setState(state);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var self = this;
      var tbodyHeight = this.props.tbodyHeight;
      var AGrid = this.props.gridComponent || aTable;
      var AItem = this.props.itemComponent || null;
      var APaginator = aPaginator; //console.log("[aDataGrid] render", this.state, this.props);

      var noElems = this.props.noItemsLabel || DEFS.NO_ELEMS;
      var noDataComp = null;

      if (this.props.children) {
        noDataComp = /*#__PURE__*/React__default['default'].createElement("div", null, this.props.children);
      } else {
        noDataComp = noElems ? /*#__PURE__*/React__default['default'].createElement("p", null, noElems) : /*#__PURE__*/React__default['default'].createElement("p", null, armCommon.i18n("V2.AGUI.ADATAGRID.NO_ELEM.NO", "Nessun"), ' ', this.props.itemName, ' ', armCommon.i18n("V2.AGUI.ADATAGRID.NO_ELEM.AVAIL", "presente"), ".");
      }

      var loading = !!this.props.loading; // 

      var rch = null;
      if (this.props.onRowClick) rch = this.rowClickHandler;
      var noPaginator = this.props.noPaginator;
      var useTree = this.props.useTree;
      var rowVisibleOn = this.props.rowVisibleOn || null;

      if (useTree) {
        rowVisibleOn = this.treeRowVisible; // override
      }

      var def = this.props.def;

      if (useTree) {
        if (this.state.count > 0) {
          var ln = Object.keys(this.state.selTree).length;

          if (ln === 0) {
            console.log("TABELLA CON useTree MA non PREPARATA", this.state, this.props); // return null;
          }
        } //def = _.cloneDeep(def);lastColNotFixedIndex


        def = def.map(function (col, index) {
          // disattivo le colonne sortable per i tree
          col.sortable = false;
          col._index = index;

          if (col.treeNode) {
            // if (col.treeNodeDone)
            //     return col;
            // col.treeNodeDone = true;
            if (!col._oldRenderer) col._oldRenderer = col.renderer || function (val) {
              return val;
            };

            col.renderer = function (val, col, item, index) {
              var origRender = col._oldRenderer(val, col, item, index);

              var ident = [];

              for (var i = 0; i < item._tree.level; i++) {
                ident.push( /*#__PURE__*/React__default['default'].createElement("div", {
                  className: "ident",
                  key: item._tree.id + "_" + i
                }));
              }

              var knot = /*#__PURE__*/React__default['default'].createElement("i", {
                className: "fa fa-square-o noArrow"
              });
              var onClick = null;

              if (item._tree.hasknot) {
                onClick = function onClick(e) {
                  //console.log("CHANGE knot", col, item, index, self.state.selTree);
                  self.treeChangeOpen(col, item, index);
                };

                var icon = " fa fa-caret-down ";

                if (self.props.knotIcon) {
                  icon = self.props.knotIcon;
                }

                knot = /*#__PURE__*/React__default['default'].createElement("i", {
                  className: " arrow " + icon + (self.treeOpened(item) ? " open " : " "),
                  onClick: onClick
                });
              }

              return /*#__PURE__*/React__default['default'].createElement("div", {
                className: "tree-knot"
              }, /*#__PURE__*/React__default['default'].createElement("div", {
                className: "pre-space"
              }, ident, knot), /*#__PURE__*/React__default['default'].createElement("div", {
                className: "tree-view-elem"
              }, origRender));
            };
          }

          return col;
        }, this);
      }

      var gridProps = {
        id: this.state.id + "__grid",
        def: def,
        data: this.state.count > 0 ? this.state.currentPage : [],
        className: this.props.className,
        sort: this.state.sort,
        detailsRenderer: this.props.detailsRenderer,
        onRowClick: rch,
        onChangeSort: this.onChangeSort,
        tbodyHeight: tbodyHeight,
        rowVisibleOn: rowVisibleOn,
        rowCssClassCalculate: this.props.rowCssClassCalculate,
        itemComponent: AItem,
        fixed: this.props.fixed || false,
        fixedCols: this.props.fixedCols,
        // = {first: 2, last: 1}
        compact: this.props.compact || false,
        useTabIndex: this.props.useTabIndex,
        rowId: this.state.rowId
      };
      var pagrProps = {
        id: this.state.id + "__pg",
        itemName: this.props.itemName,
        itemsName: this.props.itemsName,
        count: this.state.count,
        pageSize: this.state.pageSize,
        pageCount: this.state.pageCount,
        page: this.state.page,
        className: this.props.pageClassName,
        onPageChange: function onPageChange(e) {
          return _this3.pageHandler(e);
        }
      };
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: armCommon.Utils.union("aDataGrid", " ", this.props.gridClassName)
      }, this.props.loadingBg === true && /*#__PURE__*/React__default['default'].createElement("div", {
        className: "loading-bg"
      }, /*#__PURE__*/React__default['default'].createElement("i", {
        className: "fa fa-spinner fa-pulse text-primary"
      })), loading && /*#__PURE__*/React__default['default'].createElement("div", {
        className: "loading-box"
      }, /*#__PURE__*/React__default['default'].createElement("i", {
        className: "fa fa-spinner fa-pulse"
      }), " ", armCommon.i18n("V2.AGUI-adatagrid.LOADING", "Caricamento"), "..."), this.state.count > 0 ? /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "aTableContainer"
      }, /*#__PURE__*/React__default['default'].createElement(AGrid, gridProps)), !noPaginator && /*#__PURE__*/React__default['default'].createElement(APaginator, pagrProps)) : !loading && (this.props.showColumns === true ? /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "aTableContainer has-no-data"
      }, /*#__PURE__*/React__default['default'].createElement(AGrid, gridProps)), /*#__PURE__*/React__default['default'].createElement("div", {
        className: "no-data"
      }, noDataComp)) : /*#__PURE__*/React__default['default'].createElement("div", {
        className: "no-data"
      }, noDataComp)));
    }
  }, {
    key: "pageHandler",
    value: function pageHandler(event) {
      //console.log("[aDataGrid] pageHandler event:", event);
      var page = event.page; //console.log("[aDataGrid] change to page", page);

      var oldPage = this.state.page;

      if (page !== oldPage) {
        //console.log("page changed.... create new state");
        var state = Object.assign({}, this.state);
        state.page = page; // check page!?!

        if (this.internUpdateOnState(state, true)) this.setState(state);
      }
    } // private 

  }, {
    key: "internUpdateOnState",
    value: function internUpdateOnState(state, toRecreate) {
      var someChanges = false;
      var origPage = state.page;

      if (isNaN(state.pageSize) || this.props.pageSize < 0) {
        this.props.pageSize = DEFAULT_PAGE_SIZE;
        someChanges = true;
      }

      if (state.data === undefined || state.data === null) {
        state.data = [];
        state.count = 0;
        someChanges = true;
      }

      state.count = state.data.length;
      var usePage = this.props.pageSize > 0;
      state.usePage = usePage;

      if (usePage) {
        state.pageCount = Math.ceil(state.count / state.pageSize);

        if (state.pageCount < 1) {
          state.pageCount = 1;
          someChanges = true;
        }
      } else {
        state.pageCount = 1;
      }

      if (toRecreate) {
        var newdata = this.makeSort(state.data, state.sort);

        if (newdata !== null) {
          state.data = newdata;
          someChanges = true;
        }
      }

      var pageToRecreate = toRecreate;

      if (isNaN(state.page) || state.page < 1) {
        state.page = 1;
        pageToRecreate = true;
      }

      if (state.page > state.pageCount) {
        state.page = state.pageCount;
        pageToRecreate = true;
      }

      if (pageToRecreate || state.currentPage === null) {
        if (usePage) {
          var start = (state.page - 1) * this.props.pageSize;
          var end = Math.min(state.page * this.props.pageSize, state.count);
          var cp = [];

          for (var i = start; i < end; i++) {
            var elem = state.data[i];
            cp.push(elem);
          }

          state.currentPage = cp;
        } else {
          state.currentPage = state.data;
        }

        someChanges = true;
      }

      if (this.treePrepare(state.data, state)) {
        someChanges = true;
      } //console.debug("aDataGrid._updateOnState: something changes?", someChanges);


      return someChanges;
    }
  }], [{
    key: "builtinComparator",
    value: function builtinComparator(a, b, itemA, itemB, retrieveRowId) {
      if (a === undefined) a = null;
      if (b === undefined) b = null;
      if (a === null && b === null) return 0;
      if (a === null) return 1;
      if (b === null) return -1; // check on type date

      if (a instanceof Date) {
        var dateA = a.getTime();
        var dateB = b.getTime();
        return dateA < dateB ? -1 : dateA === dateB ? 0 : -1;
      } // any not number


      if (isNaN(a)) {
        var aa = a.toString().toLowerCase();
        var bb = b.toString().toLowerCase();
        return aa.localeCompare(bb);
      }

      if (a < b) return -1;

      if (a === b) {
        if (!retrieveRowId) return 0;else {
          var idA = retrieveRowId(itemA);
          var idB = retrieveRowId(itemB);
          return idA.localeCompare(idB);
        }
      }

      return 1;
    }
  }, {
    key: "getVal",
    value: function getVal(col, item) {
      return aTable.getVal(col, item);
    }
  }]);

  return aDataGrid;
}(React.PureComponent);

_defineProperty(aDataGrid, "propTypes", {
  id: p__default['default'].string,
  gridComponent: p__default['default'].node,
  itemComponent: p__default['default'].node,
  itemName: p__default['default'].string,
  itemsName: p__default['default'].string,
  def: p__default['default'].arrayOf(p__default['default'].object),
  data: p__default['default'].arrayOf(p__default['default'].object),
  noPaginator: p__default['default'].bool,
  pageSize: p__default['default'].number,
  page: p__default['default'].number,
  onRowClick: p__default['default'].func,
  pageClassName: p__default['default'].string,
  showColumns: p__default['default'].bool,
  detailsRenderer: p__default['default'].func,
  rowCssClassCalculate: p__default['default'].func,
  loading: p__default['default'].bool,
  // se true visualizza un overlay di loading dati
  loadingBg: p__default['default'].bool // se true visualizza un loading dati in alto a destra

});

_defineProperty(aDataGrid, "defaultProps", {
  gridComponent: null,
  itemComponent: null,
  itemName: armCommon.i18n("V2.AGUI.ADATAGRID.ELEMENT", "elemento"),
  itemsName: armCommon.i18n("V2.AGUI.ADATAGRID.ELEMENTS", "elementi"),
  pageSize: DEFAULT_PAGE_SIZE,
  onRowClick: null,
  pageClassName: null,
  showColumns: false,
  loading: false,
  loadingBg: false
});

function aDiv(props) {
  var _props$visible = props.visible,
      visible = _props$visible === void 0 ? true : _props$visible,
      id = props.id,
      style = props.style,
      className = props.className,
      children = props.children;
  if (!visible) return null;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: id,
    style: style,
    className: className,
    children: children
  });
}
aDiv.defaultProps = {
  visible: true,
  id: '',
  style: null,
  className: '',
  children: null
};
aDiv.propTypes = {
  visible: p__default['default'].bool,
  id: p__default['default'].string,
  style: p__default['default'].object,
  className: p__default['default'].string,
  children: p__default['default'].node
};

/**
 * @typedef {object} ToolTipProps Tool tip properties
 * @prop {boolean} show shows the tooltip
 * @prop {string} [idFor] identifier of the element to which the tooltip is associated
 * @prop {string} [classname] div selector
 * @prop {('top'|'right'|'bottom'|'left')} [position] tooltip position, default 'bottom'. Possible values: <br> top, right, bottom, left
 * @prop {('column'|'row')} [direction] Tooltip container direction,
 * @prop {number} [zIndex] z-index to levelize the tooltip
 * @prop {Node} [children] React children
 */

/**
 * @callback _ToolTip
 * @param {ToolTipProps} props
 * @returns {JSX.Element}
 */
exports.typedefs = {};

var classNamePrefix$3 = 'arm-gui-tooltip';
/** 
 * component used to show tooltip at the father components on hover
 * @type {_ToolTip} 
 */

function ToolTip(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$position = props.position,
      position = _props$position === void 0 ? 'bottom' : _props$position,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'column' : _props$direction,
      show = props.show,
      idFor = props.idFor,
      zIndex = props.zIndex,
      children = props.children;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      absolute = _useState4[0],
      setAbsolute = _useState4[1];

  var visibility = show !== null && show !== void 0 ? show : visible;

  var _useState5 = React.useState({
    visibility: visibility ? 'visible' : 'hidden',
    opacity: visibility ? 1 : 0,
    flexDirection: direction,
    top: -50000
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      coord = _useState6[0],
      setCoord = _useState6[1];

  var _useState7 = React.useState(position),
      _useState8 = _slicedToArray(_useState7, 2),
      currentPosition = _useState8[0],
      setCurrentPosition = _useState8[1];

  var _useState9 = React.useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      prevElement = _useState10[0],
      setPrevElement = _useState10[1];

  var ref = React.useRef();
  var contentRef = React.useRef();

  function calcCoord(e) {
    var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prevElement;
    var content = contentRef.current;

    if (element && content) {
      var coordinates = {
        visibility: 'visible',
        opacity: 1,
        flexDirection: direction,
        zIndex: zIndex !== null && zIndex !== void 0 ? zIndex : retriveZindex(prevElement)
      };

      var _element$getBoundingC = element.getBoundingClientRect(),
          top = _element$getBoundingC.top,
          left = _element$getBoundingC.left,
          bottom = _element$getBoundingC.bottom,
          right = _element$getBoundingC.right;

      var positionAt = currentPosition;
      var bottomSpace = window.innerHeight - bottom; //maxTopSpace || window.innerHeight - bottom;

      var topSpace = top; //maxBottomSpace || top;

      var leftSpace = left;
      var rightSpace = window.innerWidth - right;
      var contentWidth = content.offsetWidth;
      var contentHeight = content.offsetHeight;

      switch (position) {
        case 'top':
          //max priority to top position
          bottomSpace = contentHeight;
          break;

        case 'bottom':
          //max priority to bottom position
          topSpace = contentHeight;
          break;

        case 'right':
          //max priority to left position
          leftSpace = contentWidth;
          break;

        case 'left':
          //max priority to right position
          rightSpace = contentWidth;
          break;
      }

      if (position === 'bottom' || position === 'top') {
        if (bottomSpace > topSpace) {
          positionAt = 'bottom';
          coordinates.top = bottom;
          coordinates.bottom = 'auto';
          coordinates.maxHeight = bottomSpace;
        } else {
          positionAt = 'top';
          coordinates.top = 'auto';
          coordinates.bottom = window.innerHeight - top;
          coordinates.maxHeight = topSpace;
        }

        coordinates.left = left + element.offsetWidth / 2;
        coordinates.marginLeft = -(contentWidth / 2);
      } else {
        if (rightSpace < leftSpace) {
          positionAt = 'left';
          coordinates.right = window.innerWidth - left;
          coordinates.maxWidth = leftSpace;
        } else {
          positionAt = 'right';
          coordinates.left = right;
          coordinates.maxWidth = rightSpace;
        }

        coordinates.top = top + element.offsetHeight / 2;
        coordinates.marginTop = -(contentHeight / 2);
      }

      setCoord(coordinates);
      setCurrentPosition(positionAt);
    }
  }

  function onShowFunction() {
    setVisible(true);
  }

  function onHideFunction() {
    setVisible(false);
  }

  React.useEffect(function () {
    var removeEventScrollYListener = null;

    if (ref.current) {
      var element = prevElement;

      if (!element) {
        var _ref$current;

        if (idFor) {
          element = document.getElementById(idFor);
        } else if ((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.previousElementSibling) {
          element = ref.current.previousElementSibling;
        }

        setPrevElement(element);
      }

      removeEventScrollYListener = addListenerToScrollY(element, function () {
        return calcCoord(null, element);
      });

      if (show === undefined) {
        element.addEventListener('pointerover', onShowFunction);
        element.addEventListener('pointerout', onHideFunction);
      } else {
        if (!removeEventScrollYListener) {
          setAbsolute(true);
        }
      }
    }

    return function () {
      if (show === undefined && prevElement) {
        prevElement.removeEventListener('pointerover', onShowFunction);
        prevElement.removeEventListener('pointerout', onHideFunction);
        if (removeEventScrollYListener) removeEventScrollYListener();
      } else if (!show && prevElement && removeEventScrollYListener) {
        removeEventScrollYListener();
      } else {
        setAbsolute(false);
      }
    };
  }, [ref, show]);
  React.useEffect(function () {
    if (visibility && prevElement) {
      calcCoord(null, prevElement);
    }

    if (!visibility) {
      setCoord({
        visibility: 'hidden',
        opacity: 0,
        flexDirection: direction,
        top: -50000
      });
    }
  }, [visibility, prevElement]);
  var Wrapper = absolute ? function (_ref) {
    var children = _ref.children;
    return children;
  } : ModalContainer;
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    ref: ref,
    style: {
      display: 'none'
    }
  }), /*#__PURE__*/React__default['default'].createElement(Wrapper, null, visibility && /*#__PURE__*/React__default['default'].createElement("div", {
    ref: contentRef,
    style: !absolute ? coord : null,
    className: "".concat(classNamePrefix$3).concat(absolute ? '-absolute' : '', " ").concat(currentPosition, " ").concat(className).trimEnd()
  }, children)));
}
ToolTip.propTypes = {
  idFor: p__default['default'].string,
  show: p__default['default'].bool,
  children: p__default['default'].any,
  className: p__default['default'].string,
  position: p__default['default'].oneOf(['top', 'right', 'bottom', 'left']),
  direction: p__default['default'].oneOf(['column', 'row']),
  zIndex: p__default['default'].number
};
var parentWithScroll = null;
var idScroller = 0;
var tickings = {};

function scrolling(cb, id) {
  tickings[id].lastKnownScrollPosition = parentWithScroll.scrollY;

  if (!tickings[id].ticking) {
    window.requestAnimationFrame(function () {
      cb();
      tickings[id].ticking = false;
    });
    tickings[id].ticking = true;
  }
}

function addEventScroller(cb) {
  var id = ++idScroller;
  tickings[id] = {
    ticking: false,
    lastKnownScrollPosition: 0
  };

  var scroll = function scroll() {
    return scrolling(cb, id);
  };

  parentWithScroll.addEventListener('scroll', scroll);
  return function () {
    parentWithScroll.removeEventListener('scroll', scroll);
    delete tickings[id];
  };
}

function addListenerToScrollY(elem, cb) {
  if (parentWithScroll && parentWithScroll.scrollHeight > parentWithScroll.clientHeight) {
    return addEventScroller(cb);
  } else if (elem.scrollHeight > elem.clientHeight) {
    console.log('addListenerToScrollY: parent found!', elem);
    parentWithScroll = elem;
    return addEventScroller(cb);
  } else if (elem.parentElement) {
    addListenerToScrollY(elem.parentElement, cb);
  }

  console.log('addListenerToScrollY: all parent hasn\'t scrollbar');
  return null;
} //TODO: add functionality on scrollX


function retriveZindex(elem) {
  try {
    var computedStyle = window.getComputedStyle(elem);
    var position = computedStyle.getPropertyValue('position');

    if (position === 'fixed' || position === 'absolute') {
      return computedStyle.getPropertyValue('z-index');
    } else if (elem.parentElement) {
      return retriveZindex(elem.parentElement);
    } else {
      return null;
    }
  } catch (_unused) {
    return null;
  }
}

/**
 * @typedef {Object} FieldsetProps aFieldset properties
 * @prop {Array<import("react").Component>} [children] React children
 * @prop {string} [className] div selector
 * @prop {string} [title] Tile for the fieldset. First label, optional?
 * @prop {boolean} [disabled] Default false
 * @prop {string} [icon] Fontawsome icon string. Example 'fa fa-cogs'
 * @prop {boolean} [loading] Default false
 * @prop {('column'|'row')} [direction = 'column'] Direction in wich to show the fieldset. Default column. Possible values: column, row
 * @prop {string} [minWidth] How much should the component fieldset shrink. The shrinking of this component will stop at minimum width given. <br> Default '50px'
 * @prop {boolean} [enableToolTip] By default the tooltip is always enabled. Option to disable it if needed.
 * @prop {('top'|'right'|'bottom'|'left')} [tooltipPosition = 'bottom'] Position of the tooltip that is going to be shown. Default is 'bottom'. Possible values: 'top', 'right', 'bottom', 'left'
 * @prop {string} [defaultValue] In case there is no value in the variables passed as children to the tooltip. Default '-'
 */

/**
 * @callback _aFieldset 
 * @param {FieldsetProps} props
 * @returns {JSX.Element}
 */
exports.typedefs = {};

var classNamePrefix$4 = 'arm-gui-fieldset';
/** 
 * Fieldset component that allows tooltip in case of shrinking visuals
 * @type {_aFieldset} 
 */

function aFieldset(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'column' : _props$direction,
      _props$enableToolTip = props.enableToolTip,
      enableToolTip = _props$enableToolTip === void 0 ? true : _props$enableToolTip,
      _props$tooltipPositio = props.tooltipPosition,
      tooltipPosition = _props$tooltipPositio === void 0 ? 'bottom' : _props$tooltipPositio,
      title = props.title,
      icon = props.icon,
      defaultValue = props.defaultValue,
      children = props.children;
  var style = {
    flexDirection: direction
  };
  var iconComp = icon && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("i", {
    className: icon
  }), " ", " ");
  var componentCls = "".concat(classNamePrefix$4, " ").concat(classNamePrefix$4, "-").concat(direction, " ").concat(enableToolTip ? "".concat(classNamePrefix$4, "-has-tooltip") : '').trimEnd();
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(componentCls, " ").concat(className).trimEnd(),
    style: style
  }, title && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNamePrefix$4, "-title")
  }, iconComp, title), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "".concat(classNamePrefix$4, "-content")
  }, children || defaultValue || '-')), enableToolTip && /*#__PURE__*/React__default['default'].createElement(ToolTip, {
    position: tooltipPosition,
    direction: direction
  }, /*#__PURE__*/React__default['default'].createElement("div", null, iconComp, title), children));
}
aFieldset.p = {
  className: p__default['default'].string,
  title: p__default['default'].any,
  defaultValue: p__default['default'].any,
  disabled: p__default['default'].bool,
  icon: p__default['default'].string,
  loading: p__default['default'].bool,
  direction: p__default['default'].oneOf(['row', 'column']),
  children: p__default['default'].any
};

var classNamePrefix$5 = 'arm-gui-icon';
function aIcon(props) {
  var visible = props.visible,
      className = props.className,
      id = props.id,
      icon = props.icon,
      onClick = props.onClick;
  if (!visible) return null;
  var style = {};
  if (onClick) style.cursor = 'pointer';
  return /*#__PURE__*/React__default['default'].createElement("i", {
    id: id,
    style: style,
    className: "".concat(classNamePrefix$5, " ").concat(icon, " ").concat(className).trimEnd(),
    onClick: onClick
  });
}
aIcon.defaultProps = {
  visible: true,
  id: '',
  className: '',
  icon: '',
  onClick: null
};
aIcon.propTypes = {
  visible: p__default['default'].bool,
  id: p__default['default'].string,
  className: p__default['default'].string,
  icon: p__default['default'].string.isRequired,
  onClick: p__default['default'].func
};

var aSwitch = function aSwitch(props) {
  // constructor(props) {
  //     super(props);
  //     let id = props.id;
  //     if (!id) {
  //         id = Utils.uuid();
  //     }
  //     state = {
  //         id: id,
  //     }
  // }
  var id = props.id;

  if (!id) {
    id = armCommon.Utils.uuid();
  }

  var _useState = React.useState({
    id: id
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var onChangeHandler = function onChangeHandler(ev) {
    if (props.onChange) {
      return props.onChange(ev);
    }
  };

  var label = props.label,
      checked = props.checked,
      onChange = props.onChange,
      disabled = props.disabled,
      name = props.name,
      value = props.value,
      className = props.className,
      offLabel = props.offLabel,
      onLabel = props.onLabel;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "onoffswitch pull-right" + (className ? " " + className : "")
  }, /*#__PURE__*/React__default['default'].createElement("input", {
    type: "checkbox",
    name: name,
    className: "onoffswitch-checkbox",
    id: state.id,
    checked: checked,
    onChange: onChangeHandler,
    disabled: disabled,
    value: value ? value : ""
  }), /*#__PURE__*/React__default['default'].createElement("label", {
    className: "onoffswitch-label",
    htmlFor: state.id
  }, label, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "on-label"
  }, onLabel), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "off-label"
  }, offLabel)));
};

var aToggle = function aToggle(props) {
  // constructor(props) {
  //     super(props);
  //     onChange = onChange.bind(this);
  // }
  var onChangeHandler = function onChangeHandler(e) {
    if (props.onChange) props.onChange(e, props.value);
  };

  var children = props.children,
      label = props.label,
      checked = props.checked,
      onChange = props.onChange,
      id = props.id,
      disabled = props.disabled,
      radio = props.radio,
      name = props.name,
      value = props.value,
      type = props.type;
  if (children && !label) label = children;
  var inputType = "radio";

  if (radio) {
    inputType = "radio";
  } else {
    inputType = "checkbox";
  }

  if (type && type === "radio") {
    inputType = "radio";
  } else if (type && type === "checkbox") {
    inputType = "checkbox";
  }

  return /*#__PURE__*/React__default['default'].createElement("label", {
    className: "aToggle custom-toggle " + (radio || type === "radio" ? 'custom-radio' : 'custom-checkbox') + (props.className ? " " + props.className : "")
  }, /*#__PURE__*/React__default['default'].createElement("input", {
    type: inputType,
    name: radio ? name : 'false',
    className: "toggle-input",
    checked: checked ? true : false,
    onChange: onChangeHandler,
    id: id,
    value: value ? value : "",
    disabled: disabled
  }), /*#__PURE__*/React__default['default'].createElement("span", {
    style: disabled ? {
      "backgroundColor": "LightGray",
      'cursor': 'not-allowed'
    } : null,
    className: "toggle-indicator"
  }), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "toggle-label"
  }, label));
};

var _excluded$1 = ["cellifyWidth", "colWidth", "className"],
    _excluded2 = ["colWidth", "cellifyWidth", "className"];
var classNamePrefix$6 = 'arm-gui-cellify';
/**
 * Passando i numeri, si assegnano in corrispondenza della stringa
 * 
 * @param {number} lg - schermi grandi (desktop)
 * @param {number} md - schermi medi (tablet)
 * @param {number} sm - schermi piccoli (smartphone)
 * 
 * @returns stringa es 'col-lg-2 col-md-2 col-sm-6 col-6';
 */

var colWidthResponsive = function colWidthResponsive(lg, md, sm) {
  return " col-lg-".concat(lg, " col-md-").concat(md, " col-sm-").concat(sm, " col-").concat(sm, " ");
};
/**
 * Crea una stringa contenete il class di bootstrap
 * per i 3 tipi di grandezze delle schermo, partendo da quello
 * più grande (pattern di default se viene passato colWidth alla prop dell'elemento)
 * @param {number} bootstrapColLG dimensione più grande
 * 
 * @returns stringa es input '2': 'col-lg-2 col-md-2 col-sm-6 col-6';
 */


function _setBootstrapClassCol(bootstrapColLG) {
  if (typeof bootstrapColLG === 'string') bootstrapColLG = parseInt(bootstrapColLG);

  switch (bootstrapColLG) {
    case 12:
      return ' col-12 ';

    case 11:
      return colWidthResponsive(11, 12, 12);

    case 10:
      return colWidthResponsive(10, 10, 12);

    case 9:
      return colWidthResponsive(9, 8, 12);
    //se md diminuisco la grandezza perchè aumento quella di quelli più piccoli

    case 8:
      return colWidthResponsive(8, 8, 12);

    case 7:
      return colWidthResponsive(7, 6, 12);

    case 6:
      return colWidthResponsive(6, 6, 12);

    case 5:
      return colWidthResponsive(5, 4, 12);

    case 4:
      return colWidthResponsive(4, 4, 12);

    case 3:
      return colWidthResponsive(3, 4, 6);

    case 2:
      return colWidthResponsive(2, 2, 6);

    case 1:
      return colWidthResponsive(1, 2, 6);

    default:
      return '';
  }
}
/**
 * _NEEDS TO REFACTOR: Staccare il componente dalla logica Bootstrap_
 * 
 * Inserisce i figli (react children) all'interno di un div con className='col-lg-X col-md-X col-sm-X col-X',
 * dove le X sono il risultato di colWidthResponsive ottenuto partendo da un numero
 * appartenente alla prop colWidth (se non lo possiede, di default viene applicato 12) contenuta nei vari React.Children.
 * (vedi metodo _setBootstrapClassCol)
 * 
 * Questi div html vengono inseriti dentro un div con className='row' (appartenente al framework Bootstrap).
 * E' possibile passare ai children la prop cellifyWidth, che, se presente, sovrascrive il className del div cella.
 * 
 * @deprecated use arm-core-layouts.Form
 * @param {object} props properties del componente
 * @param {boolean} props.noMargin se true, rimuove il margin-bottom che spazia le righe, se no viene applicato un margin-bottom di 1rem
 * @param {string} props.className selettore del contenitore
 * @param {('stretch'|'center'|'flex-start'|'flex-end'|'baseline'|'initial'|'inherit')} props.alignItems css property
 * @param {Node} props.children react children
 */


function Cellify(props) {
  console.log('[Cellify]: render');
  var className = props.className,
      children = props.children,
      alignItems = props.alignItems,
      noMargin = props.noMargin;

  var _useState = React.useState(props.id || armCommon.Utils.uuid('cellify-')),
      _useState2 = _slicedToArray(_useState, 1),
      id = _useState2[0];

  var _renderChildren = function _renderChildren(children) {
    return children.map(function (elem, index) {
      var _elem$props;

      //checking null or visible prop of element
      if (elem === null || elem.props && elem.props.visible === false || elem.length === 0) return null; //if child is an array

      if (elem.length > 0) return _renderChildren(elem);

      var bootstrapCol = _setBootstrapClassCol(12); // default colWidth (max size)


      var childClassName = ((_elem$props = elem.props) === null || _elem$props === void 0 ? void 0 : _elem$props.className) || '';

      if (elem.props && elem.props.cellifyWidth) {
        bootstrapCol = elem.props.cellifyWidth; //applico il className definito nella prop

        var _elem$props2 = elem.props,
            cellifyWidth = _elem$props2.cellifyWidth,
            colWidth = _elem$props2.colWidth,
            _className = _elem$props2.className,
            childProps = _objectWithoutProperties(_elem$props2, _excluded$1); //rimuovo la prop per evitare errori


        elem = /*#__PURE__*/React__default['default'].createElement(elem.type, childProps);
      } else if (elem.props && elem.props.colWidth) {
        bootstrapCol = _setBootstrapClassCol(elem.props.colWidth); //applico il colSize predefinito

        var _elem$props3 = elem.props,
            _colWidth = _elem$props3.colWidth,
            _cellifyWidth = _elem$props3.cellifyWidth,
            _className2 = _elem$props3.className,
            _childProps = _objectWithoutProperties(_elem$props3, _excluded2); //rimuovo la prop per evitare errori


        elem = /*#__PURE__*/React__default['default'].createElement(elem.type, _childProps);
      }

      var margin = !noMargin ? "".concat(classNamePrefix$6, "-margin-bottom") : ''; //margin-bottom Bootstrap

      return /*#__PURE__*/React__default['default'].createElement("div", {
        key: "".concat(id, "-child-").concat(index),
        className: "".concat(margin, " ").concat(bootstrapCol, " ").concat(childClassName)
      }, elem);
    });
  };

  var style = alignItems ? {
    alignItems: alignItems
  } : null;
  var elements = React__default['default'].Children.count(children) > 1 ? children : [children];
  var haveMarginBottom = !noMargin ? "".concat(classNamePrefix$6, "-with-margin-bottom") : '';
  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: id,
    style: style,
    className: "row ".concat(classNamePrefix$6, " ").concat(haveMarginBottom, " ").concat(className || '').trimEnd()
  }, _renderChildren(elements));
}

Cellify.colWidthResponsive = colWidthResponsive;
Cellify.propTypes = {
  id: p.string,
  className: p.string,
  noMargin: p.bool,
  alignItems: p.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'baseline', 'initial', 'inherit']),
  children: p.arrayOf(p.shape({
    colWidth: p.number,
    cellifyWidth: p.string
  }))
};

var CoolCheckBox = function CoolCheckBox(props) {
  // constructor(props) {
  //     super(props);
  //     onChange = onChange.bind(this);
  // }
  var onChangeHandler = function onChangeHandler(e) {
    if (props.onChange) props.onChange(e, props.value);
  };

  var children = props.children,
      label = props.label,
      checked = props.checked,
      onChange = props.onChange,
      id = props.id,
      disabled = props.disabled,
      value = props.value,
      topLabel = props.topLabel,
      bottomLabel = props.bottomLabel,
      formatter = props.formatter,
      color = props.color,
      showProgressBar = props.showProgressBar;
  if (children && !label) label = children;
  var toggleIndicatorClass = !checked ? " toggle-indicator" : " toggle-indicator toggle-indicator-checked";
  var progressBar = false;
  var areNumbers = !isNaN(parseFloat(label)) && !isNaN(parseFloat(bottomLabel));

  if (showProgressBar) {
    if (areNumbers) {
      progressBar = {};
      progressBar.height = props.height || "10px";
      progressBar.width = parseFloat(label) / parseFloat(bottomLabel) * 100 + "%";
    } else {
      console.warn("[CoolCheckBox]: the property label and bottom label must be numbers or progress bar will not able to show.");
    }
  }

  if (areNumbers && formatter) {
    label = formatter(label);
    bottomLabel = formatter(bottomLabel);
  }

  var fatherClassName = disabled ? "checkbox-disabled" : "checkbox";
  var toggleColor = null;
  var checkboxLabelStyle = null;

  if (color) {
    fatherClassName += " colored";
    if (progressBar) progressBar.backgroundColor = color;

    if (checked) {
      toggleColor = {
        backgroundColor: color
      };
      checkboxLabelStyle = {
        color: color
      };
    }
  }

  if (disabled) {
    checkboxLabelStyle = null;
    toggleColor = {
      backgroundColor: "LightGray",
      cursor: "not-allowed"
    };
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: id,
    className: props.className ? fatherClassName + " " + props.className : fatherClassName
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "checkbox-topLabel"
  }, topLabel), /*#__PURE__*/React__default['default'].createElement("div", {
    className: checked ? "checked-checkbox" : "unchecked-checkbox",
    onClick: onChangeHandler
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "coolCheckBox custom-toggle custom-checkbox"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    style: toggleColor,
    className: disabled ? " " : toggleIndicatorClass
  }), /*#__PURE__*/React__default['default'].createElement("span", {
    style: checkboxLabelStyle,
    className: checked ? "checkbox-label" : "dark-label"
  }, disabled && !checked ? "-" : label)), progressBar ? /*#__PURE__*/React__default['default'].createElement("div", {
    className: "coolProgress-container"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "progressBar",
    role: "progressbar",
    style: progressBar
  })) : null), /*#__PURE__*/React__default['default'].createElement("span", {
    className: checked ? "checkbox-bottomLabel" : "dark-bottomLabel"
  }, " ", bottomLabel));
};

var CoolGroupSelector = function CoolGroupSelector(props) {
  var idKey = props.id || armCommon.Utils.uuid("coolgroupselector");
  var valueKey = props.valueKey || "value";
  var labelKey = props.labelKey || "label";

  var _useState = React.useState({
    idKey: idKey,
    valueKey: valueKey,
    labelKey: labelKey,
    items: props.items
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1]; // constructor(props) {
  //     super(props);
  //     let idKey = props.id || Utils.uuid("coolgroupselector");
  //     let valueKey = props.valueKey || "value";
  //     let labelKey = props.labelKey || "label";
  //     state = {
  //         idKey: idKey,
  //         valueKey: valueKey,
  //         labelKey: labelKey,
  //         items: props.items,
  //     }
  // }


  var itemRenderer = function itemRenderer(_itemRenderer, item) {
    var labelKey = state.labelKey;

    if (_itemRenderer) {
      return _itemRenderer(item);
    } else {
      return getItemValue(item, labelKey);
    }
  };

  var unSelectItem = function unSelectItem(index, item) {
    props.unSelectItem(index, item);
  };

  var selectItem = function selectItem(item) {
    props.selectItem(item);
  };

  var getItemValue = function getItemValue(item, key) {
    var arrKey = key.split(".");
    var value = item;

    if (arrKey.length > 1) {
      for (var i = 0; i < arrKey.length; i++) {
        value = value[arrKey[i]];
      }
    } else {
      value = value[key];
    }

    return value;
  };

  var items = state.items;
  var leftLabel = props.leftLabel,
      rightLabel = props.rightLabel,
      title = props.title,
      className = props.className,
      disabled = props.disabled; // let { idKey, valueKey, labelKey } = state;

  var selectedItems = props.selectedItems;
  return /*#__PURE__*/React__default['default'].createElement("div", null, title && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "groupselector-title"
  }, title), /*#__PURE__*/React__default['default'].createElement("div", {
    className: " groupselector-wrapper " + (className ? className : " ")
  }, (leftLabel || rightLabel) && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "groupselector-label"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "progress-leftLabel"
  }, leftLabel), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "progress-rightLabel"
  }, rightLabel)), /*#__PURE__*/React__default['default'].createElement("ul", {
    key: idKey,
    className: "groupselector-items"
  }, items.map(function (item, index) {
    var foundIndex = selectedItems.findIndex(function (el1) {
      return getItemValue(el1, valueKey) === getItemValue(item, valueKey);
    });

    if (selectedItems && foundIndex !== -1) {
      return /*#__PURE__*/React__default['default'].createElement("li", {
        className: "select-item selected " + (disabled ? "is-disabled " : ""),
        key: idKey + "_" + index,
        value: getItemValue(item, valueKey),
        onClick: function onClick() {
          return unSelectItem(foundIndex, item);
        }
      }, item.itemRenderer ? itemRenderer(item.itemRenderer, item) : itemRenderer(props.componentRenderer, item));
    } else {
      return /*#__PURE__*/React__default['default'].createElement("li", {
        className: "select-item " + (disabled ? "is-disabled " : ""),
        key: idKey + "_" + index,
        value: getItemValue(item, valueKey),
        onClick: function onClick() {
          return selectItem(item);
        }
      }, item.itemRenderer ? itemRenderer(item.itemRenderer, item) : itemRenderer(props.componentRenderer, item));
    }
  }))));
};

var CoolProgressBar = function CoolProgressBar(props) {
  var actualValue = props.actualValue,
      maxValue = props.maxValue,
      leftLabel = props.leftLabel,
      rightLabel = props.rightLabel,
      formatter = props.formatter;
  var progresBarStyle = {};
  progresBarStyle["height"] = props.height || "5px";
  progresBarStyle["width"] = actualValue / maxValue * 100 + "%";

  if (formatter) {
    actualValue = formatter(actualValue);
    maxValue = formatter(maxValue);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: props.className ? " " + props.className : "",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "coolProgressBar-title"
  }, /*#__PURE__*/React.createElement("span", {
    className: "progress-leftTitle"
  }, leftLabel), /*#__PURE__*/React.createElement("span", {
    className: "progress-rightTitle"
  }, rightLabel)), /*#__PURE__*/React.createElement("div", {
    className: "coolProgressBar-values"
  }, /*#__PURE__*/React.createElement("span", {
    className: "progress-leftLabel"
  }, actualValue), /*#__PURE__*/React.createElement("span", {
    className: "progress-rightLabel"
  }, maxValue)), /*#__PURE__*/React.createElement("div", {
    className: "coolProgress-container"
  }, /*#__PURE__*/React.createElement("span", {
    className: "progressBar",
    role: "progressbar",
    style: progresBarStyle
  })));
};

/**
 * @typedef {Object} DashCardProps DashCard properties
 * @prop {string} [className] container selector
 * @prop {(_DashCardLabel|_DashCardImage|_DashCardLabel[])} children  DashCard.Icon and DashCard.Image are optionable, DashCard.Label is required and could be max 3 and min 1.
 */

/**
 * @callback _DashCard renders a card with icon or image with labels
 * @param {DashCardProps} props
 * @returns {JSX.Element}
 */

/**
 * @typedef {Object} DashCardIconProps DashCardIcon properties
 * @prop {string} icon icon selector
 * @prop {string} [size='7rem'] icon font-size
 */

/**
 * @callback _DashCardIcon DashCard icon item
 * @param {DashCardIconProps} props
 * @returns {JSX.Element}
 */

/**
 * @typedef {Object} DashCardImageProps DashCardImage properties
 * @prop {string} source image path
 * @prop {string} [className] component selector
 * @prop {string} [width='6rem'] image width
 * @prop {string} [height='6rem'] image height
 */

/**
 * @callback _DashCardImage DashCard image item
 * @param {DashCardImageProps} props
 * @returns {JSX.Element}
 */

/**
 * @typedef {Object} DashCardLabelProps DashCardLabel properties
 * @prop {string} [className] component selector
 * @prop {bool} [large] large text label
 * @prop {bool} [medium] medium text label
 * @prop {bool} [small] small text label
 * @prop {bool} [highlighted] it gives the color to label
 * @prop {string[]} children text label
 */

/**
 * @callback _DashCardLabel DashCard label item
 * @param {DashCardLabelProps} props
 * @returns {JSX.Element}
 */
exports.typedefs = {};

var classNamePrefix$7 = 'arm-gui-dashcard';
/** @type {_DashCard} */

function DashCard(props) {
  console.log('[DashCard]: render');
  var children = props.children,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className;
  var mapComponents = {
    icon: null,
    image: null,
    labels: []
  };
  React__default['default'].Children.forEach(children, function (child) {
    if (!child) {
      return;
    }

    switch (child.type.toString()) {
      case DashCardIcon.toString():
        mapComponents.icon = child;
        break;

      case DashCardImage.toString():
        mapComponents.image = child;
        break;

      case DashCardLabel.toString():
        mapComponents.labels.push(child);
        break;
    }
  });
  var icon = mapComponents.icon,
      image = mapComponents.image,
      labels = mapComponents.labels;

  if (icon && image) {
    console.error('Error: only one image or only one icon');
    return null;
  }

  if (!labels.length || !(labels.length > 1 && labels.length <= 3)) {
    console.error('Error: labels must be 2 or 3');
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNamePrefix$7, "-container ").concat(className).trimEnd()
  }, (icon || image) && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNamePrefix$7, "-max-content")
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNamePrefix$7, "-container-").concat(image ? 'image' : 'icon')
  }, image || icon), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNamePrefix$7, "-content-label")
  }, labels)), !icon && !image && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNamePrefix$7, "-content")
  }, labels));
}
/** @type {_DashCardLabel} */

function DashCardLabel(props) {
  var _props$children = props.children,
      children = _props$children === void 0 ? '' : _props$children,
      _props$className2 = props.className,
      className = _props$className2 === void 0 ? '' : _props$className2,
      small = props.small,
      large = props.large,
      medium = props.medium,
      highlighted = props.highlighted;
  var textHighlighted = '';

  if (highlighted) {
    textHighlighted = "".concat(classNamePrefix$7, "-highlighted");
  }

  var size = '';

  if (large) {
    size = "".concat(classNamePrefix$7, "-label-large");
  } else if (medium) {
    size = "".concat(classNamePrefix$7, "-label-medium");
  } else if (small) {
    size = "".concat(classNamePrefix$7, "-label-small");
  }

  return /*#__PURE__*/React__default['default'].createElement("span", {
    className: "".concat(classNamePrefix$7, "-label ").concat(size, " ").concat(textHighlighted, " ").concat(className).trimEnd(),
    title: children
  }, children);
}

DashCardLabel.propTypes = {
  className: p__default['default'].string,
  small: p__default['default'].bool,
  medium: p__default['default'].bool,
  large: p__default['default'].bool,
  highlighted: p__default['default'].bool,
  children: p__default['default'].oneOfType([p__default['default'].string, p__default['default'].number, p__default['default'].arrayOf(p__default['default'].oneOfType([p__default['default'].string, p__default['default'].number]))])
};
/** @type {_DashCardIcon} */

function DashCardIcon(props) {
  console.log('[DashCardIcon]: render');
  var _props$className3 = props.className,
      className = _props$className3 === void 0 ? '' : _props$className3,
      icon = props.icon,
      size = props.size;
  var iconStyle = {
    fontSize: size
  };

  if (!icon) {
    console.error('[DashCardIcon]: Insert icon tag');
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement("i", {
    style: iconStyle,
    className: "".concat(icon, " ").concat(classNamePrefix$7, "-icon ").concat(classNamePrefix$7, "-highlighted ").concat(className).trimEnd()
  });
}
DashCardIcon.propTypes = {
  className: p__default['default'].string,
  icon: p__default['default'].string,
  size: p__default['default'].string,
  highlight: p__default['default'].bool
};
/** @type {_DashCardImage} */

function DashCardImage(props) {
  console.log('[DashCardImage]: render');
  var _props$className4 = props.className,
      className = _props$className4 === void 0 ? '' : _props$className4,
      source = props.source,
      width = props.width,
      height = props.height;
  return /*#__PURE__*/React__default['default'].createElement("img", {
    src: source,
    width: width,
    height: height,
    className: "".concat(classNamePrefix$7, "-image ").concat(className).trimEnd()
  });
}
DashCardImage.propTypes = {
  className: p__default['default'].string,
  source: p__default['default'].string,
  width: p__default['default'].string,
  height: p__default['default'].string,
  children: p__default['default'].string
};
var singleTypeComponent = p__default['default'].shape({
  type: p__default['default'].oneOf([DashCardLabel, DashCardIcon, DashCardImage])
});
DashCard.propTypes = {
  className: p__default['default'].string,
  children: p__default['default'].oneOfType([p__default['default'].shape({
    type: p__default['default'].oneOf([DashCardLabel])
  }), p__default['default'].arrayOf(singleTypeComponent)]).isRequired
};
DashCard.Label = DashCardLabel;
DashCard.Image = DashCardImage;
DashCard.Icon = DashCardIcon;

var InputRange = function InputRange(props) {
  //     super(props);
  //     componentName = "[InputRange.jsx] ";
  //     rispostaOnChange = rispostaOnChange.bind(this);
  // }

  var rispostaOnChange = function rispostaOnChange(event) {
    props.onChange(event);
  };

  var visualValue = props.visualValue ? props.visualValue : "";
  var positionValue = props.positionValue ? props.positionValue : "right";
  var widthValue = props.max.length * 13;
  var value = props.value || Math.floor(props.max / 2);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%"
    }
  }, visualValue === true && positionValue === "top" ? /*#__PURE__*/React.createElement("div", {
    className: "input-group custom-slider  " + props.className,
    style: {
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "d-flex range-slider-value-top mb-4" + props.className
  }, /*#__PURE__*/React.createElement("input", {
    style: {
      backgroundColor: "#2c3e50",
      textDecorationColor: "#FFFFFF",
      textAlign: "center",
      color: "#FFFFFF",
      width: widthValue + "px"
    },
    type: "number",
    key: "inputRangeMax",
    className: "form-control range-slider-range",
    id: props.id,
    disabled: props.disabled,
    name: props.name,
    value: value,
    onChange: rispostaOnChange
  }))) : null, /*#__PURE__*/React.createElement("div", {
    className: "input-group custom-slider  " + props.className
  }, visualValue === true && positionValue === "left" ? /*#__PURE__*/React.createElement("span", {
    className: "d-flex range-slider-value-left mr-4 mt-1 " + props.className
  }, /*#__PURE__*/React.createElement("input", {
    style: {
      backgroundColor: "#2c3e50",
      textDecorationColor: "#FFFFFF",
      textAlign: "center",
      color: "#FFFFFF",
      width: widthValue + "px"
    },
    type: "number",
    key: "inputRangeMax",
    className: "form-control range-slider-range",
    id: props.id,
    disabled: props.disabled,
    name: props.name,
    value: value,
    onChange: rispostaOnChange
  })) : null, /*#__PURE__*/React.createElement("input", {
    type: "range",
    style: {
      outlineColor: "white"
    },
    className: "form-control range-slider-range",
    id: props.id,
    required: props.required,
    disabled: props.disabled,
    name: props.name,
    value: value,
    min: props.min,
    max: props.max,
    step: props.step,
    onChange: rispostaOnChange
  }), visualValue === true && positionValue === "right" ? /*#__PURE__*/React.createElement("span", {
    className: "d-flex range-slider-value-right ml-4 mt-1 " + props.className
  }, /*#__PURE__*/React.createElement("input", {
    style: {
      backgroundColor: "#2c3e50",
      textDecorationColor: "#FFFFFF",
      textAlign: "center",
      color: "#FFFFFF",
      width: widthValue + "px"
    },
    type: "number",
    key: "inputRangeMax ",
    className: "form-control range-slider-range",
    id: props.id,
    disabled: props.disabled,
    name: props.name,
    value: value,
    onChange: rispostaOnChange
  })) : null), visualValue === true && positionValue === "bottom" ? /*#__PURE__*/React.createElement("div", {
    className: "input-group custom-slider  " + props.className,
    style: {
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "d-flex range-slider-value-bottom mt-4" + props.className
  }, /*#__PURE__*/React.createElement("input", {
    style: {
      backgroundColor: "#2c3e50",
      textDecorationColor: "#FFFFFF",
      textAlign: "center",
      color: "#FFFFFF",
      width: widthValue + "px"
    },
    type: "number",
    key: "inputRangeMax ",
    className: "form-control range-slider-range",
    id: props.id,
    disabled: props.disabled,
    name: props.name,
    value: value,
    onChange: rispostaOnChange
  }))) : null);
};

var CoolInputContainer = function CoolInputContainer(props) {
  var labRef = {}; // constructor(props) {
  //     super(props);
  //     labRef = {};
  //     clearValue = clearValue.bind(this);
  // }
  // componentWillMount() {
  // }

  var refLabel = function refLabel() {
    return armCommon.Utils.uuid("ci_lab");
  };

  var clickAddon = function clickAddon(e, ciLab, type) {
    console.log("click on addon/label " + ciLab); //$("#"+ciLab).click();

    if (props.onAddonClick) {
      props.onAddonClick(e);
      return;
    }

    if (type === "prefix") {
      if (props.onPrefixClick) {
        props.onPrefixClick(e);
        return;
      }
    }

    if (type === "suffix") {
      if (props.onSuffixClick) {
        props.onSuffixClick(e);
        return;
      }
    }

    var lar = labRef[ciLab]; ///

    if (lar) {
      //let els = $(labRef.el);
      //els.find("select,textarea,input").click();
      console.log("DO click on input");
      jquery__default['default'](lar).find("select,textarea,input").click();
    } ///

  };

  var clearValue = function clearValue() {
    console.log("clear value call");
    if (props.onClearValue) props.onClearValue();
  };

  var className = props.className,
      active = props.active; // FUTURE: gestire onBLUR / onFOCUS

  var reqMark = "";
  var requiredClass = props.required ? " required" : "";

  if (props.required) {
    reqMark = /*#__PURE__*/React__default['default'].createElement("span", {
      className: "text-danger",
      title: "campo richiesto",
      "aria-label": "campo richiesto"
    }, " *");
  }

  var ciLab = refLabel();
  var block = props.block || false;
  var children = props.children;
  var preicon = "";
  var posticon = "";
  var hasAddon = className + (block ? ' block' : '') + " ";

  if (props.disabled) {
    hasAddon += " is-disabled";
  }

  if (props.readOnly) {
    hasAddon += " is-readonly";
  }

  var help = props.help || null;
  var error = props.hasError || null;
  var warning = props.hasWarning;

  if (error || warning) {
    hasAddon += " has-error";

    if (!error && warning) {
      error = warning;
      hasAddon += " has-warning";
    }

    help = null;
  }

  if (help) {
    hasAddon += " has-help";
  }

  var clearBtn = null;

  if (armCommon.UiUtils.detectIE() === 0 && props.noClearBtn === false && !props.readOnly) {
    hasAddon += " has-clearbtn ";

    if (props.hasValue && !props.disabled) {
      clearBtn = /*#__PURE__*/React__default['default'].createElement("a", {
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopPropagation();
          clearValue();
        },
        className: "clearBtn"
      }, "x");
    }
  }

  if (props.preIcon || props.postIcon || props.prefix || props.suffix) {
    var cicon = "addon";

    if (props.useBlock) {
      cicon = "";
    }

    if (props.preIcon || props.prefix) {
      hasAddon += " has-addon-left";
      var withPrefix = props.prefix ? " withPrefix" : "";
      preicon = /*#__PURE__*/React__default['default'].createElement("span", {
        className: cicon + " pre-addon" + withPrefix,
        title: props.prefixTitle,
        onClick: function onClick(e) {
          return clickAddon(e, ciLab, "prefix");
        }
      }, props.preIcon && /*#__PURE__*/React__default['default'].createElement("i", {
        className: props.preIcon,
        "aria-hidden": "true"
      }), props.prefix && /*#__PURE__*/React__default['default'].createElement("span", {
        className: "prefix"
      }, props.prefix));
    }

    if (props.postIcon || props.suffix) {
      if (props.preIcon || props.prefix) hasAddon += "has-addon-both";else hasAddon += " has-addon-right";
      var withSuffix = props.suffix ? " withSuffix" : "";
      posticon = /*#__PURE__*/React__default['default'].createElement("span", {
        className: cicon + " post-addon" + withSuffix,
        title: props.suffixTitle,
        onClick: function onClick(e) {
          return clickAddon(e, ciLab, "suffix");
        }
      }, props.postIcon && /*#__PURE__*/React__default['default'].createElement("i", {
        className: props.postIcon,
        "aria-hidden": "true"
      }), props.suffix && /*#__PURE__*/React__default['default'].createElement("span", {
        className: "suffix"
      }, props.suffix));
    }
  }

  var lab = null;

  if (props.label) {
    if (props.useBlock) {
      var pri = preicon,
          poi = posticon;
      preicon = null;
      posticon = null;
      lab = /*#__PURE__*/React__default['default'].createElement("span", {
        className: "lab addon" + requiredClass
      }, pri, props.label, " ", reqMark, poi);
    } else {
      lab = /*#__PURE__*/React__default['default'].createElement("span", {
        className: "lab" + requiredClass,
        onClick: function onClick(e) {
          return clickAddon(e, ciLab);
        }
      }, props.label, " ", reqMark);
    }
  }

  if (className === "none") {
    return children;
  }

  if (props.minimal) {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: "cool-input cool-input-container-minimal"
    }, error && /*#__PURE__*/React__default['default'].createElement("div", {
      className: "error-sign"
    }, ' '), help && /*#__PURE__*/React__default['default'].createElement("div", {
      className: "help-mesg"
    }, help), error && /*#__PURE__*/React__default['default'].createElement("div", {
      className: "error-mesg"
    }, error), children);
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "cool-input" + (props.compact ? " cool-input-container-compact " : " cool-input-container ") + hasAddon
  }, error && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "error-sign"
  }, ' '), help && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "help-mesg"
  }, help), error && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "error-mesg"
  }, error), preicon, /*#__PURE__*/React__default['default'].createElement("label", {
    id: ciLab,
    ref: function ref(label) {
      return labRef[ciLab] = label;
    }
  }, clearBtn, children, lab), posticon);
};

/**
 * @deprecated use CoolDateInput
 */

function aDateInput(props) {
  var id = props.id,
      open = props.open,
      onInputChange = props.onInputChange,
      dateFormat = props.dateFormat,
      locale = props.locale,
      value = props.value,
      className = props.className,
      onBlur = props.onBlur,
      readOnly = props.readOnly,
      disabled = props.disabled,
      onFocus = props.onFocus,
      inputClassName = props.inputClassName,
      viewMode = props.viewMode,
      placeholder = props.placeholder,
      isValidDate = props.isValidDate,
      timeFormat = props.timeFormat,
      size = props.size;

  var _useState = React.useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      date = _useState2[0],
      setDate = _useState2[1];

  React.useEffect(function () {
    if (value !== date) setDate(value);
  }, [value]);

  function onInputBlur(e) {
    if (!moment__default['default'].isMoment(date)) setDate(value);
    if (onBlur) onBlur(e);
  }

  function onChange(moment) {
    console.debug("[aDateInput]: onInputChange", moment);

    if (moment__default['default'].isMoment(moment) && onInputChange) {
      onInputChange(moment.toDate(), moment.valueOf());
      if (open) onInputBlur();
    } else if (!moment) {
      onInputChange(null, null);
    } else {
      setDate(moment);
      if (moment && !open) onFocus();
    }
  }

  function renderView(mode, renderDefault) {
    return /*#__PURE__*/React__default['default'].createElement(PopupContestuale, {
      idFor: id,
      className: "rdtPicker",
      show: open,
      maxBottomSpace: remToPixels(21.7),
      onClose: open ? onInputBlur : undefined
    }, renderDefault());
  }

  function renderInput(props) {
    return /*#__PURE__*/React__default['default'].createElement("input", _extends({}, props, {
      value: date ? props.value : ''
    }));
  }

  return /*#__PURE__*/React__default['default'].createElement(Datetime__default['default'], {
    className: className,
    dateFormat: dateFormat,
    inputProps: {
      placeholder: placeholder,
      disabled: readOnly || disabled,
      className: inputClassName,
      size: size,
      onFocus: onFocus,
      onBlur: !open ? onInputBlur : undefined
    },
    onChange: onChange,
    timeFormat: timeFormat ? timeFormat : false,
    closeOnTab: true,
    locale: locale || armCommon.getLocale(),
    value: date,
    initialViewMode: viewMode,
    closeOnSelect: true,
    isValidDate: isValidDate,
    open: open,
    renderView: renderView,
    renderInput: renderInput
  });
}

/** @deprecated use CoolTextInput */

var aTextInput = function aTextInput(props) {
  // static propTypes = {
  //   id: t.string,
  //   disabled: t.bool,
  //   label: t.string,
  //   loading: t.bool,
  //   type: t.string,
  //   bs: t.string,
  //   icon: t.string,
  //   suffixIcon: t.string,
  //   inline: t.bool,
  //   placeholder: t.string,
  //   required: t.bool,
  //   title: t.string,
  //   help: t.string,
  //   extraClass: t.string,
  //   validation: t.objectOf(t.string),
  //   groupClass: t.string,
  //   groupProps: t.object
  // }
  // static defaultProps = {
  //   disabled: false,
  //   loading: false,
  //   label: null,
  //   type: 'text',
  //   bs: "default",
  //   icon: null,
  //   suffixIcon: null,
  //   inline: false,
  //   placeholder: null,
  //   required: false,
  //   title: null,
  //   help: null,
  //   extraClass: null,
  //   validation: null,
  //   groupClass: null,
  //   groupProps: null
  // }
  // constructor(props) {
  //   super(props);
  //   shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
  // }
  var _props = props,
      id = _props.id,
      children = _props.children,
      label = _props.label,
      title = _props.title,
      disabled = _props.disabled,
      icon = _props.icon,
      help = _props.help,
      extraClass = _props.extraClass,
      groupClass = _props.groupClass,
      groupProps = _props.groupProps,
      prefix = _props.prefix,
      suffix = _props.suffix,
      validation = _props.validation,
      suffixIcon = _props.suffixIcon,
      required = _props.required,
      inline = _props.inline,
      errMessage = _props.errMessage,
      placeholder = _props.placeholder,
      loading = _props.loading,
      type = _props.type,
      value = _props.value;
  props = ___default['default'].omit(props, 'id', 'label', 'title', 'help', 'extraClass', 'validation', 'required', 'prefix', 'suffix', 'groupClass', 'groupProps', 'children', 'placeholder', 'disabled', 'errMessage', 'bs', 'icon', 'suffixIcon', 'inline', 'loading', 'type', 'value');
  if (!id) id = armCommon.Utils.uuid("at");
  var textarea = false;
  var fieldValue = value ? value : '';

  if (loading) {
    disabled = true;
  }

  if (!type) {
    type = "text";
  } else {
    // throw error on checkbox and radio
    if (type === "checkbox" || type === "radio") throw new Error("aTextInput cannot be used with 'checkbox' or 'radio' type");

    if (type === "textarea") {
      textarea = true;
    }
  }

  var ticon = "";
  var tsuffixIcon = "";
  var licon = "";
  var lsuffixIcon = "";
  var cicon = "input-group-addon";
  if (textarea) cicon = ""; // attivo su textarea le icone sulla label

  if (icon || prefix) {
    ticon = /*#__PURE__*/React__default['default'].createElement("span", {
      className: cicon
    }, icon && /*#__PURE__*/React__default['default'].createElement("i", {
      className: icon,
      "aria-hidden": "true"
    }), prefix && ' ' + prefix);
  }

  if (suffixIcon || suffix) {
    tsuffixIcon = /*#__PURE__*/React__default['default'].createElement("span", {
      className: cicon
    }, suffix && ' ' + suffix, suffixIcon && /*#__PURE__*/React__default['default'].createElement("i", {
      className: suffixIcon,
      "aria-hidden": "true"
    }));
  }

  if (textarea) {
    licon = ticon;
    lsuffixIcon = tsuffixIcon;
    ticon = "";
    tsuffixIcon = "";
  }

  var blockcls = "form-group";
  var inputcls = "form-control";

  if (inline) {
    inputcls += " ";
    blockcls = "form-group-inline mb-2 mr-2 mr-xs-0";

    if (!placeholder) {
      placeholder = label;
      if (required) placeholder += "*";
    }
  }

  if (extraClass) {
    inputcls += " " + extraClass;
  }
  var reqMark = "";

  if (required) {
    reqMark = /*#__PURE__*/React__default['default'].createElement("span", {
      className: "text-danger required",
      title: "campo richiesto",
      "aria-label": "campo richiesto"
    }, " *");
  }

  var labelCmp;

  if (props.label !== null) {
    if (inline) labelCmp = /*#__PURE__*/React__default['default'].createElement("label", {
      className: "sr-only",
      htmlFor: id,
      id: id + '__label'
    }, label);else labelCmp = /*#__PURE__*/React__default['default'].createElement("label", {
      className: "form-control-label",
      htmlFor: id,
      id: id + '__label'
    }, " ", licon, " ", label, " ", reqMark, " ", lsuffixIcon);
  }

  var thelp = "";
  var idHelp = null;

  if (help !== null) {
    idHelp = id + "__help";
    var helpClass = "text-mute"; // block level

    helpClass += " form-text"; // FUTURE - support for inline help 

    thelp = /*#__PURE__*/React__default['default'].createElement("span", {
      id: idHelp,
      className: helpClass
    }, help);
  }

  var errorMessage = "";

  if (validation) {
    //console.log('ID = x' + id +"X");
    //for (var [key, value] of validation) {
    // console.log(key + ' = ' + value);
    //}
    //cerco un eventuale messaggio di errore per il mio componente
    var errore = validation.get ? validation.get(id) : validation[id]; //console.log('Errore: ' + errore);

    if (errore !== undefined) {
      blockcls += ' has-danger'; //	spanClass = 'glyphicon glyphicon-remove form-control-feedback';

      var spanErr = /*#__PURE__*/React__default['default'].createElement("span", {
        dangerouslySetInnerHTML: {
          __html: errore
        }
      });
      errorMessage = /*#__PURE__*/React__default['default'].createElement("small", {
        className: "form-control-feedback"
      }, /*#__PURE__*/React__default['default'].createElement("i", {
        "aria-hidden": "true",
        className: "fa fa-times"
      }), " ", ' ', spanErr, " ", errMessage);
    }
  } else if (errMessage) {
    errorMessage = /*#__PURE__*/React__default['default'].createElement("small", {
      className: "form-control-feedback"
    }, /*#__PURE__*/React__default['default'].createElement("i", {
      "aria-hidden": "true",
      className: "fa fa-times"
    }), " ", ' ', errMessage);
  }

  var mustGroup = false;

  if (ticon || tsuffixIcon) {
    mustGroup = true;
    if (!groupProps) groupProps = {};
  }

  var input;

  if (textarea) {
    input = /*#__PURE__*/React__default['default'].createElement("textarea", _extends({
      className: inputcls,
      placeholder: placeholder,
      required: required,
      disabled: disabled,
      type: type,
      id: id
    }, props, {
      "aria-describedby": idHelp,
      value: fieldValue
    }));
  } else {
    input = /*#__PURE__*/React__default['default'].createElement("input", _extends({
      className: inputcls,
      placeholder: placeholder,
      required: required,
      disabled: disabled,
      type: type,
      id: id
    }, props, {
      "aria-describedby": idHelp,
      value: fieldValue,
      size: "1"
    }));
  }

  var inputBox;

  if (mustGroup) {
    inputBox = /*#__PURE__*/React__default['default'].createElement("div", _extends({
      id: id + '__grp'
    }, groupProps, {
      className: armCommon.Utils.union('input-group', ' ', groupClass)
    }), ticon, input, tsuffixIcon);
  } else {
    inputBox = input;
  }

  console.log("[aTextInput] render: " + id);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: blockcls
  }, labelCmp, inputBox, children, thelp, errorMessage);
};

var iconProp = p__default['default'].shape({
  icon: p__default['default'].string.isRequired,
  onClick: p__default['default'].func
});
var ContainerProps = {
  defaultProps: {
    id: '',
    className: '',
    label: '',
    preIcon: '',
    postIcon: '',
    suffix: '',
    prefix: '',
    hasWarning: '',
    hasError: '',
    help: '',
    required: false,
    disabled: false,
    readOnly: false,
    minimal: false,
    noInput: false,
    validation: null,
    zIndexMessage: null,
    focus: false,
    onClear: null,
    children: p__default['default'].node
  },
  propTypes: {
    id: p__default['default'].string,
    className: p__default['default'].string,
    label: p__default['default'].string,
    preIcon: p__default['default'].oneOfType([p__default['default'].string, iconProp]),
    postIcon: p__default['default'].oneOfType([p__default['default'].string, iconProp]),
    suffix: p__default['default'].string,
    prefix: p__default['default'].string,
    hasWarning: p__default['default'].oneOfType([p__default['default'].oneOf([false]), p__default['default'].string]),
    hasError: p__default['default'].oneOfType([p__default['default'].oneOf([false]), p__default['default'].string]),
    help: p__default['default'].string,
    required: p__default['default'].bool,
    disabled: p__default['default'].bool,
    readOnly: p__default['default'].bool,
    minimal: p__default['default'].bool,
    noInput: p__default['default'].bool,
    validation: p__default['default'].oneOfType([p__default['default'].instanceOf(Object), p__default['default'].instanceOf(Map)]),
    zIndexMessage: p__default['default'].number,
    focus: p__default['default'].bool,
    onClear: p__default['default'].func,
    children: p__default['default'].node
  }
};

var AIcon = aIcon;
var classNamePrefix$8 = 'arm-gui-cool-container';

function renderIcon(className, iconProps) {
  if (iconProps) {
    if (_typeof(iconProps) === 'object') {
      return /*#__PURE__*/React__default['default'].createElement(AIcon, _extends({
        className: className
      }, iconProps));
    }

    return /*#__PURE__*/React__default['default'].createElement(AIcon, {
      className: className,
      icon: iconProps
    });
  }

  return null;
}

function AddMessage(_ref) {
  var type = _ref.type,
      message = _ref.message,
      zIndex = _ref.zIndex,
      idFor = _ref.idFor,
      focus = _ref.focus;

  var _useState = React.useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  function fade() {
    if (message) {
      setShow(true);
      setTimeout(function () {
        return setShow(undefined);
      }, 2000);
    } else {
      setShow(false);
    }
  }

  React.useEffect(function () {
    if (focus && message) {
      setShow(true);
    } else if (!focus) {
      fade();
    }
  }, [focus]);
  React.useEffect(fade, [message]);
  var icon = '';

  switch (type) {
    case 'help':
      icon = 'fas fa-info-circle';
      break;

    case 'error':
    case 'warn':
      icon = 'fas fa-exclamation-triangle';
      break;
  }

  return /*#__PURE__*/React__default['default'].createElement(ToolTip, {
    idFor: idFor,
    zIndex: zIndex,
    show: show,
    direction: "row",
    className: "arm-gui-cool-container-".concat(type)
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    style: {
      marginRight: '1rem'
    },
    className: "arm-gui-cool-container-".concat(type, "-ico ").concat(icon)
  }), " ", message);
}
function CoolContainer(props) {
  var className = props.className,
      label = props.label,
      preIcon = props.preIcon,
      postIcon = props.postIcon,
      suffix = props.suffix,
      prefix = props.prefix,
      hasWarning = props.hasWarning,
      hasError = props.hasError,
      help = props.help,
      required = props.required,
      disabled = props.disabled,
      readOnly = props.readOnly,
      minimal = props.minimal,
      noInput = props.noInput,
      zIndexMessage = props.zIndexMessage,
      focus = props.focus,
      onClear = props.onClear,
      children = props.children;
  var showWarning = !hasError && hasWarning;
  var showFocus = !hasError && !hasWarning && !readOnly;
  var clsReadOnly = readOnly ? 'readonly' : '';
  var clsErr = hasError ? 'error' : '';
  var clsWrn = showWarning ? 'warn' : '';
  var clsDisabled = disabled ? 'disabled' : '';

  var _useState3 = React.useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      clsFocus = _useState4[0],
      setClsFocus = _useState4[1];

  var _useState5 = React.useState(props.id || armCommon.Utils.uuid(classNamePrefix$8)),
      _useState6 = _slicedToArray(_useState5, 1),
      id = _useState6[0];

  var labelCont = '';

  if (label) {
    labelCont = /*#__PURE__*/React__default['default'].createElement("label", {
      className: "".concat(classNamePrefix$8, "-label"),
      title: label
    }, label, required && /*#__PURE__*/React__default['default'].createElement("i", {
      className: "".concat(classNamePrefix$8, "-required")
    }, "*"));
  }

  var containerMessage = {
    type: '',
    message: '',
    zIndex: zIndexMessage,
    idFor: id,
    focus: focus
  };

  if (hasError) {
    containerMessage.type = 'error';
    containerMessage.message = hasError;
  } else if (hasWarning) {
    containerMessage.type = 'warn';
    containerMessage.message = hasWarning;
  }

  var clsInput = noInput ? "" : "".concat(classNamePrefix$8, "-input ").concat(clsWrn, " ").concat(clsErr, " ").concat(clsFocus, " ").concat(clsDisabled, " ").concat(clsReadOnly).trimEnd();
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNamePrefix$8, " ").concat(className).trimEnd()
  }, !minimal && labelCont, /*#__PURE__*/React__default['default'].createElement("div", {
    id: id,
    className: "".concat(clsInput),
    onFocus: function onFocus() {
      return showFocus ? setClsFocus('focused') : null;
    },
    onBlur: function onBlur() {
      return showFocus ? setClsFocus('') : null;
    }
  }, preIcon && renderIcon("".concat(classNamePrefix$8, "-preicon"), preIcon), prefix && /*#__PURE__*/React__default['default'].createElement("label", {
    className: "".concat(classNamePrefix$8, "-prefix")
  }, prefix), children, onClear && renderIcon("".concat(classNamePrefix$8, "-clear"), {
    icon: 'fas fa-times',
    onClick: onClear
  }), postIcon && renderIcon("".concat(classNamePrefix$8, "-posticon"), postIcon), suffix && /*#__PURE__*/React__default['default'].createElement("label", {
    className: "".concat(classNamePrefix$8, "-suffix")
  }, suffix), /*#__PURE__*/React__default['default'].createElement(AddMessage, containerMessage)), help && /*#__PURE__*/React__default['default'].createElement("span", {
    className: "".concat(classNamePrefix$8, "-help")
  }, help, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "".concat(classNamePrefix$8, "-help-ico fas fa-info-circle")
  })));
}
CoolContainer.defaultProps = _objectSpread2({}, ContainerProps.defaultProps);
CoolContainer.propTypes = _objectSpread2({}, ContainerProps.propTypes);

var AIcon$1 = aIcon;
var classNamePrefix$9 = 'arm-gui-material-container';

function renderIcon$1(className, iconProps) {
  if (iconProps) {
    if (_typeof(iconProps) === 'object') {
      return /*#__PURE__*/React__default['default'].createElement(AIcon$1, _extends({
        className: className
      }, iconProps));
    }

    return /*#__PURE__*/React__default['default'].createElement(AIcon$1, {
      className: className,
      icon: iconProps
    });
  }

  return null;
}

function MaterialContainer(props) {
  console.log('[MaterialContainer]: render');
  var className = props.className,
      label = props.label,
      preIcon = props.preIcon,
      postIcon = props.postIcon,
      suffix = props.suffix,
      prefix = props.prefix,
      hasWarning = props.hasWarning,
      hasError = props.hasError,
      help = props.help,
      required = props.required,
      disabled = props.disabled,
      readOnly = props.readOnly,
      minimal = props.minimal,
      noInput = props.noInput,
      zIndexMessage = props.zIndexMessage,
      focus = props.focus,
      onClear = props.onClear,
      children = props.children;
  var showWarning = !hasError && hasWarning;
  var showFocus = !hasError && !hasWarning;
  var clsReadOnly = readOnly ? 'readonly' : '';
  var clsErr = hasError ? 'error' : '';
  var clsWrn = showWarning ? 'warn' : '';
  var clsDisabled = disabled ? 'disabled' : '';

  var _useState = React.useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      clsFocus = _useState2[0],
      setClsFocus = _useState2[1];

  var _useState3 = React.useState(props.id || armCommon.Utils.uuid(classNamePrefix$9)),
      _useState4 = _slicedToArray(_useState3, 1),
      id = _useState4[0];

  var containerMessage = {
    type: '',
    message: '',
    zIndex: zIndexMessage,
    idFor: id,
    focus: focus
  };

  if (hasError) {
    containerMessage.type = 'error';
    containerMessage.message = hasError;
  } else if (hasWarning) {
    containerMessage.type = 'warn';
    containerMessage.message = hasWarning;
  }

  var clsInput = noInput ? "" : "".concat(classNamePrefix$9, "-input ").concat(clsDisabled);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNamePrefix$9, " ").concat(className)
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    id: id,
    className: clsInput,
    onFocus: function onFocus() {
      return showFocus ? setClsFocus('focused') : null;
    },
    onBlur: function onBlur() {
      return showFocus ? setClsFocus('') : null;
    }
  }, preIcon && renderIcon$1("".concat(classNamePrefix$9, "-preicon"), preIcon), prefix && /*#__PURE__*/React__default['default'].createElement("label", {
    className: "".concat(classNamePrefix$9, "-prefix")
  }, prefix), children, onClear && renderIcon$1("".concat(classNamePrefix$9, "-clear"), {
    icon: 'fas fa-times',
    onClick: onClear
  }), postIcon && renderIcon$1("".concat(classNamePrefix$9, "-posticon"), postIcon), suffix && /*#__PURE__*/React__default['default'].createElement("label", {
    className: "".concat(classNamePrefix$9, "-suffix")
  }, suffix), /*#__PURE__*/React__default['default'].createElement(AddMessage, containerMessage)), help && /*#__PURE__*/React__default['default'].createElement("span", {
    className: "".concat(classNamePrefix$9, "-help")
  }, help, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "".concat(classNamePrefix$9, "-help-ico fas fa-info-circle")
  })), !minimal && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNamePrefix$9, "-label ").concat(clsWrn, " ").concat(clsErr, " ").concat(clsFocus, " ").concat(clsReadOnly)
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNamePrefix$9, "-label-pre")
  }), label && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNamePrefix$9, "-label-object")
  }, /*#__PURE__*/React__default['default'].createElement("label", null, label, required && /*#__PURE__*/React__default['default'].createElement("i", {
    className: "".concat(classNamePrefix$9, "-required")
  }, "*"))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNamePrefix$9, "-label-post")
  })));
}
MaterialContainer.defaultProps = _objectSpread2({}, ContainerProps.defaultProps);
MaterialContainer.propTypes = _objectSpread2({}, ContainerProps.propTypes);

var classNamePrefix$a = 'arm-gui-input-handler';
function inputHandler(props, type, nullValue, handler) {
  React.useEffect(function () {
    console.log("[".concat(type, "]: has been rendered"), {
      id: props.id,
      label: props.label
    });
  }, []);
  var validation = props.validation,
      hasError = props.hasError,
      value = props.value,
      onChange = props.onChange,
      onBlur = props.onBlur,
      onFocus = props.onFocus;

  var _useState = React.useState({
    id: props.id || armCommon.Utils.uuid(classNamePrefix$a),
    value: value !== null && value !== void 0 ? value : '',
    focus: false,
    hasError: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      updateState = _useState2[1];

  var setState = setStateFunction(state, props, updateState);

  function handleOnChange(val1, val2) {
    var _val, _val2, _val3;

    console.log("[".concat(type, "]: onChange"));

    if (handler) {
      var res = handler(val1, val2);
      val1 = res[0];
      val2 = res[1];
    }

    setState({
      value: (_val = val1) !== null && _val !== void 0 ? _val : ''
    });
    if (onChange) onChange((_val2 = val1) !== null && _val2 !== void 0 ? _val2 : nullValue, (_val3 = val2) !== null && _val3 !== void 0 ? _val3 : nullValue, state.id);
  }

  function handleOnFocus() {
    console.log("[".concat(type, "]: onFocus"));
    setState({
      focus: true
    });
    if (onFocus) onFocus(state.id);
  }

  function handleOnBlur() {
    console.log("[".concat(type, "]: onBlur"));
    setState({
      focus: false
    });
    if (onBlur) onBlur(state.id);
  }

  React.useEffect(function () {
    if (value !== state.value) setState({
      value: value !== null && value !== void 0 ? value : ''
    });
  }, [value]);
  React.useEffect(function () {
    var error = null;

    if (validation) {
      error = validation.get ? validation.get(state.id) : validation[state.id];
    } else if (hasError) {
      error = hasError;
    }

    setState({
      hasError: error
    });
  }, [hasError, validation]);
  return _objectSpread2(_objectSpread2({}, state), {}, {
    onChange: handleOnChange,
    onBlur: handleOnBlur,
    onFocus: handleOnFocus
  });
}
var InputProps = {
  defaultProps: {
    visible: true,
    size: 1,
    className: '',
    autoComplete: "false",
    wrapClassName: '',
    compact: false,
    placeholder: '',
    onChange: null,
    onFocus: null,
    onBlur: null,
    container: null
  },
  propTypes: {
    visible: p__default['default'].bool,
    size: p__default['default'].number,
    className: p__default['default'].string,
    autoComplete: p__default['default'].string,
    wrapClassName: p__default['default'].string,
    compact: p__default['default'].bool,
    placeholder: p__default['default'].string,
    onChange: p__default['default'].func,
    onFocus: p__default['default'].func,
    onBlur: p__default['default'].func,
    container: p__default['default'].element
  }
};

var classNamePrefix$b = 'arm-gui-cool-date-input';
function CoolDateInput(props) {
  var visible = props.visible,
      size = props.size,
      className = props.className,
      wrapClassName = props.wrapClassName,
      compact = props.compact,
      placeholder = props.placeholder,
      container = props.container,
      label = props.label,
      preIcon = props.preIcon,
      suffix = props.suffix,
      prefix = props.prefix,
      hasWarning = props.hasWarning,
      help = props.help,
      required = props.required,
      disabled = props.disabled,
      readOnly = props.readOnly,
      minimal = props.minimal,
      noInput = props.noInput,
      zIndexMessage = props.zIndexMessage,
      onClear = props.onClear,
      locale = props.locale,
      viewMode = props.viewMode,
      dateFormat = props.dateFormat,
      isValidDate = props.isValidDate;

  var _inputHandler = inputHandler(props, 'CoolDateInput', null),
      id = _inputHandler.id,
      value = _inputHandler.value,
      focus = _inputHandler.focus,
      hasError = _inputHandler.hasError,
      onBlur = _inputHandler.onBlur,
      onChange = _inputHandler.onChange,
      onFocus = _inputHandler.onFocus;

  if (!visible) return null;
  var parsedValue = armCommon.DateFormatter.toDateNew(value); //to handle string time and other cases 

  var classNameADateInput = "".concat(classNamePrefix$b, " ci-focus ").concat(className).trimEnd();

  if (readOnly) {
    classNameADateInput += " date-readonly";
  }

  if (hasError) {
    classNameADateInput += " has-error";
  }

  var postIcon = {
    icon: 'fas fa-calendar-alt',
    onClick: onFocus
  };

  if (readOnly) {
    postIcon = null;
  }

  var containerProps = {
    id: id,
    preIcon: preIcon,
    postIcon: postIcon,
    label: label,
    required: required,
    minimal: minimal,
    className: "".concat(classNamePrefix$b, "-container ").concat(wrapClassName),
    disabled: disabled,
    readOnly: readOnly,
    hasError: hasError,
    hasWarning: hasWarning,
    help: help,
    compact: compact,
    zIndexMessage: zIndexMessage,
    suffix: suffix,
    prefix: prefix,
    noInput: noInput,
    onClear: onClear
  };
  var inputProps = {
    id: id,
    open: focus,
    className: classNameADateInput,
    onBlur: onBlur,
    onFocus: onFocus,
    onInputChange: onChange,
    value: parsedValue,
    disabled: disabled,
    readOnly: readOnly,
    locale: locale,
    inputClassName: "input-date-element",
    viewMode: viewMode,
    dateFormat: dateFormat,
    isValidDate: isValidDate,
    placeholder: placeholder,
    size: size
  };
  var Container = container || CoolContainer;

  if (compact) {
    Container = MaterialContainer;
  }

  return /*#__PURE__*/React__default['default'].createElement(Container, containerProps, /*#__PURE__*/React__default['default'].createElement(aDateInput, inputProps));
}
var ViewMode = Object.freeze({
  YEARS: 'years',
  MONTHS: 'months',
  DAYS: 'days',
  TIME: 'time',
  NULL: null
});
CoolDateInput.defaultProps = _objectSpread2(_objectSpread2(_objectSpread2({}, ContainerProps.defaultProps), InputProps.defaultProps), {}, {
  //shared props not used
  focus: undefined,
  autoComplete: undefined,
  children: undefined,
  //date props
  size: 6,
  locale: null,
  viewMode: null,
  dateFormat: 'DD/MM/YYYY',
  isValidDate: undefined
});
CoolDateInput.propTypes = _objectSpread2(_objectSpread2(_objectSpread2({}, ContainerProps.propTypes), InputProps.propTypes), {}, {
  //shared props not used
  focus: p__default['default'].any,
  autoComplete: p__default['default'].any,
  children: p__default['default'].any,
  //date props
  locale: p__default['default'].string,
  viewMode: p__default['default'].oneOf(Object.values(ViewMode)),
  dateFormat: p__default['default'].string,
  isValidDate: p__default['default'].func,
  value: p__default['default'].oneOfType([p__default['default'].number, p__default['default'].string, p__default['default'].instanceOf(Date)])
});
CoolDateInput.VIEW_MODE = ViewMode;

/**
 * @typedef {object} IconProps Icon properties
 * @prop {string} icon icon selector
 * @prop {() => void} [onClick] onClick event
 */

/**
 * @typedef {object} _ContainerProps Container properties
 * @prop {string} [className] additional component selector
 * @prop {string} [label] additional component selector
 * @prop {string} [preIcon] additional component selector
 * @prop {string} [postIcon] additional component selector
 * @prop {string} [suffix] additional component selector
 * @prop {string} [prefix] additional component selector
 * @prop {string} [hasWarning] additional component selector
 * @prop {string} [hasError] additional component selector
 * @prop {string} [help] additional component selector
 * @prop {boolean} [required] additional component selector
 * @prop {boolean} [disabled] additional component selector
 * @prop {boolean} [readOnly] additional component selector
 * @prop {boolean} [minimal] additional component selector
 * @prop {boolean} [noInput] additional component selector
 * @prop {string} [zIndexMessage] additional component selector
 * @prop {boolean} [focus] additional component selector
 * @prop {React.Node} [children] input destination
 */

/**
 * @callback _CoolContainer description
 * @param {_ContainerProps} props
 * @returns {JSX.Element} Container component
 */

/**
 * @callback _MaterialContainer description
 * @param {_ContainerProps} props
 * @returns {JSX.Element} Container component
 */
exports.typedefs = {};

var classNamePrefix$c = 'arm-gui-cool-select';
function CoolSelect(props) {
  var visible = props.visible,
      size = props.size,
      className = props.className,
      wrapClassName = props.wrapClassName,
      compact = props.compact,
      placeholder = props.placeholder,
      container = props.container,
      label = props.label,
      preIcon = props.preIcon,
      suffix = props.suffix,
      prefix = props.prefix,
      hasWarning = props.hasWarning,
      help = props.help,
      required = props.required,
      disabled = props.disabled,
      readOnly = props.readOnly,
      minimal = props.minimal,
      noInput = props.noInput,
      zIndexMessage = props.zIndexMessage,
      onClear = props.onClear,
      searchable = props.searchable,
      valueKey = props.valueKey,
      labelKey = props.labelKey,
      fitInput = props.fitInput,
      itemConverter = props.itemConverter,
      items = props.items,
      componentRenderer = props.componentRenderer,
      noResultsText = props.noResultsText,
      openIcon = props.openIcon,
      closeIcon = props.closeIcon;

  var _inputHandler = inputHandler(props, 'CoolSelect', null, function (item) {
    return [armCommon.Utils.getVal(valueKey, item), item];
  }),
      id = _inputHandler.id,
      value = _inputHandler.value,
      focus = _inputHandler.focus,
      hasError = _inputHandler.hasError,
      onBlur = _inputHandler.onBlur,
      onChange = _inputHandler.onChange,
      onFocus = _inputHandler.onFocus;

  var _useState = React.useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      coolSelectItems = _useState2[0],
      setCoolSelectItems = _useState2[1];

  React.useEffect(function () {
    var handledItems = items || [];

    if (items !== null && items !== void 0 && items.length && itemConverter) {
      console.log("[CoolSelect]: with itemConverter");
      handledItems = [];
      items.forEach(function (item, index) {
        item = itemConverter(item, index);
        if (item) handledItems.push(item);
      });
    }

    if (items !== null && items !== void 0 && items.length && (_typeof(items[0]) !== "object" || items[0] === null)) {
      console.log("[CoolSelect]: with primitives");
      handledItems = [];
      items.forEach(function (item, index) {
        var _handledItems$push;

        var type = _typeof(item);

        var label;

        switch (type) {
          case 'function':
            label = item.name;
            break;

          case 'undefined':
          case 'object':
            console.warn("[CoolSelect]: with primitives: cannot allow undefined or null, due to correct behaviour of react input");
            return;

          default:
            label = item.toString();
            break;
        }

        handledItems.push((_handledItems$push = {}, _defineProperty(_handledItems$push, valueKey, item), _defineProperty(_handledItems$push, labelKey, label), _handledItems$push));
      });
    }

    setCoolSelectItems(handledItems);
  }, [items]);
  if (!visible) return null;
  var classNameSelect = className;
  classNameSelect += " cool-select";
  classNameSelect += " ci-focus";

  if (!armCommon.Utils.isNil(value) || readOnly) {
    classNameSelect += " ci-has-content";
  }

  if (hasError) {
    classNameSelect += " has-error";
  }

  var inputControl = '';
  var classNameContainer = wrapClassName;

  if (classNameContainer !== "none") {
    classNameContainer += " cool-select";
  } else {
    inputControl = ' form-control ';
  }
  /** @type {_ContainerProps} */


  var containerProps = {
    preIcon: preIcon,
    label: label,
    required: required,
    minimal: minimal,
    className: classNameContainer,
    hasError: hasError,
    hasWarning: hasWarning,
    disabled: disabled,
    readOnly: readOnly,
    help: help,
    zIndexMessage: zIndexMessage,
    onClear: onClear,
    suffix: suffix,
    prefix: prefix,
    focus: focus,
    noInput: noInput
  };
  var valueItem;

  if ((disabled || readOnly) && coolSelectItems.length) {
    valueItem = coolSelectItems.find(function (item) {
      return item[valueKey] === value;
    });
    valueItem = valueItem ? valueItem[labelKey] : "";
  }

  var inputProps = {
    id: id,
    type: "text",
    className: classNameSelect + inputControl,
    value: valueItem,
    disabled: disabled,
    readOnly: readOnly,
    onBlur: onBlur,
    size: size
  };
  var selectProps = {
    id: id,
    className: classNameSelect,
    items: coolSelectItems,
    value: value,
    placeholder: placeholder,
    fitInput: fitInput,
    searchable: searchable,
    componentRenderer: componentRenderer,
    openIcon: openIcon,
    closeIcon: closeIcon,
    valueKey: valueKey,
    labelKey: labelKey,
    noResultsText: noResultsText,
    onBlur: onBlur,
    onFocus: onFocus,
    onChange: onChange,
    size: size
  };
  var Container = container || CoolContainer;

  if (compact) {
    Container = MaterialContainer;
  }

  return /*#__PURE__*/React__default['default'].createElement(Container, containerProps, disabled || readOnly ? /*#__PURE__*/React__default['default'].createElement("input", _extends({
    size: "1"
  }, inputProps)) : /*#__PURE__*/React__default['default'].createElement(Select, selectProps));
}

function Select(props) {
  var id = props.id,
      openIcon = props.openIcon,
      closeIcon = props.closeIcon,
      items = props.items,
      className = props.className,
      value = props.value,
      placeholder = props.placeholder,
      fitInput = props.fitInput,
      searchable = props.searchable,
      componentRenderer = props.componentRenderer,
      valueKey = props.valueKey,
      labelKey = props.labelKey,
      noResultsText = props.noResultsText,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      onChange = props.onChange,
      size = props.size;
  var ulRef = React.useRef();

  var _useState3 = React.useState({
    listOpen: false,
    hasRef: false,
    searchValue: '',
    filteredItems: items,
    cursor: -1,
    maxHeight: remToPixels(24)
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      state = _useState4[0],
      updateState = _useState4[1];

  var setState = setStateFunction(state, props, updateState);
  var listOpen = state.listOpen,
      hasRef = state.hasRef,
      searchValue = state.searchValue,
      filteredItems = state.filteredItems,
      cursor = state.cursor,
      maxHeight = state.maxHeight;
  React.useEffect(function () {
    setState({
      filteredItems: items
    });
  }, [items]); //#region functionalities

  function checkSelectedItem(useFiltered) {
    var _selectedItem;

    var elements = useFiltered ? filteredItems : items;
    var key = useFiltered ? labelKey : valueKey;
    var index = elements.findIndex(function (item) {
      return item[key] === value;
    });
    var selectedItem;
    if (index < 0) selectedItem = (_selectedItem = {}, _defineProperty(_selectedItem, labelKey, ""), _defineProperty(_selectedItem, valueKey, ""), _selectedItem);else selectedItem = elements[index];
    return {
      selectedItem: selectedItem,
      index: index
    };
  }

  function openList() {
    var stateUpdateCopy = setState({
      listOpen: true
    });
    setTimeout(function () {
      stateUpdateCopy.hasRef = true;
      setState(stateUpdateCopy);
    }, 1); //ripasso listOpen perchè lo state a questo tick non ha listOpen a true
  }

  function closeList(item) {
    var override = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (override) {
      var _checkSelectedItem = checkSelectedItem(),
          _selectedItem2 = _checkSelectedItem.selectedItem;

      if (_selectedItem2[labelKey] !== searchValue) {
        if (!item) item = items.find(function (item) {
          return item[labelKey] === searchValue && item[labelKey] !== noResultsText;
        });
        if (item) onChange(item, id);
      }
    }

    if (!item) item = checkSelectedItem().selectedItem;
    setState({
      listOpen: false,
      filteredItems: items,
      searchValue: item[labelKey],
      hasRef: false,
      cursor: -1
    });
  }

  function handleKeyDown(e) {
    var keyCode = e.keyCode;

    if (keyCode === 40 || keyCode === 38) {
      //arrow down || //arrow up
      ulRef.current.focus();
    }

    var newCursor = cursor;
    if (newCursor === -1) newCursor = checkSelectedItem(searchable).index;

    switch (keyCode) {
      case 38:
      case 40:
        if (keyCode === 38 && newCursor > 0) {
          newCursor = newCursor - 1;
        } else if (keyCode === 40 && newCursor < filteredItems.length - 1) {
          newCursor = newCursor + 1;
        }

        if (!isNaN(newCursor) && newCursor > -1) {
          setState({
            cursor: newCursor,
            searchValue: filteredItems[newCursor][labelKey]
          });
        }

        break;

      case 9: //tab

      case 13:
        //enter
        closeList(null, true);
        break;

      case 27:
        //esc
        closeList();
        break;

      default:
        setState({
          cursor: newCursor
        });
    }
  }

  function selectItem(item) {
    return function () {
      closeList(item);
      onChange(item, id);
    };
  }

  function handleChange(e) {
    var newList = items;

    if (e.target.value !== "") {
      var filter = e.target.value.toLowerCase(); // check to see if the list items includes the filter term
      // If it does, it will be added to newList

      newList = items.filter(function (item) {
        if (item[labelKey] && item[labelKey].toString().toLowerCase().includes(filter)) {
          return true;
        }
      });

      if (newList.length === 0) {
        var _addObject;

        var addObject = (_addObject = {}, _defineProperty(_addObject, labelKey, noResultsText), _defineProperty(_addObject, valueKey, noResultsText), _addObject);
        newList = [addObject];
      }
    }

    setState({
      filteredItems: newList,
      searchValue: e.target.value,
      cursor: -1
    });
  }

  function elabItemRenderer(itemRenderer, item) {
    if (itemRenderer) {
      return itemRenderer(item);
    } else {
      return item[labelKey];
    }
  } //#endregion functionalities
  //Effetto per scrollare sull'elemento selezionato


  React.useEffect(function () {
    var _checkSelectedItem2 = checkSelectedItem(searchable),
        index = _checkSelectedItem2.index;

    if (index >= 0 && ulRef.current) {
      var selElem = ulRef.current.children[index];

      if (selElem) {
        var topPos = selElem.offsetTop;
        ulRef.current.scrollTop = topPos;
      }
    }
  }, [hasRef]);
  React.useEffect(function () {
    if (searchable) {
      var _checkSelectedItem3 = checkSelectedItem(),
          _selectedItem3 = _checkSelectedItem3.selectedItem;

      if (_selectedItem3[labelKey] !== searchValue) {
        setState({
          searchValue: _selectedItem3[labelKey]
        });
      }
    }
  }, [value]);

  var _checkSelectedItem4 = checkSelectedItem(searchable),
      selectedItem = _checkSelectedItem4.selectedItem;

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "select-wrapper ".concat(className).trimEnd()
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "select-holder"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "select-header"
  }, searchable ? /*#__PURE__*/React__default['default'].createElement("input", {
    size: size,
    id: id,
    className: "select-value",
    placeholder: placeholder,
    onBlur: onBlur,
    onFocus: onFocus,
    onKeyDown: handleKeyDown,
    onMouseDown: openList,
    onChange: handleChange,
    value: searchValue,
    autoComplete: "off"
  }) : /*#__PURE__*/React__default['default'].createElement("input", {
    size: size,
    id: id,
    className: "select-value",
    placeholder: placeholder,
    onBlur: onBlur,
    onFocus: onFocus,
    onKeyDown: handleKeyDown,
    onMouseDown: openList,
    value: selectedItem[labelKey],
    readOnly: true
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    id: "select-arrow_" + id,
    className: "select-arrow",
    onClick: listOpen ? function () {
      return closeList();
    } : openList
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "select-arrow-icon ".concat(listOpen ? closeIcon : openIcon)
  }))), /*#__PURE__*/React__default['default'].createElement(PopupContestuale, {
    show: listOpen,
    maxBottomSpace: maxHeight //Altezza massima della popup
    ,
    widthAsParent: fitInput,
    className: "".concat(classNamePrefix$c, "-items"),
    onClose: function onClose() {
      return closeList();
    }
  }, /*#__PURE__*/React__default['default'].createElement("ul", {
    className: "select-list",
    ref: ulRef,
    onKeyDown: handleKeyDown,
    tabIndex: "0"
  }, filteredItems.map(function (item, index) {
    var selected = selectedItem[labelKey] === item[labelKey] || selectedItem[valueKey] === item[valueKey] ? 'selected' : '';
    var active = cursor === index ? 'active' : '';
    return /*#__PURE__*/React__default['default'].createElement("li", {
      key: index,
      value: item[labelKey],
      id: id + " - " + index,
      onClick: item[valueKey] !== noResultsText ? selectItem(item) : null,
      className: "".concat(selected, " ").concat(active).trim()
    }, item.itemRenderer ? elabItemRenderer(item.itemRenderer, item) : elabItemRenderer(componentRenderer, item));
  }))));
}

CoolSelect.defaultProps = _objectSpread2(_objectSpread2(_objectSpread2({}, ContainerProps.defaultProps), InputProps.defaultProps), {}, {
  //shared props not used
  autoComplete: undefined,
  postIcon: undefined,
  focus: undefined,
  children: undefined,
  //select prop
  searchable: false,
  valueKey: 'value',
  labelKey: 'label',
  fitInput: true,
  items: null,
  componentRenderer: null,
  noResultsText: 'No item available',
  openIcon: 'fas fa-chevron-down',
  closeIcon: 'fas fa-chevron-up'
});
CoolSelect.propTypes = _objectSpread2(_objectSpread2(_objectSpread2({}, ContainerProps.propTypes), InputProps.propTypes), {}, {
  //shared props not used
  autoComplete: p__default['default'].any,
  postIcon: p__default['default'].any,
  children: p__default['default'].any,
  focus: p__default['default'].any,
  //select prop
  itemConverter: p__default['default'].func,
  searchable: p__default['default'].bool,
  valueKey: p__default['default'].string,
  labelKey: p__default['default'].string,
  items: p__default['default'].arrayOf(p__default['default'].any),
  id: p__default['default'].string,
  value: p__default['default'].any,
  componentRenderer: p__default['default'].func,
  noResultsText: p__default['default'].string,
  openIcon: p__default['default'].string,
  closeIcon: p__default['default'].string,
  placeholder: p__default['default'].string,
  fitInput: p__default['default'].bool
});

var CoolDateTimeInput = function CoolDateTimeInput(props) {

  var onChangeOra = function onChangeOra(val) {
    if (props.value) {
      var nuovaData = moment__default['default'](props.value);
      nuovaData.hours(val);
      props.onChange(nuovaData.toDate());
    }
  };

  var onChangeMinuti = function onChangeMinuti(val) {
    if (props.value) {
      var nuovaData = moment__default['default'](props.value);
      nuovaData.minutes(val);
      props.onChange(nuovaData.toDate());
    }
  }; // per generare ore(0-23) e minuti(0-59) per i select


  var generateOptions = function generateOptions(optionsNo) {
    var options = [];

    for (var i = 0; i < optionsNo; i++) {
      var option = new Object();
      option.value = i;

      if (i < 10) {
        option.label = "0" + i;
      } else {
        option.label = i.toString();
      }

      options[i] = option;
    }

    return options;
  };

  var label = props.label,
      value = props.value,
      onChange = props.onChange,
      id = props.id,
      validation = props.validation;
  var partial = "";
  var ore = generateOptions(24);
  var minuti = generateOptions(60);
  var selectValidation = new Map();

  if (validation.has(id)) {
    //selectValidation = validation;
    selectValidation.set(id + "_ore", " ");
    selectValidation.set(id + "_minuti", " ");
    partial = "";
  }

  console.log('[CoolDateTimeInput.JSX]: render');
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("form", {
    className: "form-inline"
  }, /*#__PURE__*/React.createElement(CoolDateInput, {
    id: id,
    label: label,
    value: value,
    onChange: onChange,
    wrapClassName: "mr-2",
    validation: validation
  }), /*#__PURE__*/React.createElement(CoolSelect, {
    label: "Ore",
    value: moment__default['default'](value).hours(),
    items: ore,
    id: id + "_ore",
    onChange: onChangeOra,
    wrapClassName: "mr-2 cool-select-sm",
    validation: selectValidation
  }), /*#__PURE__*/React.createElement(CoolSelect, {
    label: "Minuti",
    value: moment__default['default'](value).minutes(),
    items: minuti,
    id: id + "_minuti",
    onChange: onChangeMinuti,
    wrapClassName: "mr-2 cool-select-sm",
    validation: selectValidation
  })), /*#__PURE__*/React.createElement("div", {
    className: "err-msg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col md-12"
  }, partial, " "))));
};

var POINT_CODE = 46;
var COMMA_CODE = 44;
/** @deprecated use CoolNumberInput */

function NumberInput(props) {
  var id = props.id,
      _props$formatter = props.formatter,
      formatter = _props$formatter === void 0 ? armCommon.UiUtils.number : _props$formatter,
      onChange = props.onChange,
      className = props.className,
      value = props.value,
      zeroValue = props.zeroValue,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      title = props.title,
      placeholder = props.placeholder,
      autoComplete = props.autoComplete;

  var tryFloat = function tryFloat(val, defval) {
    if (defval === undefined) defval = null;

    try {
      if (val === null || val === undefined) return defval;
      if (val === '-') return val;
      val = ("" + val).trim().replace(',', '.');
      if (val === "") return defval;
      return parseFloat(val);
    } catch (e) {
      return defval;
    }
  };

  var val = tryFloat(props.value);
  var empty = false;

  if (val === null) {
    empty = true;
  }

  var refInputs = {};

  var _React$useState = React.useState({
    id: id || armCommon.Utils.uuid("ni"),
    value: val,
    strValue: empty ? "" : formatter(val),
    inError: false,
    focus: false,
    empty: empty
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setstate = _React$useState2[1];

  React.useEffect(function () {
    if (val !== state.value) setstate(_objectSpread2(_objectSpread2({}, state), {}, {
      value: val,
      strValue: empty ? "" : formatter(val)
    }));
  }, [val]);

  var handleChange = function handleChange(e) {
    var val = e.target.value;
    var empty = false;
    var n;
    var inError = false;
    var num = 0;

    if (armCommon.Utils.isNil(val)) {
      val = "";
      num = null;
      empty = true;
    } else {
      n = tryFloat(val);

      if (val === '-') {
        num = val;
      } else if (n === null || isNaN(n)) {
        num = null;
        inError = true;
      } else {
        num = n;
      }
    }

    var strVal = buildEditStrValue(val); // togliamo tutti i non numeri

    strVal = strVal.replace(/[^\d\.\,\-]/g, "");
    var newState = update__default['default'](state, {
      value: {
        $set: num
      },
      strValue: {
        $set: strVal
      },
      inError: {
        $set: inError
      },
      empty: {
        $set: empty
      }
    });
    setstate(newState);
    onChange(num, val);
    return newState.strValue;
  };

  var buildViewValues = function buildViewValues(val) {
    var cc = _commaCfg();

    var defVal;

    if (val === null || val === undefined) {
      defVal = zeroValue || "";
    } else {
      defVal = "" + val;
    }

    defVal = defVal.replace(/[^0-9\.\,\-]/g, "").replace(cc.oldchar, cc.newchar);
    var empty = false;

    if (defVal === "") {
      empty = true;
    }

    var dv = tryFloat(defVal);
    var inError = false;

    if (isNaN(dv)) {
      inError = true;
      dv = null;
      console.log('[NumberInput]: invalid value', {
        value: val
      });
      if (onChange) onChange(dv, strVal);
    }

    var strVal = inError || empty ? defVal : formatter(dv);
    return {
      val: dv,
      strValue: strVal,
      inError: inError,
      empty: empty
    };
  };

  var view = function view() {
    var vv = buildViewValues(state.value);
    var newState = update__default['default'](state, {
      value: {
        $set: vv.val
      },
      strValue: {
        $set: vv.strValue
      },
      inError: {
        $set: vv.inError
      },
      empty: {
        $set: vv.empty
      },
      focus: {
        $set: false
      }
    });
    setstate(newState);
  };

  var buildEditStrValue = function buildEditStrValue(val) {
    var cc = _commaCfg();

    var strVal;
    if (val === null || val === undefined) strVal = "";else strVal = "" + val;
    strVal = strVal.replace(cc.oldchar, cc.newchar);
    return strVal;
  };

  var edit = function edit() {
    var val = state.value;
    var strVal = buildEditStrValue(val);
    var newState = update__default['default'](state, {
      strValue: {
        $set: strVal
      },
      focus: {
        $set: true
      }
    });
    setstate(newState);
  };

  var handleOnBlur = function handleOnBlur(e) {
    var newState = update__default['default'](state, {
      strValue: {
        $set: empty ? "" : formatter(state.strValue)
      }
    });
    console.log("[NumberInput]: Component Blurrrred!");
    Promise.resolve().then(function () {
      setstate(newState);
    }).then(function () {
      view();
      if (onBlur) onBlur();
    });
  };

  var handleOnFocus = function handleOnFocus(e) {
    Promise.resolve().then(function () {
      edit();

      if (onFocus) {
        onFocus();
      }
    });
  };

  var _commaCfg = function _commaCfg() {
    var oldcode = POINT_CODE;
    var oldcodealt = 110;
    var newcode = COMMA_CODE;
    var oldchar = String.fromCharCode(oldcode);
    var newchar = String.fromCharCode(newcode);
    return {
      oldcode: oldcode,
      oldcodealt: oldcodealt,
      oldchar: oldchar,
      newcode: newcode,
      newchar: newchar
    };
  };

  var compProps = ___default['default'].omit(props, 'value', 'zeroValue', 'formatter', 'onChange', 'onBlur', 'onFocus', 'type', 'className');

  var clsName = className;
  if (!clsName) clsName = "number-input";else clsName += " number-input";

  if (state.inError) {
    clsName += " error ci-error";
  }

  if (state.focus) {
    clsName += " ci-focus";
  }

  if (!armCommon.Utils.isNil(state.strValue)) {
    clsName += " ci-has-content";
  }

  var ref = function ref(input) {
    return refInputs[state.id] = input;
  };

  return /*#__PURE__*/React.createElement("input", _extends({
    id: state.id,
    title: title,
    placeholder: placeholder,
    autoComplete: autoComplete,
    ref: ref,
    type: "text",
    className: clsName,
    onChange: handleChange,
    onBlur: handleOnBlur,
    onFocus: handleOnFocus,
    value: state.strValue,
    size: 1
  }, compProps));
}

function CoolNumberInput(props) {
  var visible = props.visible,
      size = props.size,
      className = props.className,
      autoComplete = props.autoComplete,
      wrapClassName = props.wrapClassName,
      compact = props.compact,
      placeholder = props.placeholder,
      container = props.container,
      label = props.label,
      preIcon = props.preIcon,
      postIcon = props.postIcon,
      suffix = props.suffix,
      prefix = props.prefix,
      hasWarning = props.hasWarning,
      help = props.help,
      required = props.required,
      disabled = props.disabled,
      readOnly = props.readOnly,
      minimal = props.minimal,
      noInput = props.noInput,
      zIndexMessage = props.zIndexMessage,
      onClear = props.onClear,
      formatter = props.formatter;

  var _inputHandler = inputHandler(props, 'CoolNumberInput', null),
      id = _inputHandler.id,
      value = _inputHandler.value,
      focus = _inputHandler.focus,
      hasError = _inputHandler.hasError,
      onBlur = _inputHandler.onBlur,
      onChange = _inputHandler.onChange,
      onFocus = _inputHandler.onFocus;

  if (!visible) return null;
  var classNameInput = className;

  if (focus) {
    classNameInput += " ci-focus";
  }

  if (hasError) {
    classNameInput += " has-error";
  }

  var inputProps = {
    id: id,
    className: classNameInput,
    placeholder: placeholder,
    onBlur: onBlur,
    onFocus: onFocus,
    value: value,
    zeroValue: "",
    onChange: onChange,
    disabled: disabled,
    readOnly: readOnly,
    formatter: formatter,
    autoComplete: autoComplete,
    size: size
  };
  /** @type {_ContainerProps} */

  var containerProps = {
    preIcon: preIcon,
    postIcon: postIcon,
    suffix: suffix,
    prefix: prefix,
    label: label,
    required: required,
    className: wrapClassName,
    minimal: minimal,
    disabled: disabled,
    readOnly: readOnly,
    hasError: hasError,
    hasWarning: hasWarning,
    help: help,
    zIndexMessage: zIndexMessage,
    onClear: onClear,
    noInput: noInput,
    focus: focus
  };
  var Container = container || CoolContainer;

  if (compact) {
    Container = MaterialContainer;
  }

  return /*#__PURE__*/React__default['default'].createElement(Container, containerProps, /*#__PURE__*/React__default['default'].createElement(NumberInput, inputProps));
}
CoolNumberInput.defaultProps = _objectSpread2(_objectSpread2(_objectSpread2({}, ContainerProps.defaultProps), InputProps.defaultProps), {}, {
  //shared props not used
  focus: undefined,
  children: undefined,
  //ni props
  formatter: armCommon.UiUtils.number,
  value: null
});
CoolNumberInput.propTypes = _objectSpread2(_objectSpread2(_objectSpread2({}, ContainerProps.propTypes), InputProps.propTypes), {}, {
  //shared props not used
  focus: p__default['default'].any,
  children: p__default['default'].any,
  //number props
  formatter: p__default['default'].func,
  value: p__default['default'].number
});

function CoolTextArea(props) {
  var visible = props.visible,
      size = props.size,
      className = props.className,
      wrapClassName = props.wrapClassName,
      compact = props.compact,
      placeholder = props.placeholder,
      container = props.container,
      label = props.label,
      preIcon = props.preIcon,
      postIcon = props.postIcon,
      suffix = props.suffix,
      prefix = props.prefix,
      hasWarning = props.hasWarning,
      help = props.help,
      required = props.required,
      disabled = props.disabled,
      readOnly = props.readOnly,
      minimal = props.minimal,
      noInput = props.noInput,
      zIndexMessage = props.zIndexMessage,
      onClear = props.onClear,
      rows = props.rows,
      cols = props.cols,
      onKeyUp = props.onKeyUp,
      maxLength = props.maxLength;

  var _inputHandler = inputHandler(props, 'CoolTextArea', '', function (e) {
    return [e.target.value, e.target.id];
  }),
      id = _inputHandler.id,
      value = _inputHandler.value,
      focus = _inputHandler.focus,
      hasError = _inputHandler.hasError,
      onBlur = _inputHandler.onBlur,
      onChange = _inputHandler.onChange,
      onFocus = _inputHandler.onFocus;

  if (!visible) return null; // input container

  var containerClassName = wrapClassName;

  if (wrapClassName === null || wrapClassName === undefined) {
    containerClassName = "";
  }

  if (wrapClassName !== "none") {
    containerClassName += " cool-text-input";
  }

  var inputClassName = className;

  if (focus) {
    inputClassName += " ci-focus";
  }

  if (hasError) {
    inputClassName += " has-error";
  }

  var inputProps = {
    type: "text",
    id: id,
    className: inputClassName,
    onBlur: onBlur,
    onFocus: onFocus,
    onKeyUp: onKeyUp,
    value: value,
    onChange: onChange,
    disabled: disabled,
    readOnly: readOnly,
    rows: rows,
    cols: cols,
    maxLength: maxLength,
    placeholder: placeholder,
    size: size
  };
  /** @type {_ContainerProps} */

  var containerProps = {
    id: id,
    preIcon: preIcon,
    postIcon: postIcon,
    suffix: suffix,
    prefix: prefix,
    label: label,
    required: required,
    minimal: minimal,
    className: containerClassName,
    disabled: disabled,
    readOnly: readOnly,
    help: help,
    hasError: hasError,
    hasWarning: hasWarning,
    zIndexMessage: zIndexMessage,
    focus: focus,
    onClear: onClear,
    noInput: noInput
  };
  var Container = container || CoolContainer;

  if (compact) {
    Container = MaterialContainer;
  }

  return /*#__PURE__*/React__default['default'].createElement(Container, _extends({}, containerProps, {
    className: "arm-gui-textArea"
  }), /*#__PURE__*/React__default['default'].createElement("textarea", inputProps));
}
CoolTextArea.defaultProps = _objectSpread2(_objectSpread2(_objectSpread2({}, ContainerProps.defaultProps), InputProps.defaultProps), {}, {
  //shared props not used
  focus: undefined,
  size: undefined,
  children: undefined,
  //text prop
  rows: null,
  cols: null,
  onKeyUp: null,
  value: ''
});
CoolTextArea.propTypes = _objectSpread2(_objectSpread2(_objectSpread2({}, ContainerProps.propTypes), InputProps.propTypes), {}, {
  //shared props not used
  focus: p__default['default'].any,
  size: p__default['default'].any,
  children: p__default['default'].any,
  //text prop
  rows: p__default['default'].number,
  cols: p__default['default'].number,
  maxLength: p__default['default'].number,
  onKeyUp: p__default['default'].func,
  value: p__default['default'].string
});

function CoolTextInput(props) {
  var visible = props.visible,
      size = props.size,
      className = props.className,
      autoComplete = props.autoComplete,
      wrapClassName = props.wrapClassName,
      compact = props.compact,
      placeholder = props.placeholder,
      container = props.container,
      label = props.label,
      preIcon = props.preIcon,
      postIcon = props.postIcon,
      suffix = props.suffix,
      prefix = props.prefix,
      hasWarning = props.hasWarning,
      help = props.help,
      required = props.required,
      disabled = props.disabled,
      readOnly = props.readOnly,
      minimal = props.minimal,
      noInput = props.noInput,
      zIndexMessage = props.zIndexMessage,
      onClear = props.onClear,
      type = props.type,
      onKeyUp = props.onKeyUp;

  var _inputHandler = inputHandler(props, 'CoolTextInput', '', function (e) {
    return [e.target.value, e.target.id];
  }),
      id = _inputHandler.id,
      value = _inputHandler.value,
      focus = _inputHandler.focus,
      hasError = _inputHandler.hasError,
      onBlur = _inputHandler.onBlur,
      onChange = _inputHandler.onChange,
      onFocus = _inputHandler.onFocus;

  if (!visible) return null;
  var containerClassName = wrapClassName;

  if (wrapClassName === null || wrapClassName === undefined) {
    containerClassName = "";
  }

  if (wrapClassName !== "none") {
    containerClassName += " cool-text-input";
  }

  var inputProps = {
    type: type ? type : "text",
    id: id,
    className: className,
    placeholder: placeholder,
    value: value,
    disabled: disabled,
    onKeyUp: onKeyUp,
    onChange: onChange,
    readOnly: readOnly,
    autoComplete: autoComplete,
    onBlur: onBlur,
    onFocus: onFocus,
    size: size
  };
  /** @type {_ContainerProps} */

  var containerProps = {
    id: id,
    preIcon: preIcon,
    postIcon: postIcon,
    suffix: suffix,
    prefix: prefix,
    label: label,
    required: required,
    minimal: minimal,
    className: containerClassName,
    disabled: disabled,
    readOnly: readOnly,
    help: help,
    hasError: hasError,
    hasWarning: hasWarning,
    zIndexMessage: zIndexMessage,
    focus: focus,
    onClear: onClear,
    noInput: noInput
  };
  var Container = container || CoolContainer;

  if (compact) {
    Container = MaterialContainer;
  }

  return /*#__PURE__*/React__default['default'].createElement(Container, containerProps, /*#__PURE__*/React__default['default'].createElement("input", inputProps));
}
CoolTextInput.defaultProps = _objectSpread2(_objectSpread2(_objectSpread2({}, ContainerProps.defaultProps), InputProps.defaultProps), {}, {
  //shared props not used
  focus: undefined,
  children: undefined,
  //text prop
  type: 'text',
  onKeyUp: null,
  value: ''
});
CoolTextInput.propTypes = _objectSpread2(_objectSpread2(_objectSpread2({}, ContainerProps.propTypes), InputProps.propTypes), {}, {
  //shared props not used
  focus: p__default['default'].any,
  children: p__default['default'].any,
  //text prop
  type: p__default['default'].string,
  onKeyUp: p__default['default'].func,
  value: p__default['default'].string
});

/**
 * Inserisce ogni figlio in un div sotto il componente LineBar.
 * 
 * @param {*} props contenitore delle successive properties
 * @param {boolean} right se true, posiziona gli elementi sulla destra, false, li posiziona alla sinistra
 * @param {string} margin valore css dell'attributo marginRight (caso right = false) o marginLeft (caso right = true)
 * @param {Array} children React children
 */

var LineBarGroup = function LineBarGroup(props) {
  var _useState = React.useState({
    id: armCommon.Utils.uuid('line-item-')
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1]; // constructor(props) {
  //     super(props);
  //     this.consoleLog = (text) => console.log('[LineBar]: ' + text);
  //     this.state = { id: Utils.uuid('line-item-') };
  // }
  // consoleLog("render");


  var vertical = props.vertical,
      right = props.right,
      margin = props.margin;
  var children = props.children;
  var id = state.id;
  var childrenLength = React__default['default'].Children.count(children);

  if (childrenLength === 1) {
    children = [children];
  }

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, children.map(function (child, index) {
    if (!child) return null;
    if (child.props && child.props.visible !== undefined && !child.props.visible) return null;
    var style = null;
    var marginAttr = vertical ? "marginBottom" : "marginRight";

    if (!right) {
      /** Rendering elements WITHOUT 'right' prop (starts from left side) **/
      style = _defineProperty({}, marginAttr, margin || '1rem'); //common style of elements on left side
      //the last element will not have margin

      if (index === childrenLength - 1) style = {};
      return /*#__PURE__*/React__default['default'].createElement("div", {
        key: "".concat(id, "-").concat(index),
        className: "line-item-left-".concat(index),
        style: style
      }, child);
    }

    marginAttr = vertical ? "marginTop" : "marginLeft";
    /** Rendering elements with 'right' prop **/

    style = _defineProperty({}, marginAttr, margin || '1rem'); //common style of children
    //the first element needs to have marginLeft set to auto to align all futher contents on right

    if (index === 0) style[marginAttr] = 'auto';
    return /*#__PURE__*/React__default['default'].createElement("div", {
      key: "".concat(id, "-").concat(index),
      className: "line-item-right-".concat(index),
      style: style
    }, child);
  }));
};
/**
 * Crea una flex box che dispone gli elementi in linea o in colonna, in base ai parametri passati.
 * 
 * @param {*} props oggetto contenitore dei sottostanti parametri
 * @param {boolean} visible se true o undefined, visualizza il componente, se false, non viene visualizzato
 * @param {string} height altezza del contenitore (se vertical = true default: "100vh")
 * @param {string} width larghezza del contenitore (se vertical = false default: "100%")
 * @param {boolean} vertical se true, dispone la barra in colonna
 * @param {boolean} noWrap se true, gli elementi flex non vanno a capo, se false, una volta raggiunta la larghezza massima, gli elementi si dispongono nella riga successiva
 * @param {string} id id del contenitore
 * @param {string} className selettore del contenitore
 * @param {Array} children react children
 */


var LineBar = function LineBar(props) {
  // constructor(props) {
  //     super(props);
  //     this.consoleLog = (text) => console.log('[LineBar]: ' + text);
  //     this.state = { id: this.props.id || Utils.uuid('line-bar-') };
  // }
  var _useState3 = React.useState({
    id: props.id || armCommon.Utils.uuid('line-bar-')
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      state = _useState4[0],
      setState = _useState4[1]; // consoleLog("render");


  var visible = props.visible,
      height = props.height,
      width = props.width,
      alignItems = props.alignItems,
      vertical = props.vertical,
      noWrap = props.noWrap,
      className = props.className,
      children = props.children;
  var id = state.id;
  if (visible !== undefined && !visible) return null;
  var barStyle = {
    display: 'flex',
    alignItems: alignItems || 'flex-end',
    height: height || '100vh',
    width: width || '100%',
    flexWrap: noWrap ? 'nowrap' : 'wrap'
  };

  if (vertical) {
    //if vertical all the line should be show like a column
    barStyle.flexDirection = 'column';
    if (!width) delete barStyle.width; //the default value should be remove only if width is not setted
  } else {
    //display as row
    barStyle.flexDirection = 'row';
    if (!height) delete barStyle.height; //the default value should be remove only if height is not setted
  }

  var ochildren = children;

  if (React__default['default'].Children.count(children) === 2) {
    //if the children are 2 (the component have LineBarGroup and LineBarGroup right={true})
    ochildren = _toConsumableArray(children);
    ochildren.sort(function (a, b) {
      return a.props && b.props && !a.props.right ? -1 : 1;
    }); //if the elem of child haven't the prop right, it will positioned as a first element
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: id,
    style: barStyle,
    className: className ? 'line-bar ' + className : 'line-bar'
  }, ochildren);
};

/**
 * @typedef {object} PopupContestualeProps PopupContestuale properties
 *
 * @prop {boolean} show shows the popup
 * @prop {string} [idFor] identifier of the element to which the popup is associated
 * @prop {string} [className] selector of main container
 * @prop {string} [classNameBody] selector of body
 * @prop {() => void} [onClose] allows to close the Popup
 * @prop {number} [maxTopSpace] allows to show the popup on top side declaring a number of pixel which the content occupies
 * @prop {number} [maxBottomSpace] allows to show the popup on bottom side declaring a number of pixel which the content occupies
 * @prop {number} [maxRightSpace] allows to show the popup on right side declaring a number of pixel which the content occupies
 * @prop {number} [maxLeftSpace] allows to show the popup on left side declaring a number of pixel which the content occupies
 * @prop {boolean} [centered] allows to show the popup on the center of element connected. `maxRightSpace` or `maxLeftSpace` needs to be populated with popup size.
 * @prop {boolean} [widthAsParent] set the width of parent to the popup
 * @prop {Node} [children] popup content
 */

/**
 * @callback _PopupContestuale component that shows a PopupDialog referring to an element.
 * The component works in two different ways:
 * 1) passing the prop `idFor`, where id is the identifier of the rendered element to which the popup is associated:
 * ```jsx
 * <div id='container-1'/>
 * ...
 * <PopupContestuale idFor='container-1'>
 *  I'm the content of 'container-1' 
 * </PopupContestuale>
 * ```
 * 2) declaring the component after another one:
 * ```jsx
 * <button/>
 * <PopupContestuale>
 *  I'm the content of {'<button/>'}
 * </PopupContestuale>
 * ```
 * 
 * @param {PopupContestualeProps} props
 * @returns {JSX.Element}
 */
exports.typedefs = {};

var classNamePrefix$d = 'arm-gui-popup-contestuale';
/** @type {_PopupContestuale} */

function PopupContestuale(props) {
  var show = props.show,
      className = props.className,
      classNameBody = props.classNameBody,
      centered = props.centered,
      maxTopSpace = props.maxTopSpace,
      maxBottomSpace = props.maxBottomSpace,
      maxRightSpace = props.maxRightSpace,
      maxLeftSpace = props.maxLeftSpace,
      idFor = props.idFor,
      onClose = props.onClose,
      widthAsParent = props.widthAsParent,
      children = props.children;

  var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      coord = _useState2[0],
      setCoord = _useState2[1];

  var _useState3 = React.useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      prevElement = _useState4[0],
      setPrevElement = _useState4[1];

  var nextRef = React.useRef();

  function calcCoord(e) {
    var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prevElement;

    if (element) {
      //the client rectangle top, left, bottom, right values starts all from top-left corner of window
      // here -> +--- --- ---+
      //         |  window   |
      //         |           |
      //         |           |
      //         +--- --- ---+
      // see https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
      var _element$getBoundingC = element.getBoundingClientRect(),
          top = _element$getBoundingC.top,
          left = _element$getBoundingC.left,
          bottom = _element$getBoundingC.bottom,
          right = _element$getBoundingC.right;

      var coordinates = {
        transform: 'unset'
      };
      if (widthAsParent) coordinates.width = element.offsetWidth;
      var bottomSpace = maxTopSpace !== null && maxTopSpace !== void 0 ? maxTopSpace : window.innerHeight - bottom;
      var topSpace = maxBottomSpace !== null && maxBottomSpace !== void 0 ? maxBottomSpace : top;

      if (bottomSpace > topSpace) {
        coordinates.top = bottom;
        coordinates.bottom = 'auto';
        coordinates.maxHeight = bottomSpace; //|     _X      |   
        //|     |       |
        //|    max      |
        //|     |       |
        //+-------------+
      } else {
        coordinates.top = 'auto';
        coordinates.bottom = window.innerHeight - top;
        coordinates.maxHeight = topSpace; //+-------------+
        //|     |       |
        //|    max      |
        //|     _       |
        //|      X      |   
      }

      var leftSpace = maxRightSpace !== null && maxRightSpace !== void 0 ? maxRightSpace : left;
      var rightSpace = maxLeftSpace !== null && maxLeftSpace !== void 0 ? maxLeftSpace : window.innerWidth - right;
      if (centered && !(maxRightSpace || maxLeftSpace)) console.warn('[PopupContestuale]: popup cannot be centered without content size. You must valorize `maxRightSpace` or `maxLeftSpace` with it.');

      if (centered && (maxRightSpace || maxLeftSpace)) {
        coordinates.maxWidth = window.innerWidth;
        var originPosition = left + (right - left) / 2;
        var contentSpace = maxRightSpace !== null && maxRightSpace !== void 0 ? maxRightSpace : maxLeftSpace;

        if (contentSpace / 2 <= originPosition && originPosition + contentSpace / 2 <= window.innerWidth) {
          coordinates.right = 'auto';
          coordinates.transform = 'translate(-50%, 0)';
          coordinates.left = originPosition;
        } else {
          coordinates.left = 'auto';
          coordinates.right = 'auto';
        }

        if (originPosition + contentSpace / 2 > window.innerWidth) {
          coordinates.right = 0;
        }

        if (contentSpace / 2 > originPosition) {
          coordinates.left = 0;
        }
      } else if (rightSpace < leftSpace) {
        //container ends at element's right
        coordinates.right = rightSpace;
        coordinates.left = 'auto';
        coordinates.maxWidth = right; //takes as max-width the client-rect-element's right
        //|      X      |   
        //|<-max->|     |
        //+-------------+
      } else {
        coordinates.right = 'auto';
        coordinates.left = leftSpace;
        coordinates.maxWidth = window.innerWidth - left; //takes as max-width the viewport width minus client-rect-element's left
        //|      X      |   
        //|     |<-max->|
        //+-------------+
      }

      setCoord(coordinates);
    }
  }

  React.useEffect(function () {
    if (show && (idFor || nextRef.current || prevElement)) {
      var element = prevElement;

      if (!element) {
        var _nextRef$current;

        if (idFor) {
          element = document.getElementById(idFor);
        } else if ((_nextRef$current = nextRef.current) !== null && _nextRef$current !== void 0 && _nextRef$current.previousElementSibling) {
          element = nextRef.current.previousElementSibling;
        }

        setPrevElement(element);
      }

      calcCoord(null, element);
    }

    if (!show) setCoord(null);
    return function () {
      return setPrevElement(null);
    };
  }, [show, nextRef]);
  React.useEffect(function () {
    if (prevElement) window.addEventListener('resize', calcCoord);
    return function () {
      return !!prevElement && window.removeEventListener('resize', calcCoord);
    };
  }, [prevElement]);
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, show && !coord && /*#__PURE__*/React__default['default'].createElement("div", {
    ref: nextRef
  }), /*#__PURE__*/React__default['default'].createElement(PopupDialog, {
    show: !!coord && show,
    className: "".concat(classNamePrefix$d, " ").concat(className).trim(),
    addBackDrop: "transparent",
    onClose: onClose,
    style: coord
  }, /*#__PURE__*/React__default['default'].createElement(PopupDialog.Body, {
    className: "".concat(classNamePrefix$d, "-body ").concat(classNameBody).trimEnd()
  }, children)));
}
PopupContestuale.defaultProps = {
  show: false,
  className: '',
  classNameBody: '',
  centered: false,
  maxTopSpace: null,
  maxBottomSpace: null,
  maxRightSpace: null,
  maxLeftSpace: null,
  idFor: '',
  onClose: function onClose() {},
  widthAsParent: false,
  children: null
};
PopupContestuale.propTypes = {
  show: p__default['default'].bool.isRequired,
  idFor: p__default['default'].string,
  className: p__default['default'].string,
  classNameBody: p__default['default'].string,
  onClose: p__default['default'].func,
  maxTopSpace: p__default['default'].number,
  maxBottomSpace: p__default['default'].number,
  maxRightSpace: p__default['default'].number,
  maxLeftSpace: p__default['default'].number,
  centered: p__default['default'].bool,
  widthAsParent: p__default['default'].bool,
  children: p__default['default'].node
};

/**
 * @typedef {object} PopupMenuProps PopupMenu properties
 *
 * @prop {string} [id] component id
 * @prop {string} [className] component selector
 * @prop {string} [label] label of popup button
 * @prop {string} [popupIcon] icon string selector
 * @prop {aButtonStyle} [buttonsType] change all the type of buttons
 * @prop {(PopupMenuItemProp|PopupMenuPrimaryProp|PopupMenuItemProp[]|PopupMenuPrimaryProp[])} [primaryMenu] list or single button associate to popup menu button
 * @prop {PopupMenuItemProp[]} items items of menu
 */

/**
 * @callback _PopupMenu component that shows a popup menu referring to a group or single button
 * @param {PopupMenuProps} props
 * @returns {JSX.Element}
 */

/**
 * @typedef {object} PopupMenuItemProp menu item properties
 * @prop {string} [link] href path
 * @prop {() => void} [onClick] click event
 * @prop {boolean} [disabled]
 * @prop {(string|AskConfirmOptions)} [askConfirm] activates AskConfirm popup and execute the events when click confirm
 * @prop {string} [className] selector name
 * @prop {string} [title] element title
 * @prop {string} [icon] icon string selector
 * @prop {string} [label] label of element
 */

/**
 * @typedef {object} PopupMenuPrimaryProp menu primary properties
 * @prop {aButtonStyle} [bs] button style
 */

exports.typedefs = {};

var _excluded$2 = ["link", "onClick", "disabled", "askConfirm"];
var idCounter = 0;
var classNamePrefix$e = 'arm-gui-popup-menu';
var initialAskConfirmProps = {
  show: false,
  onConfirm: function onConfirm() {
    return null;
  },
  onCancel: function onCancel() {
    return null;
  }
};

function PopupMenuItem(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      title = _ref.title,
      icon = _ref.icon,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label;
  return /*#__PURE__*/React__default['default'].createElement("span", {
    className: "".concat(classNamePrefix$e, "-item").concat(disabled ? " ".concat(classNamePrefix$e, "-item-disabled ") : ' ').concat(className).trimEnd(),
    onClick: onClick,
    title: title
  }, icon && /*#__PURE__*/React__default['default'].createElement("i", {
    className: "".concat(classNamePrefix$e, "-item-icon").concat(label || '-only', " ").concat(icon)
  }), icon && label && /*#__PURE__*/React__default['default'].createElement("span", {
    className: "".concat(classNamePrefix$e, "-item-divisor")
  }), label);
}

function PopupMenuButton(_ref2) {
  var className = _ref2.className,
      bs = _ref2.bs,
      onClick = _ref2.onClick,
      disabled = _ref2.disabled,
      title = _ref2.title,
      icon = _ref2.icon,
      label = _ref2.label;
  return /*#__PURE__*/React__default['default'].createElement(aButton, {
    className: "".concat(classNamePrefix$e, "-primary ").concat(className).trimEnd(),
    onClick: onClick,
    bs: bs,
    disabled: disabled,
    title: title,
    icon: icon,
    children: label
  });
}
/** @type {_PopupMenu} */


function PopupMenu(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$popupIcon = props.popupIcon,
      popupIcon = _props$popupIcon === void 0 ? "fas fa-ellipsis-v" : _props$popupIcon,
      _props$buttonsType = props.buttonsType,
      buttonsType = _props$buttonsType === void 0 ? 'default' : _props$buttonsType,
      id = props.id,
      primaryMenu = props.primaryMenu,
      def = props.def,
      items = props.items,
      label = props.label;
  var primaryMenuItems = Array.isArray(primaryMenu) ? primaryMenu : [primaryMenu];
  var menuItems = def || items || [];

  var _useState = React.useState(id || "".concat(classNamePrefix$e, "-").concat(idCounter++)),
      _useState2 = _slicedToArray(_useState, 1),
      idComp = _useState2[0];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      show = _useState4[0],
      setShow = _useState4[1];

  var _useState5 = React.useState(initialAskConfirmProps),
      _useState6 = _slicedToArray(_useState5, 2),
      askConfirmProps = _useState6[0],
      setAskConfirmProps = _useState6[1];

  function renderItems(items, Comp) {
    return items.map(function (item, index) {
      if (!item) return null;

      var link = item.link,
          onClick = item.onClick,
          disabled = item.disabled,
          askConfirm = item.askConfirm,
          itemProps = _objectWithoutProperties(item, _excluded$2);

      var defaultClick = function defaultClick() {
        if (onClick) onClick();
        if (link) document.location.href = link;
        if (show) setShow(false);
      };

      var onClickEvent = defaultClick;

      if (askConfirm) {
        var acProps = {
          show: true,
          options: askConfirm,
          onCancel: function onCancel() {
            setAskConfirmProps(initialAskConfirmProps);
          },
          onConfirm: function onConfirm() {
            defaultClick();
            setAskConfirmProps(initialAskConfirmProps);
          }
        };

        onClickEvent = function onClickEvent() {
          return setAskConfirmProps(acProps);
        };
      }

      if (disabled) onClickEvent = null;
      return /*#__PURE__*/React__default['default'].createElement(Comp, _extends({
        key: "".concat(idComp, "-").concat(Comp.name, "-").concat(index),
        onClick: onClickEvent,
        disabled: disabled,
        bs: buttonsType
      }, itemProps));
    });
  }

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    id: idComp,
    className: "".concat(classNamePrefix$e, " ").concat(className).trimEnd()
  }, renderItems(primaryMenuItems, PopupMenuButton), /*#__PURE__*/React__default['default'].createElement(aButton, {
    className: "".concat(classNamePrefix$e, "-primary"),
    onClick: function onClick() {
      return setShow(true);
    },
    bs: buttonsType,
    icon: popupIcon,
    children: label
  }), /*#__PURE__*/React__default['default'].createElement(PopupContestuale, {
    show: show,
    onClose: function onClose() {
      return setShow(false);
    },
    className: "".concat(classNamePrefix$e, "-drop"),
    classNameBody: "".concat(classNamePrefix$e, "-drop-body")
  }, renderItems(menuItems, PopupMenuItem))), /*#__PURE__*/React__default['default'].createElement(AskConfirm, askConfirmProps));
}
var itemShape = {
  link: p.string,
  onClick: p.func,
  disabled: p.bool,
  askConfirm: optionsType,
  className: p.string,
  title: p.string,
  icon: p.string,
  label: p.string
};

var primaryShape = _objectSpread2(_objectSpread2({}, itemShape), {}, {
  bs: bsType
});

PopupMenu.propTypes = {
  id: p.string,
  className: p.string,
  popupIcon: p.string,
  label: p.string,
  buttonsType: p.string,
  primaryMenu: p.oneOfType([p.shape(primaryShape), p.arrayOf(p.shape(primaryShape))]),
  items: p.arrayOf(p.shape(itemShape)).isRequired,

  /** @deprecated use `items` prop */
  def: p.arrayOf(p.shape(itemShape))
};

function PopupResponsive(props) {
  var show = props.show,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      marginTop = props.marginTop,
      marginRight = props.marginRight,
      marginBottom = props.marginBottom,
      marginLeft = props.marginLeft,
      width = props.width,
      children = props.children;
  if (!show) return null;
  console.log('[PopupResponsive] render');
  var modalStyle = {};
  if (marginTop) modalStyle["marginTop"] = marginTop;
  if (marginRight) modalStyle["marginRight"] = marginRight;
  if (marginBottom) modalStyle["marginBottom"] = marginBottom;
  if (marginLeft) modalStyle["marginLeft"] = marginLeft;

  if (width) {
    var w = width.startsWith("min") || width.startsWith("max") || width.startsWith("clamp") ? width : "clamp(".concat(width, ", 80%, 98vw)");
    modalStyle["width"] = w;
  }

  return /*#__PURE__*/React__default['default'].createElement(ModalContainer, null, /*#__PURE__*/React__default['default'].createElement(ModalBackDrop, null), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "modal",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "responsive-modal-dialog ".concat(className).trimEnd(),
    style: modalStyle
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "modal-content"
  }, children))));
}
PopupResponsive.propTypes = {
  show: p.bool.isRequired,
  className: p.string,
  marginTop: p.oneOfType([p.string, p.number]),
  marginRight: p.oneOfType([p.string, p.number]),
  marginBottom: p.oneOfType([p.string, p.number]),
  marginLeft: p.oneOfType([p.string, p.number]),
  width: p.oneOfType([p.string, p.number]),
  children: p.node
};

function Header(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      onClose = _ref.onClose,
      children = _ref.children;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "w-100 ".concat(className).trimEnd()
  }, children), onClose && /*#__PURE__*/React__default['default'].createElement("button", {
    type: "button",
    className: "close",
    onClick: onClose
  }, /*#__PURE__*/React__default['default'].createElement("span", null, "\xD7")));
}

Header.propTypes = {
  className: p.string,
  onClose: p.func,
  children: p.node
};

function Body(_ref2) {
  var _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      maxHeight = _ref2.maxHeight,
      _ref2$overflow = _ref2.overflow,
      overflow = _ref2$overflow === void 0 ? false : _ref2$overflow,
      children = _ref2.children;
  var style = {};
  if (maxHeight) style["maxHeight"] = maxHeight;
  if (overflow !== false) style.overflow = "auto";
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "modal-body mt-3 ".concat(className).trimEnd(),
    style: style
  }, children);
}

Body.propTypes = {
  className: p.string,
  maxHeight: p.oneOfType([p.string, p.number]),
  overflow: p.bool,
  children: p.node
};

function Footer(_ref3) {
  var _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className,
      children = _ref3.children;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "modal-footer ".concat(className).trimEnd()
  }, children);
}

Footer.propTypes = {
  className: p.string,
  children: p.node
};
PopupResponsive.Header = Header;
PopupResponsive.Body = Body;
PopupResponsive.Footer = Footer;

/**
 * @augments {Component<{width: string, height: string, animateBar: boolean}, State>}
 */

var ProgressBar = function ProgressBar(props) {
  // constructor(props) {
  //     super(props);
  //     state = {
  //     }
  // }
  var progresBarStyle = {};

  if (props.height) {
    progresBarStyle["height"] = props.height;
  }

  if (props.width) {
    progresBarStyle["width"] = props.width + "%";
  }

  var animateBar = props.animateBar;
  var showPercentage = props.showPercentage;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress-container" + (props.className ? " " + props.className : "")
  }, /*#__PURE__*/React.createElement("span", {
    className: animateBar ? " animate " : " progressBar ",
    role: "progressbar",
    style: progresBarStyle
  }, showPercentage ? props.width + "%" : "")));
};

function TabBarItem(_ref) {
  var children = _ref.children;
  console.log('[TabBarItem]: render');
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, " ", children, " ");
}

TabBarItem.propTypes = {
  /** Required to show in Bar */
  label: p.string.isRequired,

  /** Show the item in Bar */
  visible: p.bool,

  /** Disable the item in Bar */
  disabled: p.bool,

  /** Select the item via properties */
  selected: p.bool,

  /** Event when click item Bar */
  onClick: p.func,
  children: p.node
};

var idCounter$1 = 0;
var classNameComponent = 'arm-gui-tab-bar';

var Bar = function Bar(_ref) {
  var right = _ref.right,
      items = _ref.items,
      selItem = _ref.selItem,
      selectItem = _ref.selectItem;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNameComponent, "-items").concat(right ? '-right' : '')
  }, Object.values(items).map(function (item) {
    var selected = item.id === selItem.id ? "".concat(classNameComponent, "-item-selected") : '';
    var disabled = item.disabled ? "".concat(classNameComponent, "-item-disabled") : '';
    return /*#__PURE__*/React__default['default'].createElement("div", {
      key: item.id,
      onClick: function onClick() {
        if (!disabled && !selected) {
          selectItem(item.id);
          if (item.onClick) item.onClick(item);
        }
      },
      className: "".concat(classNameComponent, "-item ").concat(selected, " ").concat(disabled).trimEnd()
    }, item.label);
  }));
};
/**
 * Creates a bar with as many voices as there are `TabBar.Item`s.
 * It shows only the tab that is selected.
 * 
 * @example
 * 
 * ```jsx
 * const id = 'tab-bar-id',
 *       className = 'up',
 *       selected = false,
 *       onClick = (item) => console.log('Selected item: ', item);
 * <TabBar id={id} className={className}>
 *     <TabBar.Item
 *          label={i18n('TAB_BAR.ITEM_LABEL', 'Item')}
 *          disabled={false}
 *          selected={selected}
 *          onClick={onClick}
 *      >
 *         {'content to show'
 *          || null } //if you don't want show content
 *     </TabBar.Item>
 *     ...
 * </TabBar>
 * ```
 */


function TabBar(props) {
  console.log('[TabBar]: render');
  var id = props.id,
      className = props.className,
      right = props.right,
      children = props.children;

  var _useState = React.useState(id || "".concat(classNameComponent, "-").concat(idCounter$1++)),
      _useState2 = _slicedToArray(_useState, 2),
      idComp = _useState2[0],
      setIdComp = _useState2[1];

  var _useState3 = React.useState({
    component: null
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      selItem = _useState4[0],
      setSelItem = _useState4[1];

  var _useState5 = React.useState({
    _initial: {
      label: 'Initial'
    }
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      items = _useState6[0],
      setItems = _useState6[1];

  var prepareItems = function prepareItems() {
    var preparedItems = {};
    var selectChanges = false;
    var childChanges = false;
    React__default['default'].Children.forEach(children, function (child, index) {
      var _child$props, _child$props2, _child$props3, _child$props4, _items$key, _items$key2;

      if (!child || !child.type || child.type.toString() !== TabBarItem.toString()) return;
      var _child$props$visible = child.props.visible,
          visible = _child$props$visible === void 0 ? true : _child$props$visible;
      if (!visible) return;
      var key = "".concat(index, "-").concat(idComp);
      var label = ((_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.label) || 'no label';
      var disabled = !!((_child$props2 = child.props) !== null && _child$props2 !== void 0 && _child$props2.disabled);
      var onClick = (_child$props3 = child.props) === null || _child$props3 === void 0 ? void 0 : _child$props3.onClick;
      var selected = (_child$props4 = child.props) === null || _child$props4 === void 0 ? void 0 : _child$props4.selected;
      if (((_items$key = items[key]) === null || _items$key === void 0 ? void 0 : _items$key.selected) !== selected) selectChanges = true;
      if (((_items$key2 = items[key]) === null || _items$key2 === void 0 ? void 0 : _items$key2.component) !== child) childChanges = true;
      preparedItems[key] = {
        id: key,
        label: label,
        selected: selected,
        disabled: disabled,
        onClick: onClick,
        component: child
      };
    });
    return {
      preparedItems: preparedItems,
      selectChanges: selectChanges,
      childChanges: childChanges
    };
  };

  React.useEffect(function () {
    if (id && idComp !== id) setIdComp(id);

    var _prepareItems = prepareItems(),
        preparedItems = _prepareItems.preparedItems,
        selectChanges = _prepareItems.selectChanges,
        childChanges = _prepareItems.childChanges;

    setItems(preparedItems);

    if (selItem.id && !preparedItems[selItem.id] || //Child selected is no more present
    selItem.id && preparedItems[selItem.id].disabled || //Child changes disabled prop
    selectChanges || //Child changes selected prop
    selItem.component === null) {
      var arritems = Object.values(preparedItems);
      setSelItem(arritems.find(function (i) {
        return i.selected && !i.disabled;
      }) || {
        component: null
      });
    } else if (childChanges) {
      //when selected Child has some changes in TabBar scope (see #11205)
      setSelItem(preparedItems[selItem.id]);
    }
  }, [children, id]);

  var selectItem = function selectItem(key) {
    return setSelItem(items[key]);
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: idComp,
    className: "".concat(classNameComponent, " ").concat(className || '').trimEnd()
  }, /*#__PURE__*/React__default['default'].createElement(Bar, {
    right: right,
    items: items,
    selItem: selItem,
    selectItem: selectItem
  }), selItem.component);
}

function childrenPropType(propValue, propName, componentName) {
  if (!propValue) return new Error("[".concat(componentName, "]: must have children"));
  var index = 0;
  var error = false;
  if (!Array.isArray(propValue) && (!propValue.type || propValue.type.toString() !== TabBarItem.toString())) error = true;else {
    index = propValue.findIndex(function (child) {
      return !child.type || child.type.toString() !== TabBarItem.toString();
    });
    if (index !== -1) error = true;
  }
  if (error) return new Error("[".concat(componentName, "]: incorrect component type in children prop at position [").concat(index, "]. The component must be instance of <").concat(componentName, ".Item/>. if you want to hide an item use 'visible' prop instead of returning null"));
}

TabBar.propTypes = {
  id: p.string,
  className: p.string,
  right: p.bool,
  children: p.arrayOf(childrenPropType)
};
/**
 * Support component for `TabBar`
 * 
 * @example
 * 
 * ```jsx
 * const id = 'tab-bar-id',
 *       className = 'up',
 *       selected = false,
 *       onClick = (item) => console.log('Selected item: ', item);
 * <TabBar id={id} className={className}>
 *     <TabBar.Item
 *          label={i18n('TAB_BAR.ITEM_LABEL', 'Item')}
 *          disabled={false}
 *          selected={selected}
 *          onClick={onClick}
 *      >
 *         { 'content to show' || 
 *              null // if you don't want show content
 *          } 
 *     </TabBar.Item>
 *     ...
 * </TabBar>
 * ```
 */

TabBar.Item = TabBarItem;

var agui = {
  version: pckg.version,
  aButton: aButton,
  aFieldset: aFieldset,
  NumberInput: NumberInput,
  aDateInput: aDateInput,
  aDiv: aDiv,
  aCard: aCard,
  aCardHeader: aCardHeader,
  aCardDetailsHeader: aCardDetailsHeader,
  aCardFilter: aCardFilter,
  aCardBody: aCardBody,
  aCardFooter: aCardFooter,
  aTextInput: aTextInput,
  CoolNumberInput: CoolNumberInput,
  CoolTextInput: CoolTextInput,
  CoolTextArea: CoolTextArea,
  CoolDateInput: CoolDateInput,
  CoolSelect: CoolSelect,
  CoolInputContainer: CoolInputContainer,
  CoolDateTimeInput: CoolDateTimeInput,
  DashCard: DashCard,
  PopupDialog: PopupDialog,
  PopupMenu: PopupMenu,
  PopupResponsive: PopupResponsive,
  aDataGrid: aDataGrid,
  aTable: aTable,
  aPaginator: aPaginator,
  aIcon: aIcon,
  aCardDetail: aCardDetail,
  AskConfirm: AskConfirm,
  ProgressBar: ProgressBar,
  InputRange: InputRange,
  aToggle: aToggle,
  aSwitch: aSwitch,
  CoolCheckBox: CoolCheckBox,
  CoolProgressBar: CoolProgressBar,
  Accordion: Accordion,
  AccordionFooter: AccordionFooter,
  AccordionHeader: AccordionHeader,
  AccordionBody: AccordionBody,
  CoolGroupSelector: CoolGroupSelector,
  LineBar: LineBar,
  LineBarGroup: LineBarGroup,
  Cellify: Cellify,
  TabBar: TabBar,
  PopupContestuale: PopupContestuale,
  ToolTip: ToolTip,
  ModalContainer: ModalContainer
};

exports.Accordion = Accordion;
exports.AccordionBody = AccordionBody;
exports.AccordionFooter = AccordionFooter;
exports.AccordionHeader = AccordionHeader;
exports.AskConfirm = AskConfirm;
exports.Cellify = Cellify;
exports.CoolCheckBox = CoolCheckBox;
exports.CoolDateInput = CoolDateInput;
exports.CoolDateTimeInput = CoolDateTimeInput;
exports.CoolGroupSelector = CoolGroupSelector;
exports.CoolInputContainer = CoolInputContainer;
exports.CoolNumberInput = CoolNumberInput;
exports.CoolProgressBar = CoolProgressBar;
exports.CoolSelect = CoolSelect;
exports.CoolTextArea = CoolTextArea;
exports.CoolTextInput = CoolTextInput;
exports.DashCard = DashCard;
exports.InputRange = InputRange;
exports.LineBar = LineBar;
exports.LineBarGroup = LineBarGroup;
exports.ModalContainer = ModalContainer;
exports.NumberInput = NumberInput;
exports.PopupContestuale = PopupContestuale;
exports.PopupDialog = PopupDialog;
exports.PopupMenu = PopupMenu;
exports.PopupResponsive = PopupResponsive;
exports.ProgressBar = ProgressBar;
exports.TabBar = TabBar;
exports.ToolTip = ToolTip;
exports.aButton = aButton;
exports.aCard = aCard;
exports.aCardBody = aCardBody;
exports.aCardDetail = aCardDetail;
exports.aCardDetailsHeader = aCardDetailsHeader;
exports.aCardFilter = aCardFilter;
exports.aCardFooter = aCardFooter;
exports.aCardHeader = aCardHeader;
exports.aDataGrid = aDataGrid;
exports.aDateInput = aDateInput;
exports.aDiv = aDiv;
exports.aFieldset = aFieldset;
exports.aIcon = aIcon;
exports.aPaginator = aPaginator;
exports.aSwitch = aSwitch;
exports.aTable = aTable;
exports.aTextInput = aTextInput;
exports.aToggle = aToggle;
exports.default = agui;
//# sourceMappingURL=index.js.map
